/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link, useNavigate, useParams} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import CustomUseEffect from '../component/CustomUseEffect'
import swal from 'sweetalert'
import {Spinner} from 'react-bootstrap'
import AddRemoveJadwal from './AddRemoveJadwal'
import {useTranslation} from 'react-i18next'
import {getAccesses, postChatOrder} from '../../../api/modules/order'
import {
  getPriceList,
  getScheduleOrder,
  getCommentOrder,
} from '../../../api/modules/order'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import {getStock} from '../../../api/modules/getdatalist'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {
  getAmandemen,
  createAmandemen,
  detailAmandemen,
  rejectAmandemen,
  approveAmandemen,
  orderDetailAmandemen,
  detailAmandemenCustomer,
  reviseAmandemen,
  resubmitAmandemen,
} from '../../../api/modules/amandemen'
import {useDispatch, useSelector} from 'react-redux'
import {setNotifOrder, setGetNotif, setItemNego} from '../../../_metronic/redux/content'
import i18next from 'i18next'
import Select from 'react-select'
import CurrencyInput from 'react-currency-input-field'
import {getCusGrup, getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {
  getProductName,
  getSalesArea,
  getEndUser,
  getSector,
  getIncoterm,
  getProvince3,
  getCity,
  getPlant,
  getPayment,
  getProductType,
  getAllPaymentList,
} from '../../../api/modules/getdatalist'
import InputGroup from 'react-bootstrap/InputGroup'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {MultiSelect} from 'react-multi-select-component'
import {PopoverText} from '../../../components/Popover/Popover'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import axios from 'axios'
import {PriceFormater} from '../../../components/mikro/PriceFormater'
import {authSelector} from 'src/redux/slices/authSlices'
import {useAppSelector} from 'src/redux/hooks'
import {HakAkses, UserSegment} from 'src/components/mikro/getHakAkses'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import dateformat from 'src/utils/dateformat'
import getCurrentFormattedDate from 'src/utils/Today'
import { SkeletonForm } from 'src/components/Skeletons'
import { SkeletonOrderDetail } from './SkeletonOrderDetail'
import { ShowStock } from './components/ShowStock'
import { fetchCheckStock } from 'src/services/fetcher'
import { InputFile } from 'src/app/components/InputFile'

const OrderAmandemen: React.FC = () => {
  const intl = useIntl()
  const {roleId} = useAppSelector(authSelector)

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)
  const [show3, setShow3] = useState(false)
  const [show8, setShow8] = useState(false)
  const params = useParams()
  const isCreating = params.type == 'create'

  const hakAkses = HakAkses()
  const [showStock, setShowStock] = useState(false)
  const [btnStock, setBtnStock] = useState(false)
  const [loadedStock, setLoadedStock] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleShow1 = async (paramm: any, id: any) => {
    ambilAttachment(paramm, id)
    setShowUpload(true)
  }
  const handleClose2 = () => setShow2(false)
  const handleShow2 = () => setShow2(true)
  const handleClose3 = () => setShow3(false)
  const handleShow3 = (id: any) => {
    sessionStorage.setItem('id', id)
    handleJadwal()
  }
  const handleClose8 = () => setShow8(false)
  const [allFile, setAllFiles] = useState<any[]>([])
  const [allFile2, setAllFiles2] = useState<any[]>([])
  const handleShow8 = (id: any, id2: any) => {
    const getJadwal = async () => {
      let res = await getScheduleOrder(id, 'false')
      let res2 = await getScheduleOrder(id2, 'true')
      let tempArray: any[] = []
      tempArray = tempArray.concat(res.data.data.schedules, res2.data.data.schedules)

      setTempJadwal2(tempArray)
      // .then((response) => {
      //   setAllJadwal(response.data.data)
      //   console.log(response.data.data)
      //   if (response.data.data[response.data.data.length - 1]?.sort != null)
      //     setTaking(response.data.data[response.data.data.length - 1]?.sort + 1)
      //   else setTaking(1)
      // })
      // .catch((error) => {
      //   swal({
      //     title: error.response.data,
      //     icon: 'error',
      //   })
      // })
    }
    getJadwal()
    setShow8(true)
  }

  const {t} = useTranslation()
  const [btnLoadingApp, setBtnLoadingApp] = useState(false)
  const [btnLoadingRej, setBtnLoadingRej] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const credential = localStorage.getItem('credential')
  const user = localStorage.getItem('role-flag')
  const [showRevisionNote, setShowRevisionNote] = useState(false)
  const [revisionNote, setRevisionNote] = useState('')
  const [showRejectNote, setShowRejectNote] = useState(false)
  const [rejectNote, setRejectNote] = useState('')
  const [tanggalPerpanjangan, setTanggalPerpanjangan] = useState<any>()
  const notif = useSelector((state: any) => state.notif.getNotif)

  const [detailOrder, setDetailOrder] = useState<any[]>([])
  const [detailOrder2, setDetailOrder2] = useState<any[]>([])

  const [roleUser, setRoleUser] = useState('')
  const [sektorID, setSektorID] = useState(0)

  const [status, setStatus] = useState(0)
  const [ID, setID] = useState(0)
  const [arrayEnduser, setEnduserArray] = useState([])
  const [allStock, setAllStock] = useState([])

  const dispath = useDispatch()

  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerTitle, setCustomerTitle] = useState('')
  const [orderNumber, setOrderNumber] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [PICCust, setPICCust] = useState('')
  const [emailCust, setEmailCust] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [param, setParam] = useState('')
  const [subOrderID, setSubOrderID] = useState(0)
  const [downloadOnly, setDownloadOnly] = useState(false)
  const [showUpload, setShowUpload] = useState(false)
  const [showUpload1, setShowUpload1] = useState(false)

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [retailFlag, setRetailFlag] = useState(false)

  //#region
  const [produsen, setProdusen] = useState('')
  const [enduser, setEnduser] = useState('')
  const [sektor, setSektor] = useState('')
  const [idSektor, setIDSector] = useState(0)
  const [incoterm1, setIncoterm1] = useState(0)
  const [incoterm2, setIncoterm2] = useState(0)
  const [province, setProvince] = useState(0)
  const [country, setCountry] = useState('')
  const [city, setCity] = useState(0)
  const [warehouse, setWarehouse] = useState('')
  const [warehouseDesc, setWarehouseDesc] = useState('')
  const [ptype, setPtype] = useState('')
  const [ptype2, setPtype2] = useState('')
  const [pname, setPname] = useState('')
  const [pnumber, setPnumber] = useState('')
  const [punit, setPunit] = useState('')
  const [pspec, setPspec] = useState('')
  const [subprice, setSubprice] = useState<any>(0)
  const [quantum, setQuantum] = useState<any>(0)
  const [note, setNote] = useState('')
  const [pay1, setPay1] = useState('')
  const [pay2, setPay2] = useState('')
  const [disctribution, setDistribution] = useState('')
  const [shipping, setShipping] = useState(0)
  const [subID, setSubID] = useState(0)
  const [subSektorID, setSubSektorID] = useState(0)
  const [segment, setSegment] = useState('')
  const [segmentDesc, setSegmentDesc] = useState('')
  const [produsenDesc, setProdusenDesc] = useState('')
  const [regarding, setRegarding] = useState('')
  const [enduserDesc, setEnduserDesc] = useState('')
  const [sektorDesc, setSektorDesc] = useState('')
  const [idSektorDesc, setIDSectorDesc] = useState('')
  const [incoterm1Desc, setIncoterm1Desc] = useState(0)
  const [incoterm2Desc, setIncoterm2Desc] = useState(0)
  const [provinceDesc, setProvinceDesc] = useState('')
  const [countryDesc, setCountryDesc] = useState('')
  const [cityDesc, setCityDesc] = useState('')
  const [pay1Desc, setPay1Desc] = useState('')
  const [pay2Desc, setPay2Desc] = useState('')
  const [keterangan, setketerangan] = useState('')
  const [allJadwal, setAllJadwal] = useState<any[]>([])
  const [plantcity, setPlantcity] = useState('')
  const [includePPN, setIncludePPN] = useState(false)
  const [language, setLanguage] = useState<any>()
  const [salesArea, setSalesArea] = useState<any[]>([])
  const [fullEndUser, setFullEndUser] = useState<any[]>([])
  const [fullSector, setFullSector] = useState<any[]>([])
  const [fullIncoterm, setFullIncoterm] = useState<any[]>([])
  const [fullIncoterm2, setFullIncoterm2] = useState<any[]>([])
  const [fullProvince, setFullProvince] = useState<any[]>([])
  const [fullCity, setFullCity] = useState([])
  const [fullPlant, setFullPlant] = useState([])
  const [fullPayment, setFullPayment] = useState([])
  const [fullProductType, setFullProductType] = useState([])
  const [fullProductName, setFullProductName] = useState([])
  const [tempData, setTempData] = useState<any>({})
  const [tempData2, setTempData2] = useState<any>({})
  const [fullSegment, setFullSegment] = useState<any[]>([])
  const [isFormulatedPrice, setIsFormulatedPrice] = useState(false)
  const [underAmandment, setUnderAmandment] = useState(false)
  const [tempDetail, setTempDetail] = useState<any>({})
  const [btnLoadingRef, setBtnLoadingRef] = useState(false)
  const [indexAmandement, setIndexAmandement] = useState(0)
  const [fullRole, setFullRole] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])
  const [isAmandemend, setIsAmandemend] = useState(false)
  const [showAmandemend, setShowAmandemend] = useState(false)
  const [showAmandemendApproval, setShowAmandemendApproval] = useState(false)
  const [numberRevisedItem, setNumberRevisedItem] = useState(0)
  const [minQuantum, setMinQuantum] = useState(0)
  const [itemIndex, setItemIndex] = useState<any[]>([])
  const [indexItem, setIndexItem] = useState<any[]>([])
  const [buttonFlag, setButtonFlag] = useState(false)
  const [buttonFlag2, setButtonFlag2] = useState(false)
  const [addedItems, setAddedItems] = useState<any[]>([])
  const [addedItems2, setAddedItems2] = useState<any[]>([])
  const [showAddProduct, setShowAddProduct] = useState(false)
  const [showDetailNewProduct, setShowDetailNewProduct] = useState(false)
  const [showEditNewProduct, setShowEditNewProduct] = useState(false)
  const [ischanged, setIsChanged] = useState(false)
  const [newProductFlag, setNewProductFlag] = useState(false)
  const [checkDetector, setCheckDetector] = useState<any[]>([])
  const [indexItem2, setIndexItem2] = useState<any>([])
  const [showJadwal, setShowJadwal] = useState(false)
  const [fullHeader, setFullHeader] = useState<any[]>([])
  const [showHeader, setShowHeader] = useState(false)
  const [stateFileHeader, setStateFileHeader] = useState<any[]>([])
  const [showComment, setShowComment] = useState(false)
  const [fullComment, setFullComment] = useState([])
  const [alasan, setAlasan] = useState('')
  const [colorList] = useState<any>({
    // Red: '#274070',
    Red: '#ff0000',
    Green: '#48CE86',
    Yellow: '#F0C94A',
    Black: '#000000',
  })
  const [showCustPro, setShowCustPro] = useState(false)
  const [totalInvoices, setTotalInvoices] = useState<any[]>([0, 0, 0, 0])
  const [custStatus, setCustStatus] = useState<any>({})
  const [invoices, setInvoices] = useState<any[]>([
    {
      B000: 0,
      C000: 0,
      D000: 0,
      E000: 0,
      F000: 0,
    },
    {
      B000: 0,
      C000: 0,
      D000: 0,
      E000: 0,
      F000: 0,
    },
    {
      B000: 0,
      C000: 0,
      D000: 0,
      E000: 0,
      F000: 0,
    },
    {
      B000: 0,
      C000: 0,
      D000: 0,
      E000: 0,
      F000: 0,
    },
  ])
  const [amandmentNote, setAmandmentNote] = useState<any>(null)
  const [extensionDate, setExtensionDate] = useState<any>(null)

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(async () => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(IDAttachments[0], IDAttachments[1])
          })
          .catch((error) => {
            swal({
              title: t(error.response.data),
              icon: 'error',
            })
          })
      }
    })
  }

  const deleteAttachmentHeader = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(async () => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            getFile('header', ID, localStorage.getItem('credential')!).then((res) => {
              setFullHeader(res.data.data)
            })
          })
          .catch((error) => {
            swal({
              title: t(error.response.data),
              icon: 'error',
            })
          })
      }
    })
  }

  const [IDAttachments, setIDAttachments] = useState([0, 0])
  const accsessDelete = useSelector(
    (state: any) => state.appPersistedReducer.selectedMenu.attachment_delete
  )

  const ambilAttachment = async (id: any, id2: any) => {
    if (fileBox == 'false') {
      setShowUpload(true)
    } else {
      setShowUpload1(true)
    }

    // if (roleUser == 'salesAdmin') {
    if (true) {
      let tempArray: any[] = []
      const res = await getFile('order-item', id, localStorage.getItem('credential')!)
      // setAllFiles(res.data.data)

      const res2 = await getFile('amandemen', id2, localStorage.getItem('credential')!)

      tempArray = tempArray.concat(res.data.data, res2.data.data)
      setAllFiles(tempArray)
      setAllFiles2(tempArray)
    }
    // const res = await getFile('order-item', id, localStorage.getItem('credential')!)
    // setAllFiles(res.data.data)
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (accesses?.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    return data
  }

  const [tempJadwal, setTempJadwal] = useState<any>([])
  const [tempJadwal2, setTempJadwal2] = useState<any>([])

  const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ]
  const [listYear, setListYear] = useState<any[]>([])
  const [tempTanggal, setTempTanggal] = useState(0)
  const [daysInMonth, setDaysInMonth] = useState(0)
  const [tempMinggu, setTempMinggu] = useState(0)
  const [tempBulan, setTempBulan] = useState(0)
  const [tempTahun, setTempTahun] = useState(0)
  const [tempTon, setTempTon] = useState(0)
  const [tempIndex, setTempIndex] = useState(0)
  const [taking, setTaking] = useState(0)
  //#endregion

  const [fixedQuantum2, setFixedQuantum2] = useState<any>(0)
  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    // console.log(temp)
    setFixedQuantum2(temp)
  }

  const [editedIndex, setEditedIndex] = useState<any>()

  const rubahSchedule = (index: any, tonnage: any, tonlama: any) => {
    let tempoquantum = 0
    tempJadwal?.forEach((element: any) => {
      tempoquantum = tempoquantum + element?.tonnage
    })
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        if (tempTon != 0) {
          if (fixedQuantum >= tempoquantum - tonlama + tempTon) {
            let tempArray: any[] = tempJadwal
            let temparrayorder: any[] = detailOrder
            let temparraynerorder: any[] = addedItems
            tempArray[index].tonnage = tonnage
            if (newProductFlag) {
              temparraynerorder[tempIndex].schedules = tempArray
              setAddedItems(temparraynerorder)
            } else {
              temparrayorder[tempIndex].schedules = tempArray
              setDetailOrder(temparrayorder)
            }
            setTempJadwal(tempArray)
            setEditedIndex(null)
            swal({
              title: `${t('dataBerhasilDiedit')}`,
              icon: 'success',
            })
          } else {
            swal({
              title: t('Melebihi Tonase!'),
              icon: 'error',
            })
          }
        } else {
          swal({
            title: t('isi') + t('Tonnage'),
            icon: 'error',
          })
        }
      } else return setEditedIndex(null)
    })
  }

  const hapusSchedule = (index: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        let tempArray: any[] = tempJadwal
        let temparrayorder: any[] = detailOrder
        let temparraynerorder: any[] = addedItems
        tempArray.splice(index, 1)
        if (newProductFlag) {
          temparraynerorder[tempIndex].schedules = tempArray
          setAddedItems(temparraynerorder)
        } else {
          temparrayorder[tempIndex].schedules = tempArray
          setDetailOrder(temparrayorder)
        }
        setTempJadwal(tempArray)
        const temptaking = taking - 1
        setTaking(temptaking)
        setEditedIndex(null)
        swal({
          closeOnClickOutside: false,
          title: t('deleted successfully'),
          icon: 'success',
        })
      } else return setEditedIndex(null)
    })
  }

  const clearStateJadwal = () => {
    setTempTanggal(0)
    setTempBulan(0)
    setTempTahun(0)
    setTempTon(0)
  }

  const validasiJadwal = () => {
    if (tempTanggal == 0) return t('Tanggal ke-')
    else if (tempBulan == 0) return t('Bulan ke-')
    else if (tempTahun == 0) return t('Tahun ke-')
    else if (tempTon == 0) return t('Tonnage')
    else return 'nothing'
  }

  const clearInputJadwal = () => {
    const input5 = document.getElementById('jadwalminggu') as HTMLInputElement
    input5.value = ''
    const input1 = document.getElementById('jadwaltanggal') as HTMLSelectElement
    if (input1 != null) input1.selectedIndex = 0
    const input11 = document.getElementById('jadwaltanggal1') as HTMLSelectElement
    if (input11 != null) input11.selectedIndex = 0
    const input2 = document.getElementById('jadwalbulan') as HTMLSelectElement
    input2.selectedIndex = 0
    const input3 = document.getElementById('jadwaltahun') as HTMLSelectElement
    input3.selectedIndex = 0
    const input4 = document.getElementById('jadwalton') as HTMLInputElement
    input4.value = ''
  }

  const [day, setDay] = useState<any>(0)
  const [month, setMonth] = useState<any>(0)
  const [year, setYear] = useState<any>(0)
  const [datenow, setDateNow] = useState('')
  const [orderItemFiles, setOrderItemsFiles] = useState<any[]>([])

  const handleDeleteUploadHeader = (index: any, data: any, setData: any, type: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          if (type == 'header') {
            const tempArray = [...stateFileHeader]
            tempArray?.splice(index, 1)
            setStateFileHeader(tempArray)
          } else {
            const tempArray = [...data]
            let temparrayorder: any[] = detailOrder
            let temparrayneworder: any[] = addedItems
            tempArray?.splice(index, 1)

            if (newProductFlag) {
              temparrayneworder[tempIndex].attachments = tempArray
              setAddedItems(temparrayneworder)
            } else {
              temparrayorder[tempIndex].attachments = tempArray
              setDetailOrder(temparrayorder)
            }
            setData(tempArray)
          }
          swal({
            closeOnClickOutside: false,
            title: t('deleted successfully'),
            icon: 'success',
          })
        }
      })
      .catch((err) => {
        swal({
          title: `${t('Data Failed to Delete')}`,
          icon: 'error',
        })
      })
  }

  function download_file(fileURL: any, fileName: any) {
    var save = document.createElement('a')
    save.href = fileURL
    save.target = '_blank'
    // var filename = fileURL.substring(fileURL.lastIndexOf('/') + 0)
    let temp = fileName.split('.')
    var filename = temp[0]
    // console.log(filename.slice(1, 20))
    save.download = filename
    if (
      navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
      navigator.userAgent.search('Chrome') < 0
    ) {
      document.location = save.href
    } else {
      var evt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: false,
      })
      save.dispatchEvent(evt)
      ;(window.URL || window.webkitURL).revokeObjectURL(save.href)
    }
  }
  const [tempFiles, setTempFiles] = useState<any[]>([])

  const validasiFile = () => {
    if (files == null || files == '') return 'File'
    else if (description == '') return 'File Information'
    else return 'nothing'
  }

  const handleUpload = async () => {
    const checkvalidasi = validasiFile()
    if (checkvalidasi == 'nothing') {
      let temparray: any[] = []
      if (tempRole.length > 0) {
        tempRole.forEach((data: any) => {
          temparray.push(data.value)
        })
      }

      const _detailOrder = [...detailOrder]
      const _allFile = [...allFile]
      const newFile = {
        file_r: files,
        name: namaFile,
        description: description!,
        file_type: dataType,
        private: isPrivate,
        is_new: true,
        roles: temparray
      }
      _detailOrder[tempIndex].attachments.push(newFile)
      _allFile.push(newFile)

      setDetailOrder(_detailOrder)
      setAllFiles(_allFile)

      swal({
        title: `${t('document uploaded successfully')}`,
        icon: 'success',
      })

    } else {
      swal({
        title: t('isi') + checkvalidasi,
        icon: 'error',
      })
    }
  }

  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [files, setFiles] = useState<any>()

  const removeFileState = () => {
    setFiles('')
    setNamaFile('')
    setDescription('')
    setDataType('')
    setTempRole([])
    setIsPrivate(false)
  }

  const clearInputUpload = () => {
    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    input2.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
  }

  useEffect(() => {
    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDay(today.getDate())
    setMonth(today.getMonth() + 1)
    setYear(today.getFullYear())
    setDateNow(dd + '-' + mm + '-' + yyyy)
    setDaysInMonth(getDaysInMonth(today.getFullYear(), today.getMonth() + 1))
  }, [])

  useEffect(() => {
    if (tempTahun != 0 && tempBulan != 0) setDaysInMonth(getDaysInMonth(tempTahun, tempBulan))
  }, [tempTahun, tempBulan])

  function getDaysInMonth(year: any, month: any) {
    return new Date(year, month, 0).getDate()
  }

  function loopTanggal(jumlah: any) {
    var indents = []
    for (let i = 0; i < jumlah; i++) {
      indents.push(<option value={i + 1}>{i + 1}</option>)
    }
    return indents
  }

  const checktaking = () => {
    let temp: any[] = tempData?.schedules
    let tempindex = 0

    if (temp == null) tempindex = 0
    else tempindex = temp.length

    if (tempTahun > year + 1) return 'Tahun tidak boleh melebihi tahun ini'

    if (tempTanggal > getDaysInMonth(tempTahun, tempBulan)) return 'Tanggal melebihi'

    if (tempindex != 0) {
      if (temp[tempindex - 1].year <= tempTahun) {
        if (temp[tempindex - 1].year < tempTahun) {
          if (tempTahun == year) {
            if (tempBulan == month) {
              if (tempTanggal >= day) return 'nothing'
              else return 'Week must be greater than or equal to current week'
            } else if (tempBulan > month) return 'nothing'
            else return 'Month must be greater than or equal to current month'
          } else if (tempTahun > year) return 'nothing'
          else return 'Year must be greater than or equal to current year'
        } else if (temp[tempindex - 1].month <= tempBulan) {
          if (temp[tempindex - 1].month < tempBulan) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else if (temp[tempindex - 1].date < tempTanggal) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else return 'Week must be greater than previous week'
        } else return 'Month must be greater than previous month'
      } else return 'Year must be greater than previous year'
    } else {
      if (tempTahun == year) {
        if (tempBulan == month) {
          if (tempTanggal >= day || day > 28) return 'nothing'
          else return 'Week must be greater than or equal to current week'
        } else if (tempBulan > month) return 'nothing'
        else return 'Month must be greater than or equal to current month'
      } else if (tempTahun > year) return 'nothing'
      else return 'Year must be greater than or equal to current year'
    }
  }

  const sendJadwal = () => {
    let tempoquantum = 0
    tempJadwal?.forEach((element: any) => {
      tempoquantum = tempoquantum + element?.tonnage
    })

    const CheckTaking = checktaking()
    const checkMandatory = validasiJadwal()
    if (CheckTaking == 'nothing') {
      if (checkMandatory == 'nothing') {
        if (fixedQuantum >= tempoquantum + tempTon) {
          let temp: any = [...tempJadwal]
          let temparray: any[] = detailOrder
          let temparrayneworder: any[] = addedItems
          const tempobject = {
            sort: tempJadwal.length + 1,
            date: tempTanggal,
            month: tempBulan,
            year: tempTahun,
            tonnage: tempTon,
          }

          if (temp == null) {
            const temp2 = []
            temp2.push(tempobject)
            temp = temp2
          } else {
            temp.push(tempobject)
          }
          const temptaking = taking + 1
          if (newProductFlag) {
            temparrayneworder[tempIndex].schedules = temp
            setAddedItems(temparrayneworder)
          } else {
            temparray[tempIndex].schedules = temp
            setDetailOrder(temparray)
          }
          // console.log(temparray)
          setTaking(temptaking)
          setTempJadwal(temp)
          clearInputJadwal()
          clearStateJadwal()
          // setShowJadwal(false)
        } else {
          swal({
            title: t('Melebihi Tonase!'),
            icon: 'error',
          })
        }
      } else {
        swal({
          title: t('isi') + checkMandatory,
          icon: 'error',
        })
      }
    } else {
      swal({
        title: t(CheckTaking),
        icon: 'error',
      })
    }
  }

  const handleJadwal = () => {
    if (tempJadwal?.length == undefined) {
      setTaking(0)
    } else {
      setTaking(tempJadwal?.length)
    }
    setShow3(true)
  }

  const [fixedQuantum, setFixedQuantum] = useState(0)

  const getDetail = async (is_amandemen: any) => {
    setLoading(true)
    await orderDetailAmandemen(params?.id || sessionStorage.getItem('po'), is_amandemen).then((res) => {
      // console.log(res.data.data.children)
      // setDetailOrder(res.data.data.children)
      setRegarding(res.data.data.regarding)
      setStatus(res.data.data.status)
      setID(res.data.data.id)
      setOrderNumber(res.data.data.po_number)
      setSektorID(res.data.data.sector_id)
      setCustomerCode(res.data.data.customer?.customer_code)
      setCustomerName(res.data.data.customer?.name)
      setCustomerTitle(res.data.data.customer?.title)
      setCustomerAddress(res.data.data.customer?.address)
      setPhoneNumber(res.data.data.customer?.user?.mobile_number)
      setPICCust(res.data.data.customer?.name4)
      setEmailCust(res.data.data.customer?.user?.email)
      setDistribution(res.data.data.distribution_channel)
      setIsAmandemend(res.data.data.is_amandemen)
      setNumberRevisedItem(res.data.data.item_revisied_amandement)
      if (user == 'salesAdmin') {
        dispath(setGetNotif(!notif))
      }
      let temparray: any[] = []
      let temparray2: any[] = []
      let temparray3: any[] = []
      let temparraycheck: any[] = []
      res.data.data.children.forEach((data: any) => {
        let tempobject = data
        let tempschedule: any[] = []
        if (user == 'salesAdmin' && data.is_amendment) {
          data.amendment_orders[0].schedules.forEach((item: any) => {
            tempschedule.push({
              date: item.date,
              month: item.month,
              year: item.year,
              tonnage: item.tonnage,
            })
          })
          temparraycheck.push({
            sales_org_code: false,
            sector_id: false,
            incoterm1_id: false,
            incoterm2_id: false,
            province_id: false,
            city_id: false,
            product_type: false,
            product_name: false,
            request_quantum: false,
            request_price: false,
            include_ppn: false,
            payment_type_1: false,
            payment_type_2: false,
            segment_code: false,
            payment_note: false,
            end_user: false,
            plant: false,
            shipping_tolerance: false,
            notes: false,
          })

          let temprealizedbefore = 0
          if (data.is_so_release == true)
            temprealizedbefore = parseFloat(data.fixed_quantum) - parseFloat(data.so_qty_realized)
          else temprealizedbefore = data.fixed_quantum
          temparray3.push({
            order_sub_detail_id: data.id,
            sales_org_code: data.sales_org_code,
            incoterm1_id: data.incoterm1_id,
            incoterm2_id: data.incoterm2_id,
            incoterm1_desc: data.incoterm1?.code,
            incoterm2_desc: data.incoterm2 == null ? data.incoterm2_id : data?.incoterm2?.code,
            product_type: data.product_type,
            product_type_desc: data.product_type_desc,
            product_name: data.product_name,
            product_spec: data.product_spec,
            request_price: data.fixed_price,
            request_quantum: data.fixed_quantum,
            province_id: data.province_id,
            province_desc: data.province?.region_name,
            city_id: data.city_id,
            city_desc: data.city?.city_name,
            sector_id: data.sector_id,
            include_ppn: data.include_ppn,
            end_user: data.end_user,
            end_user_multiple: data.end_user_multiple,
            segment_code: data.segment_code,
            segment_name: data.segment_name,
            plant: data.plant,
            city_plant: data.city_plant,
            notes: data.notes,
            payment_type_1: data.payment_type_1,
            payment_type_2: data.payment_type_2,
            shipping_tolerance: data.shipping_tolerance,
            material_number: data.material_number,
            unit: data.unit,
            payment_type_1_desc: data.payment_type_1_desc,
            payment_type_2_desc: data.payment_type_2_desc,
            payment_note: data.payment_note,
            country: data.country,
            country_desc: data.country_desc,
            plant_desc: data.plant_desc,
            so_qty_realized: data.so_qty_realized,
            quantum_realisazied: data.quantum_realisazied,
            quantum_left: data.quantum_left,
            quantum_do: data.quantum_do,
            id: data.amendment_orders[0]?.id,
          })
          data.amendment_orders[0].schedules = tempschedule
          temparray.push(tempobject)
        } else if (data.amendment_status == 2) {
          // console.log(data)
          data.amendment_orders[0].ischanged = false
          data.amendment_orders[0].attachments = []
          data.amendment_orders[0].schedules?.forEach((item: any) => {
            tempschedule.push({
              date: item.date,
              month: item.month,
              year: item.year,
              tonnage: item.tonnage,
            })
          })
          data.amendment_orders[0].schedules = tempschedule
          data.amendment_orders[0].amendment_status = 2
          temparray.push(data.amendment_orders[0])
        } else if (data.is_new_item) {
          // console.log(data)
          data.schedules.forEach((item: any) => {
            tempschedule.push({
              date: item.date,
              month: item.month,
              year: item.year,
              tonnage: item.tonnage,
            })
          })
          data.schedules = tempschedule
          temparray2.push(tempobject)
        } else {
          data.ischanged = false
          data.attachments = []
          data.schedules?.forEach((item: any) => {
            tempschedule.push({
              date: item.date,
              month: item.month,
              year: item.year,
              tonnage: item.tonnage,
            })
          })
          data.schedules = tempschedule
          temparray.push(tempobject)
        }
      })

      setDetailOrder(temparray)
      setDetailOrder2(temparray3)
      setCheckDetector(temparraycheck)
      setAddedItems(temparray2)
      setAddedItems2(temparray2)
    })
    setLoading(false)
  }

  const getDetailCustomer = async () => {
    await detailAmandemenCustomer().then((res) => {
      setRegarding(res.data.data.regarding)
      setStatus(res.data.data.status)
      setID(res.data.data.id)
      setOrderNumber(res.data.data.po_number)
      setSektorID(res.data.data.sector_id)
      setCustomerCode(res.data.data.customer?.customer_code)
      setCustomerName(res.data.data.customer?.name)
      setCustomerTitle(res.data.data.customer?.title)
      setCustomerAddress(res.data.data.customer?.address)
      setPhoneNumber(res.data.data.customer?.user?.mobile_number)
      setPICCust(res.data.data.customer?.name4)
      setEmailCust(res.data.data.customer?.user?.email)
      setDistribution(res.data.data.distribution_channel)
      if (user == 'salesAdmin') {
        dispath(setGetNotif(!notif))
      }
      let temparray: any[] = []
      let temparray2: any[] = []
      let temparray3: any[] = []
      let temparraycheck: any[] = []
      res.data.data.children.forEach((data: any) => {
        let tempobject = data
        let tempschedule: any[] = []
        if (data.is_new_item) {
          data.schedules.forEach((item: any) => {
            tempschedule.push({
              date: item.date,
              month: item.month,
              year: item.year,
              tonnage: item.tonnage,
            })
          })
          data.schedules = tempschedule
          temparray2.push(tempobject)
        } else {
          data.ischanged = false
          data.attachments = []
          data.schedules?.forEach((item: any) => {
            tempschedule.push({
              date: item.date,
              month: item.month,
              year: item.year,
              tonnage: item.tonnage,
            })
          })
          data.schedules = tempschedule
          temparray.push(tempobject)
        }
      })
      setDetailOrder(temparray)
      setDetailOrder2(temparray3)
      setCheckDetector(temparraycheck)
      setAddedItems(temparray2)
      // console.log(temparray, temparray2)
    })
  }

  const [accesses, setAccesses] = useState<any>()

  useEffect(() => {
    let is_amandemen = false
    if(isCreating){
      getDetail(false)
      is_amandemen = false
    }else{
      if (localStorage.getItem('role-flag') == 'salesAdmin') {
        getDetail(true)
        is_amandemen = true
      } else {
        getDetail(false)
        is_amandemen = false
      }
    }

    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }
    const handleYear = () => {
      let year = []
      const aYearFromNow = new Date()
      year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear())).getFullYear())
      for (let i = 0; i < 2; i++) {
        year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1)).getFullYear())
      }
      setListYear(year)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    handleYear()
    getAllRoleList()
    getAccessMenu()
    role()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleStock = async () => {
    setShowStock(true)

    if(!loadedStock) loadDetailStock()
  }

  const loadDetailStock = async () => {
    setBtnStock(true)
    setLoadedStock(true)

    const temp = {data: [{}]}
    temp.data.splice(0, 1)
    detailOrder.forEach((data) => {
      if (data.is_amendment == true)
        temp.data.push({
          material_number: data.amendment_orders[0]?.material_number,
          unit: data.amendment_orders[0]?.unit,
          plant: data.amendment_orders[0]?.plant,
          product_type: data.amendment_orders[0]?.product_type
        })
      else temp.data.push({
        material_number: data.material_number, 
        unit: data.unit, 
        plant: data.plant,
        product_type: data.product_type
      })
    })

    fetchCheckStock(temp).then((res: any) => {
      setAllStock(res.data.data)
    }).catch((error: any) => {
        if (error.response) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        } else {
          swal({
            title: t(error.message),
            icon: 'error',
          })
        }
      })
      .finally(() => setBtnStock(false))
  }

  const reloadData = async () => {
    const cred = localStorage.getItem('cust-code')
    try {
      await getSector(disctribution).then((res) => {
        setFullSector(res.data.data)
      })
    } catch {}

    try {
      await getIncoterm().then((res) => {
        let temparray: any[] = [{value: '~#~', label: t('Pilih-incoterm')}]
        res.data.data.forEach((item: any) => {
          temparray.push({value: item.id + '~#~' + item.code, label: item.code})
        })
        setFullIncoterm(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.code,
              label: item.code,
            }
          })
        )
        // console.log(temparray)
        setFullIncoterm2(temparray)
      })
    } catch {}

    try {
      await getProductType('').then((res) => {
        setFullProductType(res.data.data)
      })
    } catch {}
  }

  CustomUseEffect(() => {
    if (idSektor == 2) setRetailFlag(true)
    else setRetailFlag(false)
  }, [idSektor])

  const getprov = async () => {
    let options: Record<string, any> = {}
    if(idSektor == 2) options.customer_code = localStorage.getItem("cust-code")
    await getProvince3(options).then((res) => {
      setFullProvince(
        res.data.data.map((item: any) => {
          return {
            value: item.sales_office + '~#~' + item.controlling_area,
            label: item.controlling_area,
          }
        })
      )
    })
  }

  const cityData = async (value: any) => {
    const tempName = value.split('~#~')
    setProvince(parseInt(tempName[0]))
    setProvinceDesc(tempName[1])
    try {
      await getCity(tempName[0]).then((res) => {
        setFullCity(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.value,
              label: item.value,
            }
          })
        )
      })
      fieldClearer('province')
    } catch {}
  }

  const plantData = async () => {
    let temp: string[] = []
    if (sektor != '') {
      temp = sektor.split('~#~')
    }
    try {
      if (produsen != '' && sektor != '') {
        await getPlant(produsen, disctribution, province, {
          city_code: city
        }).then((res) => {
          setFullPlant(
            res.data.data.map((item: any) => {
              return {
                value: item.plant + '~#~' + item.plant_name + '~#~' + item.city_name,
                label: item.plant + '-' + item.plant_name,
              }
            })
          )
        })
      }
    } catch {}
  }

  const productTypeChange = (value: any) => {
    const tempType = value.split('~#~')
    // if(tempType[1] == 'P13'){
    //   const ckbox = document.getElementById('noenduser') as HTMLInputElement
    //   if (ckbox != null) ckbox.checked = true
    //   setIsNoEnduser(true)
    // }
    setPtype2(tempType[0])
    setPtype(tempType[1])
    fieldClearer('tipe')
  }

  const productNameChange = (value: any) => {
    const tempName = value.split('~#~')
    if (tempName[0] != '0') setPname(tempName[1])

    setPnumber(tempName[0])
    setPunit(tempName[2])
    // fieldClearer(1)
  }

  const plantChange = (value: any) => {
    const tempName = value.split('~#~')
    setWarehouse(tempName[0])
    setWarehouseDesc(tempName[1])
    setPlantcity(tempName[2])
    fieldClearer(3)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const [tempPayload, setTempPayload] = useState<any>({})
  const [itemNumber, setItemNumber] = useState('')
  const [isNoEnduser, setIsNoEnduser] = useState(false)
  const [isFileBox, setIsFileBox] = useState<any>({})

  const [fileBox, setFileBox] = useState<any>('false')

  const addAmandement = () => {
    setFileBox('true')
    const mandatoryCheck = checkMandatory()
    if (mandatoryCheck == 'nothing') {
      if (minQuantum > quantum) {
        swal({
          title: t('minamemdmentquantum'),
          icon: 'error',
        })
      } else {
        swal({
          title: `${t('Are you sure?')}`,
          icon: 'warning',
          buttons: [`${t('Tidak')}`, `${t('Ya')}`],
          dangerMode: true,
        }).then(async (resubmit) => {
          let enduser1: any = []
          let enduser2: any = []
          if (!isNoEnduser) {
            arrayEnduser.forEach((data: any) => {
              enduser1.push(data.value)
              enduser2.push(data.label)
            })
          } else {
            enduser1 = enduserDesc
            enduser2 = enduserDesc
          }
          let temp: any = [...detailOrder]
          if (resubmit) {
            if (shipping <= 100) {
              const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
              let ppn = false
              if (ckbox != null) {
                if (ckbox.checked) ppn = true
                else ppn = false
              }

              let temptol = shipping
              if (isNaN(temptol)) temptol = 0
              else temptol = shipping
              setShowAmandemend(false)
              if (roleUser == 'salesAdmin') {
                let tempaddeditem: any[] = addedItems
                tempaddeditem[tempIndex].sales_org_code = produsen
                tempaddeditem[tempIndex].incoterm1_id = incoterm1
                tempaddeditem[tempIndex].incoterm1!.code = incoterm1Desc
                tempaddeditem[tempIndex].incoterm2_id = incoterm2
                // if (tempaddeditem[tempIndex].incoterm2 != null) tempaddeditem[tempIndex].incoterm2!.code = incoterm2Desc
                tempaddeditem[tempIndex].incoterm2 = {code: incoterm2Desc, id: incoterm2}
                tempaddeditem[tempIndex].product_type = ptype
                tempaddeditem[tempIndex].product_type_desc = ptype2
                tempaddeditem[tempIndex].product_name = pname
                tempaddeditem[tempIndex].product_spec = pspec
                tempaddeditem[tempIndex].request_price = parseFloat(subprice)
                tempaddeditem[tempIndex].fixed_price = parseFloat(subprice)
                tempaddeditem[tempIndex].fixed_quantum = parseFloat(quantum)
                tempaddeditem[tempIndex].request_quantum = parseFloat(quantum)
                tempaddeditem[tempIndex].segment_code = segment
                tempaddeditem[tempIndex].segment_name = segmentDesc
                tempaddeditem[tempIndex].province_id = province
                tempaddeditem[tempIndex].so_qty_realized = 0
                if (tempaddeditem[tempIndex].province != null)
                  tempaddeditem[tempIndex].province.region_name = provinceDesc
                if (tempaddeditem[tempIndex].city != null)
                  tempaddeditem[tempIndex].city.city_name = cityDesc
                tempaddeditem[tempIndex].city_id = city
                tempaddeditem[tempIndex].sector_id = idSektor
                tempaddeditem[tempIndex].include_ppn = ppn
                tempaddeditem[tempIndex].end_user = enduser1.toString()
                tempaddeditem[tempIndex].plant = warehouse
                tempaddeditem[tempIndex].city_plant = plantcity
                tempaddeditem[tempIndex].notes = note
                tempaddeditem[tempIndex].payment_type_1 = pay1
                tempaddeditem[tempIndex].payment_type_2 = pay2
                tempaddeditem[tempIndex].shipping_tolerance = temptol
                tempaddeditem[tempIndex].material_number = pnumber
                tempaddeditem[tempIndex].unit = punit
                tempaddeditem[tempIndex].payment_type_1_desc = pay1Desc
                tempaddeditem[tempIndex].payment_type_2_desc = pay2Desc
                tempaddeditem[tempIndex].payment_note = keterangan
                tempaddeditem[tempIndex].country = country
                tempaddeditem[tempIndex].country_desc = countryDesc
                tempaddeditem[tempIndex].plant_desc = warehouseDesc
                tempaddeditem[tempIndex].end_user_multiple = !isNoEnduser
                tempaddeditem[tempIndex].amandement_notes = alasan
                tempaddeditem[tempIndex].extension_date = tanggalPerpanjangan
              } else {
                temp[tempIndex].sales_org_code = produsen
                temp[tempIndex].incoterm1_id = incoterm1
                temp[tempIndex].incoterm1!.code = incoterm1Desc
                temp[tempIndex].incoterm2_id = incoterm2
                // if (temp[tempIndex].incoterm2 != null) temp[tempIndex].incoterm2!.code = incoterm2Desc
                temp[tempIndex].incoterm2 = {code: incoterm2Desc, id: incoterm2}
                temp[tempIndex].product_type = ptype
                temp[tempIndex].product_type_desc = ptype2
                temp[tempIndex].product_name = pname
                temp[tempIndex].product_spec = pspec
                temp[tempIndex].request_price = parseFloat(subprice)
                // temp[tempIndex].fixed_price = parseFloat(subprice)
                // temp[tempIndex].fixed_quantum = parseFloat(quantum)
                temp[tempIndex].request_quantum = parseFloat(quantum)
                temp[tempIndex].segment_code = segment
                temp[tempIndex].segment_name = segmentDesc
                temp[tempIndex].province_id = province
                temp[tempIndex].so_qty_realized = 0
                if (temp[tempIndex].province != null)
                  temp[tempIndex].province.region_name = provinceDesc
                if (temp[tempIndex].city != null) temp[tempIndex].city.city_name = cityDesc
                temp[tempIndex].city_id = city
                temp[tempIndex].sector_id = idSektor
                temp[tempIndex].include_ppn = ppn
                temp[tempIndex].is_formulated_price = isFormulatedPrice
                temp[tempIndex].end_user = enduser1.toString()
                temp[tempIndex].plant = warehouse
                temp[tempIndex].city_plant = plantcity
                temp[tempIndex].notes = note
                temp[tempIndex].payment_type_1 = pay1
                temp[tempIndex].payment_type_2 = pay2
                temp[tempIndex].shipping_tolerance = temptol
                temp[tempIndex].material_number = pnumber
                temp[tempIndex].unit = punit
                temp[tempIndex].payment_type_1_desc = pay1Desc
                temp[tempIndex].payment_type_2_desc = pay2Desc
                temp[tempIndex].payment_note = keterangan
                temp[tempIndex].country = country
                temp[tempIndex].country_desc = countryDesc
                temp[tempIndex].plant_desc = warehouseDesc
                temp[tempIndex].end_user_multiple = !isNoEnduser
                temp[tempIndex].ischanged = true
                temp[tempIndex].amandement_notes = alasan
                temp[tempIndex].extension_date = tanggalPerpanjangan
                setDetailOrder(temp)
              }
            } else {
              swal({
                title: t('Shipping tolerance melebihi 100%'),
                icon: 'error',
              })
            }
          } else return
        })
      }
    } else {
      swal({
        title: t(mandatoryCheck),
        icon: 'error',
      })
    }
  }

  const addNewProduct = () => {
    const mandatoryCheck = checkMandatory()
    if (mandatoryCheck == 'nothing') {
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      }).then(async (resubmit) => {
        if (resubmit) {
          let enduser1: any = []
          let enduser2: any = []
          if (!isNoEnduser && idSektor == 1) {
            arrayEnduser.forEach((data: any) => {
              enduser1.push(data.value)
              enduser2.push(data.label)
            })
          } else {
            enduser1 = enduserDesc
            enduser2 = enduserDesc
          }
          let temp: any = [...addedItems]
          let temp2: any = [...addedItems2]
          if (shipping <= 100) {
            const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
            let ppn = false
            if (ckbox != null) {
              if (ckbox.checked) ppn = true
              else ppn = false
            }
            let temptol = shipping
            if (isNaN(temptol)) temptol = 0
            else temptol = shipping

            let tempprice = parseFloat(subprice)

            if (isFormulatedPrice) tempprice = 0
            else tempprice = parseFloat(subprice)

            temp.push({
              item_number: 0,
              sales_org_code: produsen,
              incoterm1_id: incoterm1,
              incoterm2_id: incoterm2,
              product_type: ptype,
              product_type_desc: ptype2,
              product_name: pname,
              product_spec: pspec,
              request_price: tempprice,
              request_quantum: parseFloat(quantum),
              province_id: province,
              city_id: city,
              sector_id: sektorID,
              include_ppn: ppn,
              end_user: enduser1.toString(),
              segment_code: segment,
              segment_name: segmentDesc,
              plant: warehouse,
              city_plant: plantcity,
              notes: note,
              payment_type_1: pay1,
              payment_type_2: pay2,
              shipping_tolerance: temptol,
              material_number: pnumber,
              unit: punit,
              payment_type_1_desc: pay1Desc,
              payment_type_2_desc: pay2Desc,
              payment_note: keterangan,
              country: country,
              country_desc: countryDesc,
              plant_desc: warehouseDesc,
              end_user_multiple: idSektor != 1 ? false : !isNoEnduser,
              is_formulated_price: isFormulatedPrice,
              schedules: [],
              attachments: [],
            })
            temp2.push({
              item_number: 0,
              sales_org_code: produsenDesc,
              incoterm1_id: incoterm1Desc,
              incoterm2_id: incoterm2Desc,
              product_type: ptype,
              product_type_desc: ptype2,
              product_name: pname,
              product_spec: pspec,
              request_price: tempprice,
              request_quantum: parseFloat(quantum),
              province_id: provinceDesc,
              city_id: cityDesc,
              sector_id: sektorID,
              include_ppn: ppn,
              end_user: enduser1.toString(),
              segment_code: segment,
              segment_name: segmentDesc,
              plant: warehouse,
              city_plant: plantcity,
              notes: note,
              payment_type_1: pay1,
              payment_type_2: pay2,
              shipping_tolerance: temptol,
              material_number: pnumber,
              unit: punit,
              payment_type_1_desc: pay1Desc,
              payment_type_2_desc: pay2Desc,
              payment_note: keterangan,
              country: country,
              country_desc: countryDesc,
              plant_desc: warehouseDesc,
              is_formulated_price: isFormulatedPrice,
              end_user_multiple: idSektor != 1 ? false : !isNoEnduser,
            })
            setAddedItems(temp)
            setAddedItems2(temp2)
            setShowAddProduct(false)
          } else {
            swal({
              title: t('Shipping tolerance melebihi 100%'),
              icon: 'error',
            })
          }
        } else return
      })
    } else {
      swal({
        title: t(mandatoryCheck),
        icon: 'error',
      })
    }
  }

  const editNewOrder = () => {
    const mandatoryCheck = checkMandatory()
    if (mandatoryCheck == 'nothing') {
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      }).then(async (resubmit) => {
        let enduser1: any = []
        let enduser2: any = []
        if (!isNoEnduser && idSektor == 1) {
          arrayEnduser.forEach((data: any) => {
            enduser1.push(data.value)
            enduser2.push(data.label)
          })
        } else {
          enduser1 = enduserDesc
          enduser2 = enduserDesc
        }
        let temp: any = [...addedItems]
        let temp2: any = [...addedItems2]
        let tempprice = parseFloat(subprice)

        if (isFormulatedPrice) tempprice = 0
        else tempprice = parseFloat(subprice)

        if (resubmit) {
          if (shipping <= 100) {
            if (roleUser != 'salesAdmin') {
              const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
              let ppn = false
              if (ckbox != null) {
                if (ckbox.checked) ppn = true
                else ppn = false
              }

              let temptol = shipping
              if (isNaN(temptol)) temptol = 0
              else temptol = shipping
              setShowAmandemend(false)
              temp[tempIndex].incoterm1_id = incoterm1
              temp[tempIndex].incoterm2_id = incoterm2
              temp[tempIndex].product_type = ptype
              temp[tempIndex].product_type_desc = ptype2
              temp[tempIndex].product_name = pname
              temp[tempIndex].product_spec = pspec
              temp[tempIndex].request_price = tempprice
              temp[tempIndex].request_quantum = parseFloat(quantum)
              temp[tempIndex].segment_code = segment
              temp[tempIndex].segment_name = segmentDesc
              temp[tempIndex].province_id = province
              temp[tempIndex].city_id = city
              temp[tempIndex].include_ppn = ppn
              temp[tempIndex].end_user = enduser1.toString()
              temp[tempIndex].plant = warehouse
              temp[tempIndex].city_plant = plantcity
              temp[tempIndex].notes = note
              temp[tempIndex].payment_type_1 = pay1
              temp[tempIndex].payment_type_2 = pay2
              temp[tempIndex].shipping_tolerance = temptol
              temp[tempIndex].material_number = pnumber
              temp[tempIndex].unit = punit
              temp[tempIndex].payment_type_1_desc = pay1Desc
              temp[tempIndex].payment_type_2_desc = pay2Desc
              temp[tempIndex].payment_note = keterangan
              temp[tempIndex].country = country
              temp[tempIndex].country_desc = countryDesc
              temp[tempIndex].plant_desc = warehouseDesc
              if (idSektor == 1) temp[tempIndex].end_user_multiple = !isNoEnduser
              else temp[tempIndex].end_user_multiple = false
              temp[tempIndex].is_formulated_price = isFormulatedPrice
              temp[tempIndex].ischanged = true

              temp2[tempIndex].incoterm1_id = incoterm1Desc
              temp2[tempIndex].incoterm2_id = incoterm2Desc
              temp2[tempIndex].product_type = ptype
              temp2[tempIndex].product_type_desc = ptype2
              temp2[tempIndex].product_name = pname
              temp2[tempIndex].product_spec = pspec
              temp2[tempIndex].request_price = tempprice
              temp2[tempIndex].request_quantum = parseFloat(quantum)
              temp2[tempIndex].segment_code = segment
              temp2[tempIndex].segment_name = segmentDesc
              temp2[tempIndex].province_id = provinceDesc
              temp2[tempIndex].city_id = cityDesc
              temp2[tempIndex].include_ppn = ppn
              temp2[tempIndex].end_user = enduser1.toString()
              temp2[tempIndex].plant = warehouse
              temp2[tempIndex].city_plant = plantcity
              temp2[tempIndex].notes = note
              temp2[tempIndex].payment_type_1 = pay1
              temp2[tempIndex].payment_type_2 = pay2
              temp2[tempIndex].shipping_tolerance = temptol
              temp2[tempIndex].material_number = pnumber
              temp2[tempIndex].unit = punit
              temp2[tempIndex].payment_type_1_desc = pay1Desc
              temp2[tempIndex].payment_type_2_desc = pay2Desc
              temp2[tempIndex].payment_note = keterangan
              temp2[tempIndex].country = country
              temp2[tempIndex].country_desc = countryDesc
              temp2[tempIndex].plant_desc = warehouseDesc
              if (idSektor == 1) temp2[tempIndex].end_user_multiple = !isNoEnduser
              else temp2[tempIndex].end_user_multiple = false
              temp2[tempIndex].is_formulated_price = isFormulatedPrice
              temp2[tempIndex].ischanged = true
              setAddedItems(temp)
              setAddedItems2(temp2)
            } else {
              const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
              let ppn = false
              if (ckbox != null) {
                if (ckbox.checked) ppn = true
                else ppn = false
              }

              let temptol = shipping
              if (isNaN(temptol)) temptol = 0
              else temptol = shipping
              setShowAmandemend(false)
              temp[tempIndex].incoterm1_id = incoterm1
              temp[tempIndex].incoterm1.code = incoterm1Desc
              temp[tempIndex].incoterm1.id = incoterm1
              temp[tempIndex].incoterm2_id = incoterm2
              temp[tempIndex].incoterm2 = {id: incoterm2, code: incoterm2Desc}
              temp[tempIndex].product_type = ptype
              temp[tempIndex].product_type_desc = ptype2
              temp[tempIndex].product_name = pname
              temp[tempIndex].product_spec = pspec
              temp[tempIndex].request_price = tempprice
              temp[tempIndex].fixed_price = tempprice
              temp[tempIndex].request_quantum = parseFloat(quantum)
              temp[tempIndex].fixed_quantum = parseFloat(quantum)
              temp[tempIndex].segment_code = segment
              temp[tempIndex].segment_name = segmentDesc
              temp[tempIndex].province_id = province
              temp[tempIndex].province.region_name = provinceDesc
              temp[tempIndex].province.id = province
              temp[tempIndex].city_id = city
              temp[tempIndex].city.id = city
              temp[tempIndex].city.city_name = cityDesc
              temp[tempIndex].include_ppn = ppn
              temp[tempIndex].end_user = enduser1.toString()
              temp[tempIndex].plant = warehouse
              temp[tempIndex].city_plant = plantcity
              temp[tempIndex].notes = note
              temp[tempIndex].payment_type_1 = pay1
              temp[tempIndex].payment_type_2 = pay2
              temp[tempIndex].shipping_tolerance = temptol
              temp[tempIndex].material_number = pnumber
              temp[tempIndex].unit = punit
              temp[tempIndex].payment_type_1_desc = pay1Desc
              temp[tempIndex].payment_type_2_desc = pay2Desc
              temp[tempIndex].payment_note = keterangan
              temp[tempIndex].country = country
              temp[tempIndex].country_desc = countryDesc
              temp[tempIndex].plant_desc = warehouseDesc
              if (idSektor == 1) temp[tempIndex].end_user_multiple = !isNoEnduser
              else temp[tempIndex].end_user_multiple = false
              temp[tempIndex].is_formulated_price = isFormulatedPrice
              temp[tempIndex].ischanged = true

              setAddedItems(temp)
              setAddedItems2(temp2)
            }
            setShowEditNewProduct(false)
          } else {
            swal({
              title: t('Shipping tolerance melebihi 100%'),
              icon: 'error',
            })
          }
        } else return
      })
    } else {
      swal({
        title: t(mandatoryCheck),
        icon: 'error',
      })
    }
  }

  const handleTambahProduct = async () => {
    clearState()
    setShowAddProduct(true)

    await getEndUser('').then((res) => {
      // console.log(res.data, ' end user')
      setFullEndUser(res.data.data)
    })

    await getCusGrup().then((res) => {
      setFullSegment(res.data.data)
    })

    await getProductType('').then((res) => {
      // console.log(res.data.data, ' product type')
      setFullProductType(res.data.data)
    })
    setProdusen(detailOrder[0].produsen.code)
    setProdusenDesc(detailOrder[0].produsen.name)
    setIDSector(sektorID)
  }

  const lang = i18next.language

  const postAmandement = async () => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (post) => {
      if (post) {
        setBtnLoading(true)
        const tempfilesheader: any[] = []
        stateFileHeader?.forEach((file: any, _index: any) => {
          tempfilesheader.push(file)
          if (tempfilesheader?.length > 0) {
            const temp = file?.file_r.split(',')
            if (temp[1] != undefined) tempfilesheader[_index].file_r = temp[1]
          }
        })
        let ordersubmission: any[] = []
        if (numberRevisedItem > 0) {
          if (indexItem.length > 0) {
            indexItem.forEach((data: any) => {
              const tempfiles: any[] = []
              detailOrder[data].attachments?.forEach((file: any, _index: any) => {
                tempfiles.push(file)
                if (tempfiles?.length > -1) {
                  const temp = file?.file_r.split(',')
                  if (temp[1] != undefined) tempfiles[_index].file_r = temp[1]
                }
              })
              let tempobject = {
                order_sub_detail_id: detailOrder[data].order_sub_detail_id,
                item_number: detailOrder[data].item_number,
                sales_org_code: detailOrder[data].produsen.code,
                incoterm1_id: detailOrder[data].incoterm1_id,
                incoterm2_id: detailOrder[data].incoterm2_id,
                product_type: detailOrder[data].product_type,
                product_type_desc: detailOrder[data].product_type_desc,
                product_name: detailOrder[data].product_name,
                product_spec: detailOrder[data].product_spec,
                request_price: detailOrder[data].request_price,
                request_quantum: detailOrder[data].ischanged
                  ? detailOrder[data].request_quantum
                  : detailOrder[data].fixed_quantum,
                province_id: detailOrder[data].province_id,
                city_id: detailOrder[data].city_id,
                sector_id: detailOrder[data].sector_id,
                include_ppn: detailOrder[data].include_ppn,
                end_user: detailOrder[data].end_user,
                segment_code: detailOrder[data].segment_code,
                segment_name: detailOrder[data].segment_name,
                plant: detailOrder[data].plant,
                city_plant: detailOrder[data].city_plant,
                notes: detailOrder[data].notes,
                payment_type_1: detailOrder[data].payment_type_1,
                payment_type_2: detailOrder[data].payment_type_2,
                shipping_tolerance: detailOrder[data].shipping_tolerance,
                material_number: detailOrder[data].material_number,
                unit: detailOrder[data].unit,
                payment_type_1_desc: detailOrder[data].payment_type_1_desc,
                payment_type_2_desc: detailOrder[data].payment_type_2_desc,
                payment_note: detailOrder[data].payment_note,
                country: detailOrder[data].country,
                country_desc: detailOrder[data].country_desc,
                plant_desc: detailOrder[data].plant_desc,
                end_user_multiple: detailOrder[data].end_user_multiple,
                amandement_notes: detailOrder[data].amandement_notes,
                extension_date: detailOrder[data].extension_date,
                schedules: detailOrder[data].schedules,
                attachments: tempfiles,
                is_new_item_revision: false,
              }
              ordersubmission.push(tempobject)
            })
          }
          if (addedItems.length > 0) {
            addedItems.forEach((data: any) => {
              const tempfiles: any[] = []
              data.attachments?.forEach((file: any, _index: any) => {
                tempfiles.push(file)
                if (tempfiles?.length > -1) {
                  const temp = file?.file_r.split(',')
                  if (temp[1] != undefined) tempfiles[_index].file_r = temp[1]
                }
              })
              let tempobject = {
                order_sub_detail_id: data.order_sub_detail_id,
                item_number: data.item_number,
                sales_org_code: data.sales_org_code,
                incoterm1_id: data.incoterm1_id,
                incoterm2_id: data.incoterm2_id,
                product_type: data.product_type,
                product_type_desc: data.product_type_desc,
                product_name: data.product_name,
                product_spec: data.product_spec,
                request_price: data.request_price,
                request_quantum: data.request_quantum,
                province_id: data.province_id,
                city_id: data.city_id,
                sector_id: data.sector_id,
                include_ppn: data.include_ppn,
                end_user: data.end_user,
                segment_code: data.segment_code,
                segment_name: data.segment_name,
                plant: data.plant,
                city_plant: data.city_plant,
                notes: data.notes,
                payment_type_1: data.payment_type_1,
                payment_type_2: data.payment_type_2,
                shipping_tolerance: data.shipping_tolerance,
                material_number: data.material_number,
                unit: data.unit,
                payment_type_1_desc: data.payment_type_1_desc,
                payment_type_2_desc: data.payment_type_2_desc,
                payment_note: data.payment_note,
                country: data.country,
                country_desc: data.country_desc,
                plant_desc: data.plant_desc,
                end_user_multiple: data.end_user_multiple,
                schedules: data.schedules,
                is_formulated_price: data.is_formulated_price,
                attachments: tempfiles,
                is_new_item_revision: true,
                amendment_order_id: data.id,
              }
              ordersubmission.push(tempobject)
            })
          }

          await resubmitAmandemen({
            order_sub_id: ID,
            order_submissions: ordersubmission,
            lang: lang,
          })
            .then((res) => {
              swal({
                title: t(res.data.message),
                icon: 'success',
              }).then(() => {
                setIndexAmandement(0)
                setUnderAmandment(false)
                navigate('/management/order/all')
              })
            })
            .catch((error) => {
              if (error.response.data.message.match(':')) {
                const msg = error.response.data.message
                swal({
                  closeOnClickOutside: false,
                  title: t(msg.split(':')[0]) + t(msg.split(': ')[1]),
                  icon: 'error',
                })
              } else {
                swal({
                  closeOnClickOutside: false,
                  title: t(error.response.data.message),
                  icon: 'error',
                })
              }
            })
            .finally(() => setBtnLoading(false))
        } else {
          if (indexItem.length > 0) {
            indexItem.forEach((data: any) => {
              const tempfiles: any[] = []
              detailOrder[data].attachments?.forEach((file: any, _index: any) => {
                tempfiles.push(file)
                if (tempfiles?.length > -1) {
                  const temp = file?.file_r.split(',')
                  if (temp[1] != undefined) tempfiles[_index].file_r = temp[1]
                }
              })
              let tempobject = {
                order_sub_detail_id: detailOrder[data].id,
                item_number: detailOrder[data].item_number,
                sales_org_code: detailOrder[data].produsen.code,
                incoterm1_id: detailOrder[data].incoterm1_id,
                incoterm2_id: detailOrder[data].incoterm2_id,
                product_type: detailOrder[data].product_type,
                product_type_desc: detailOrder[data].product_type_desc,
                product_name: detailOrder[data].product_name,
                product_spec: detailOrder[data].product_spec,
                request_price: detailOrder[data].request_price,
                request_quantum: detailOrder[data].ischanged
                  ? detailOrder[data].request_quantum
                  : detailOrder[data].fixed_quantum,
                province_id: detailOrder[data].province_id,
                city_id: detailOrder[data].city_id,
                sector_id: detailOrder[data].sector_id,
                include_ppn: detailOrder[data].include_ppn,
                end_user: detailOrder[data].end_user,
                segment_code: detailOrder[data].segment_code,
                segment_name: detailOrder[data].segment_name,
                plant: detailOrder[data].plant,
                city_plant: detailOrder[data].city_plant,
                notes: detailOrder[data].notes,
                payment_type_1: detailOrder[data].payment_type_1,
                payment_type_2: detailOrder[data].payment_type_2,
                shipping_tolerance: detailOrder[data].shipping_tolerance,
                material_number: detailOrder[data].material_number,
                unit: detailOrder[data].unit,
                payment_type_1_desc: detailOrder[data].payment_type_1_desc,
                payment_type_2_desc: detailOrder[data].payment_type_2_desc,
                payment_note: detailOrder[data].payment_note,
                country: detailOrder[data].country,
                country_desc: detailOrder[data].country_desc,
                plant_desc: detailOrder[data].plant_desc,
                end_user_multiple: detailOrder[data].end_user_multiple,
                amandement_notes: detailOrder[data].amandement_notes,
                extension_date: detailOrder[data].extension_date,
                schedules: detailOrder[data].schedules,
                attachments: tempfiles,
              }
              ordersubmission.push(tempobject)
            })
          }
          if (addedItems.length > 0) {
            addedItems.forEach((data: any) => {
              const tempfiles: any[] = []
              data.attachments?.forEach((file: any, _index: any) => {
                tempfiles.push(file)
                if (tempfiles?.length > -1) {
                  const temp = file?.file_r.split(',')
                  if (temp[1] != undefined) tempfiles[_index].file_r = temp[1]
                }
              })
              let tempobject = {
                item_number: data.item_number,
                sales_org_code: data.sales_org_code,
                incoterm1_id: data.incoterm1_id,
                incoterm2_id: data.incoterm2_id,
                product_type: data.product_type,
                product_type_desc: data.product_type_desc,
                product_name: data.product_name,
                product_spec: data.product_spec,
                request_price: data.request_price,
                request_quantum: data.request_quantum,
                province_id: data.province_id,
                city_id: data.city_id,
                sector_id: data.sector_id,
                include_ppn: data.include_ppn,
                end_user: data.end_user,
                segment_code: data.segment_code,
                segment_name: data.segment_name,
                plant: data.plant,
                city_plant: data.city_plant,
                notes: data.notes,
                payment_type_1: data.payment_type_1,
                payment_type_2: data.payment_type_2,
                shipping_tolerance: data.shipping_tolerance,
                material_number: data.material_number,
                unit: data.unit,
                payment_type_1_desc: data.payment_type_1_desc,
                payment_type_2_desc: data.payment_type_2_desc,
                payment_note: data.payment_note,
                country: data.country,
                country_desc: data.country_desc,
                plant_desc: data.plant_desc,
                end_user_multiple: data.end_user_multiple,
                schedules: data.schedules,
                is_formulated_price: data.is_formulated_price,
                attachments: tempfiles,
              }
              ordersubmission.push(tempobject)
            })
          }
          let payload = {
            order_sub_id: ID,
            order_submissions: ordersubmission,
          }

          await createAmandemen({
            order_sub_id: ID,
            order_submissions: ordersubmission,
            lang: lang,
            attachments: tempfilesheader,
          })
            .then((res) => {
              swal({
                title: t(res.data.message),
                icon: 'success',
              }).then(() => {
                setIndexAmandement(0)
                setUnderAmandment(false)
                navigate('/management/order/all')
              })
            })
            .catch((error) => {
              if (error.response.data.message.match(':')) {
                const msg = error.response.data.message
                swal({
                  closeOnClickOutside: false,
                  title: t(msg.split(':')[0]) + t(msg.split(': ')[1]),
                  icon: 'error',
                })
              } else {
                swal({
                  closeOnClickOutside: false,
                  title: t(error.response.data.message),
                  icon: 'error',
                })
              }
            })
            .finally(() => setBtnLoading(false))
        }
      } else return
    })
  }

  const acceptAmandement = () => {
    // setBtnLoadingApp(true)
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((post) => {
      if (post) {
        const ck_sales = document.getElementById(`ck-sales`) as HTMLInputElement
        const ck_sektor = document.getElementById(`ck-sektor`) as HTMLInputElement
        const ck_shipping = document.getElementById(`ck-shipping`) as HTMLInputElement
        const ck_plant = document.getElementById(`ck-plant`) as HTMLInputElement
        const ck_incoterm1 = document.getElementById(`ck-incoterm1`) as HTMLInputElement
        const ck_incoterm2 = document.getElementById(`ck-incoterm2`) as HTMLInputElement
        const ck_provinsi = document.getElementById(`ck-provinsi`) as HTMLInputElement
        const ck_kota = document.getElementById(`ck-kota`) as HTMLInputElement
        const ck_jenis = document.getElementById(`ck-jenis`) as HTMLInputElement
        const ck_produk = document.getElementById(`ck-produk`) as HTMLInputElement
        const ck_kuantum = document.getElementById(`ck-kuantum`) as HTMLInputElement
        const ck_harga = document.getElementById(`ck-harga`) as HTMLInputElement
        const ck_ppn = document.getElementById(`ck-ppn`) as HTMLInputElement
        const ck_payment1 = document.getElementById(`ck-payment1`) as HTMLInputElement
        const ck_payment2 = document.getElementById(`ck-payment2`) as HTMLInputElement
        const ck_keterangan = document.getElementById(`ck-keterangan`) as HTMLInputElement
        const ck_spek = document.getElementById(`ck-spek`) as HTMLInputElement
        const ck_enduser = document.getElementById(`ck-enduser`) as HTMLInputElement
        const ck_catatan = document.getElementById(`ck-catatan`) as HTMLInputElement
        const ck_segment = document.getElementById(`ck-segment`) as HTMLInputElement
        const ck_alasan_perpanjangan = document.getElementById(`ck-alasan-perpanjangan`) as HTMLInputElement
        const ck_tanggal_perpanjangan = document.getElementById(`ck-periode-perpanjangan`) as HTMLInputElement

        let temp = checkMandatoryApproval(ck_harga)
        if (temp == 'nothing') {
          let temparray: any[] = detailOrder2
          let temparray2: any[] = detailOrder
          let payload = detailOrder2[tempIndex]
          let payload2: any = detailOrder[tempIndex].amendment_orders
          let tempcheckdetector: any[] = checkDetector
          let enduser1: any = []
          let enduser2: any = []

          if (payload.end_user_multiple) {
            arrayEnduser.forEach((data: any) => {
              enduser1.push(data.value)
              enduser2.push(data.label)
            })
          } else {
            enduser1 = enduserDesc
            enduser2 = enduserDesc
          }

          if (ck_sales != null) {
            if (ck_sales.checked) tempcheckdetector[tempIndex].sales_org_code = true
            else tempcheckdetector[tempIndex].sales_org_code = false
          }

          if (ck_sektor != null){
            if (ck_sektor.checked) tempcheckdetector[tempIndex].sector_id = true
            else tempcheckdetector[tempIndex].sector_id = false
          }

          if (ck_incoterm1 != null){
            if (ck_incoterm1.checked) {
              // payload.incoterm1_id = tempData.incoterm1_id
              payload.incoterm1_id = incoterm1
              payload.incoterm1_desc = incoterm1Desc
              payload2[0].incoterm1_id = incoterm1
              payload2[0].incoterm1 = {code: incoterm1Desc, id: incoterm1}
              tempcheckdetector[tempIndex].incoterm1_id = true
            } else {
              payload.incoterm1_id = tempData2?.incoterm1_id
              payload.incoterm1_desc = tempData2?.incoterm1?.code
              tempcheckdetector[tempIndex].incoterm1_id = false
            }
          }

          if (ck_incoterm2 != null){
            if (ck_incoterm2.checked) {
              // payload.incoterm2_id = tempData.incoterm2_id
              payload.incoterm2_id = incoterm2
              payload.incoterm2_desc = incoterm2Desc
              payload2[0].incoterm2_id = incoterm2
              payload2[0].incoterm2 = {code: incoterm2Desc, id: incoterm2}
              tempcheckdetector[tempIndex].incoterm2_id = true
            } else {
              payload.incoterm2_id = tempData2?.incoterm2_id
              if (tempData2?.incoterm2_id == null || tempData2?.incoterm2_id == '0')
                payload.incoterm2_desc = tempData2?.incoterm2_id
              else payload.incoterm2_desc = tempData2?.incoterm2?.code

              tempcheckdetector[tempIndex].incoterm2_id = false
            }
          }

          if (ck_provinsi != null){
            if (ck_provinsi.checked) {
              payload.province_id = province
              payload.province_desc = provinceDesc
              payload2[0].province_id = tempData2?.province_id
              payload2[0].province_desc = tempData2.province?.region_name
              tempcheckdetector[tempIndex].province_id = true
            } else {
              payload.province_id = tempData2?.province_id
              payload.province_desc = tempData2.province?.region_name
              tempcheckdetector[tempIndex].province_id = false
            }
          }

          if (ck_kota != null){
            if (ck_kota.checked) {
              payload.city_id = city
              payload.city_desc = cityDesc
              payload2[0].city_id = tempData2?.city_id
              payload2[0].city_desc = tempData2.city?.city_name
              tempcheckdetector[tempIndex].city_id = true
            } else {
              payload.city_id = tempData2?.city_id
              payload.city_desc = tempData2.city?.city_name
              tempcheckdetector[tempIndex].city_id = false
            }
          }

          if (ck_jenis != null){
            if (ck_jenis.checked) {
              payload.product_type = ptype
              payload.product_type_desc = ptype2
              payload2[0].product_type = ptype
              payload2[0].product_type_desc = ptype2
              tempcheckdetector[tempIndex].product_type = true
            } else {
              payload.product_type = tempData2?.product_type
              payload.product_type_desc = tempData2?.product_type_desc
              tempcheckdetector[tempIndex].product_type = false
            }
          }

          if (ck_produk != null){
            if (ck_produk.checked) {
              payload.product_name = pname
              payload.material_number = pnumber
              payload.unit = punit
              payload2[0].product_name = pname
              payload2[0].material_number = pnumber
              payload2[0].unit = punit
              tempcheckdetector[tempIndex].product_name = true
            } else {
              payload.product_name = tempData2?.product_name
              payload.material_number = tempData2?.material_number
              payload.unit = tempData2?.unit
              tempcheckdetector[tempIndex].product_name = false
            }
          }

          let temprealized = 0
          let temprealizedbefore = 0

          if (tempData2.so_qty_realized == undefined) temprealized = quantum
          else temprealized = parseFloat(tempData2.so_qty_realized) + parseFloat(quantum)

          if (tempData2.is_so_release == true)
            temprealizedbefore =
              parseFloat(tempData2.fixed_quantum) - parseFloat(tempData2.so_qty_realized)
          else temprealizedbefore = tempData2.fixed_quantum

          if (ck_kuantum != null){
            if (ck_kuantum.checked) {
              payload.request_quantum = temprealized
              payload2[0].request_quantum = temprealized
              payload2[0].fixed_quantum = temprealized
              tempcheckdetector[tempIndex].request_quantum = true
            } else {
              payload.request_quantum = temprealizedbefore
              tempcheckdetector[tempIndex].request_quantum = false
            }
          }

          if (ck_harga != null){
            if (ck_harga.checked) {
              payload.request_price = parseFloat(subprice)
              payload2[0].request_price = parseFloat(subprice)
              tempcheckdetector[tempIndex].request_price = true
            } else {
              payload.request_price = tempData2?.fixed_price
              tempcheckdetector[tempIndex].request_price = false
            }
          }

          if (ck_ppn != null){
            if (ck_ppn.checked) {
              payload.include_ppn = includePPN
              payload2[0].include_ppn = includePPN
              tempcheckdetector[tempIndex].include_ppn = true
            } else {
              payload.include_ppn = tempData2?.include_ppn
              tempcheckdetector[tempIndex].include_ppn = false
            }
          }

          if (ck_payment1 != null){
            if (ck_payment1.checked) {
              payload.payment_type_1 = pay1
              payload.payment_type_1_desc = pay1Desc
              payload2[0].payment_type_1 = pay1
              payload2[0].payment_type_1_desc = pay1Desc
              tempcheckdetector[tempIndex].payment_type_1 = true
            } else {
              payload.payment_type_1 = tempData2?.payment_type_1
              payload.payment_type_1_desc = tempData2?.payment_type_1_desc
              tempcheckdetector[tempIndex].payment_type_1 = false
            }
          }

          if (ck_payment2 != null){
            if (ck_payment2.checked) {
              payload.payment_type_2 = pay2
              payload.payment_type_2_desc = pay2Desc
              payload2[0].payment_type_2 = pay2
              payload2[0].payment_type_2_desc = pay2Desc
              tempcheckdetector[tempIndex].payment_type_2 = true
            } else {
              payload.payment_type_2 = tempData2?.payment_type_2
              payload.payment_type_2_desc = tempData2?.payment_type_2_desc
              tempcheckdetector[tempIndex].payment_type_2 = false
            }
          }

          if (ck_segment != null){
            if (ck_segment.checked) {
              payload.segment_code = segment
              payload.segment_name = segmentDesc
              payload2[0].segment_code = segment
              payload2[0].segment_name = segmentDesc
              tempcheckdetector[tempIndex].segment_code = true
            } else {
              payload.segment_code = tempData2?.segment_code
              payload.segment_name = tempData2?.segment_name
              tempcheckdetector[tempIndex].segment_code = false
            }
          }

          if (ck_keterangan != null){
            if (ck_keterangan.checked) {
              payload.payment_note = keterangan
              payload2[0].payment_note = keterangan
              tempcheckdetector[tempIndex].payment_note = true
            } else {
              payload.payment_note = tempData2?.payment_note
              tempcheckdetector[tempIndex].payment_note = false
            }
          }

          if (ck_spek != null){
            if (ck_spek.checked) {
              payload.product_spec = pspec
              payload2[0].product_spec = pspec
              tempcheckdetector[tempIndex].product_spec = true
            } else {
              payload.product_spec = tempData2?.product_spec
              tempcheckdetector[tempIndex].product_spec = false
            }
          }

          if (ck_enduser != null){
            if (ck_enduser.checked) {
              payload.end_user = enduser1.toString()
              payload2[0].end_user = enduser1.toString()
              tempcheckdetector[tempIndex].end_user = true
            } else {
              payload.end_user = tempData2?.end_user
              tempcheckdetector[tempIndex].end_user = false
            }
          }

          if (ck_catatan != null){
            if (ck_catatan.checked) {
              payload.notes = note
              payload2[0].notes = note
              tempcheckdetector[tempIndex].notes = true
            } else {
              payload.notes = tempData2?.notes
              tempcheckdetector[tempIndex].notes = false
            }
          }

          if (ck_plant != null){
            if (ck_plant.checked) {
              payload.plant = tempData.plant
              payload.plant_desc = tempData.plant_desc
              payload.city_plant = tempData.city_plant
              payload2[0].plant = tempData.plant
              payload2[0].plant_desc = tempData.plant_desc
              payload2[0].city_plant = tempData.city_plant
              tempcheckdetector[tempIndex].plant = true
            } else {
              payload.plant = tempData.plant
              payload.plant_desc = tempData2.plant_desc
              payload.city_plant = tempData2.city_plant
              tempcheckdetector[tempIndex].plant = false
            }
          }

          if (ck_shipping != null){
            if (ck_shipping.checked) {
              payload.shipping_tolerance = shipping
              payload2[0].shipping_tolerance = shipping
              tempcheckdetector[tempIndex].shipping_tolerance = true
            } else {
              payload.shipping_tolerance = tempData2?.shipping_tolerance
              tempcheckdetector[tempIndex].shipping_tolerance = false
            }
          }

          if (ck_alasan_perpanjangan != null){
            if (ck_alasan_perpanjangan.checked) {
              payload.amandement_notes = alasan
              payload2[0].amandement_notes = alasan
              tempcheckdetector[tempIndex].amandement_notes = true
            } else {
              payload.amandement_notes = tempData2?.amandement_notes
              tempcheckdetector[tempIndex].amandement_notes = false
            }
          }
          if (ck_tanggal_perpanjangan != null){
            if (ck_tanggal_perpanjangan.checked) {
              payload.extension_date = tanggalPerpanjangan
              payload2[0].extension_date = tanggalPerpanjangan
              tempcheckdetector[tempIndex].extension_date = true
            } else {
              payload.extension_date = tempData2?.extension_date
              tempcheckdetector[tempIndex].extension_date = false
            }
          }

          // payload.amandement_notes = alasan
          // payload2[0].amandement_notes = alasan
          // payload.extension_date = tanggalPerpanjangan
          // payload2[0].extension_date = tanggalPerpanjangan

          temparray[tempIndex] = payload
          temparray2[tempIndex] = {
            ...temparray2[tempIndex],
            ...payload,
            amandment_orders: payload2
          }
          // console.log("detail", temparray, temparray2)
          
          setDetailOrder(temparray2)
          setDetailOrder2(temparray)
          setCheckDetector(tempcheckdetector)

          swal({
            title: t('dataBerhasilDiupdate'),
            icon: 'success',
          }).then(() => {
            setShowAmandemendApproval(false)
          })
        } else {
          swal({
            title: t(temp),
            icon: 'error',
          })
        }
      }
    })
  }

  const amandementReject = async () => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (reject) => {
      if (reject) {
        let tempid: any[] = []
        if (indexItem.length > 0) {
          indexItem.forEach((item: any) => {
            tempid.push(detailOrder2[item].order_sub_detail_id)
          })
        }

        if (indexItem2.length > 0) {
          addedItems.forEach((item: any) => {
            tempid.push(item.order_sub_detail_id)
          })
        }
        setBtnLoadingRej(true)
        await rejectAmandemen({
          order_submission_ids: tempid,
          reason: rejectNote,
          lang: i18next.language,
        })
          .then((res) => {
            swal({
              title: t(res.data.message),
              icon: 'success',
            }).then(() => {
              setIndexAmandement(0)
              setBtnLoadingRej(false)
              navigate('/management/order/all')
            })
          })
          .catch((error) => {
            swal({
              closeOnClickOutside: false,
              title: t(error.response.data.message),
              icon: 'error',
            })
            setBtnLoadingRej(false)
          })
          .finally(() => setBtnLoadingRej(false))
      }
    })
  }

  const sendApproveAmandemen = async () => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (accept) => {
      if (accept) {
        setBtnLoading(true)
        let payload: any[] = []
        if (indexItem.length > 0) {
          indexItem.forEach((item: any) => {
            payload.push({
              order_sub_detail_id: detailOrder2[item].order_sub_detail_id,
              sales_org_code: detailOrder2[item].sales_org_code,
              incoterm1_id: detailOrder2[item].incoterm1_id,
              incoterm2_id: detailOrder2[item].incoterm2_id,
              product_type: detailOrder2[item].product_type,
              product_type_desc: detailOrder2[item].product_type_desc,
              product_name: detailOrder2[item].product_name,
              product_spec: detailOrder2[item].product_spec,
              request_price: detailOrder2[item].request_price,
              request_quantum: detailOrder2[item].request_quantum,
              province_id: detailOrder2[item].province_id,
              city_id: detailOrder2[item].city_id,
              sector_id: detailOrder2[item].sector_id,
              include_ppn: detailOrder2[item].include_ppn,
              end_user: detailOrder2[item].end_user,
              segment_code: detailOrder2[item].segment_code,
              segment_name: detailOrder2[item].segment_name,
              plant: detailOrder2[item].plant,
              city_plant: detailOrder2[item].city_plant,
              notes: detailOrder2[item].notes,
              payment_type_1: detailOrder2[item].payment_type_1,
              payment_type_2: detailOrder2[item].payment_type_2,
              shipping_tolerance: detailOrder2[item].shipping_tolerance,
              material_number: detailOrder2[item].material_number,
              unit: detailOrder2[item].unit,
              payment_type_1_desc: detailOrder2[item].payment_type_1_desc,
              payment_type_2_desc: detailOrder2[item].payment_type_2_desc,
              payment_note: detailOrder2[item].payment_note,
              country: detailOrder2[item].country,
              country_desc: detailOrder2[item].country_desc,
              plant_desc: detailOrder2[item].plant_desc,
              end_user_multiple: detailOrder2[item].end_user_multiple,
              amandement_notes: detailOrder2[item].amandement_notes,
              extension_date: detailOrder2[item].extension_date,
            })
          })
        }

        if (indexItem2.length > 0) {
          indexItem2.forEach((item: any) => {
            payload.push({
              order_sub_detail_id: addedItems[item].order_sub_detail_id,
              sales_org_code: addedItems[item].sales_org_code,
              incoterm1_id: addedItems[item].incoterm1_id,
              incoterm2_id: addedItems[item].incoterm2_id,
              product_type: addedItems[item].product_type,
              product_type_desc: addedItems[item].product_type_desc,
              product_name: addedItems[item].product_name,
              product_spec: addedItems[item].product_spec,
              request_price: addedItems[item].request_price,
              request_quantum: addedItems[item].request_quantum,
              province_id: addedItems[item].province_id,
              city_id: addedItems[item].city_id,
              sector_id: addedItems[item].sector_id,
              include_ppn: addedItems[item].include_ppn,
              end_user: addedItems[item].end_user,
              segment_code: addedItems[item].segment_code,
              segment_name: addedItems[item].segment_name,
              plant: addedItems[item].plant,
              city_plant: addedItems[item].city_plant,
              notes: addedItems[item].notes,
              payment_type_1: addedItems[item].payment_type_1,
              payment_type_2: addedItems[item].payment_type_2,
              shipping_tolerance: addedItems[item].shipping_tolerance,
              material_number: addedItems[item].material_number,
              unit: addedItems[item].unit,
              payment_type_1_desc: addedItems[item].payment_type_1_desc,
              payment_type_2_desc: addedItems[item].payment_type_2_desc,
              payment_note: addedItems[item].payment_note,
              country: addedItems[item].country,
              country_desc: addedItems[item].country_desc,
              plant_desc: addedItems[item].plant_desc,
              end_user_multiple: addedItems[item].end_user_multiple,
              is_formulated_price: addedItems[item].is_formulated_price,
              amandement_notes: addedItems[item].amandement_notes,
              extension_date: addedItems[item].extension_date,
            })
          })
        }

        await approveAmandemen({order_submissions: payload})
          .then((res) => {
            swal({
              title: t(res.data.message),
              icon: 'success',
            }).then(() => {
              setIndexAmandement(0)
              setBtnLoading(false)
              // navigate('/management/order/all')
              if(payload.length == 1){
                dispath(setItemNego({id: payload[0].order_sub_detail_id, type: 'single', id_PO: orderNumber}))
              }else{
                dispath(setItemNego({id: params?.id || sessionStorage.getItem('po'), type: 'multiple', id_PO: orderNumber}))
              }
              navigate('/negotiate')
              // getDetail(true)
            })
          })
          .catch((error) => {
            swal({
              closeOnClickOutside: false,
              title: t(error.response.data.message),
              icon: 'error',
            })
            setBtnLoading(false)
          })
          .finally(() => setBtnLoading(false))
      }
    })
  }

  const sendReviseAmandemen = async () => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (accept) => {
      if (accept) {
        setBtnLoadingRef(true)
        let payload: any[] = []
        if (indexItem.length > 0) {
          indexItem.forEach((item: any) => {
            payload.push(detailOrder2[item].id)
          })
        }

        if (indexItem2.length > 0) {
          indexItem2.forEach((item: any) => {
            payload.push(addedItems[item].id)
          })
        }

        await reviseAmandemen({
          amendment_order_ids: payload,
          reason: revisionNote,
          lang: i18next.language,
        })
          .then((res) => {
            swal({
              title: t(res.data.message),
              icon: 'success',
            }).then(() => {
              setBtnLoadingRef(false)
              navigate('/management/order/all')
            })
          })
          .catch((error) => {
            swal({
              closeOnClickOutside: false,
              title: t(error.response.data.message),
              icon: 'error',
            })
            setBtnLoadingRef(false)
          })
          .finally(() => setBtnLoadingRef(false))
      }
    })
  }

  const checkMandatory = () => {
    if (produsen == '') return t('isi') + t('Sales Org')
    else if (
      (idSektor == 1 && arrayEnduser.length < 1 && isNoEnduser == false) ||
      (isNoEnduser == true && enduser == '') ||
      (idSektor != 1 && enduser == '')
    )
      return t('isi') + t('End Customer')
    else if (idSektor == 0) return t('isi') + t('Sector')
    else if (incoterm1 == 0) return t('isi') + 'Incoterm 1'
    else if (idSektor != 3 && province == 0) return t('isi') + t('Province')
    else if (idSektor != 3 && city == 0) return t('isi') + t('City')
    else if (ptype == '') return t('isi') + t('Product Type')
    else if (pnumber == '') return t('isi') + t('Product Name')
    else if (sektorID != 3 && segment == '') return t('isi') + t('segment')
    else if (isFormulatedPrice == false && (subprice == 0 || subprice == undefined))
      return t('isi') + t('Submission Price')
    else if (quantum == 0 || quantum == undefined) return t('isi') + t('Quantum')
    else if (pay1 == '') return t('isi') + t('Payment 1')
    // else if (shipping == 0 || Number.isNaN(shipping)) return 'Shipping Tolerance'
    // else if (Number.isNaN(shipping)) return t('shipping harus angka')
    else if (shipping > 100) return t('Shipping tolerance melebihi 100%')
    else return 'nothing'
  }

  const checkMandatoryApproval = (ckharga: any) => {
    if (
      (idSektor == 1 && arrayEnduser.length < 1 && isNoEnduser == false) ||
      (isNoEnduser == true && enduser == '') ||
      (idSektor != 1 && enduser == '')
    )
      return t('isi') + t('End Customer')
    else if (incoterm1 == 0) return t('isi') + 'Incoterm 1'
    else if (idSektor != 3 && province == 0) return t('isi') + t('Province')
    else if (idSektor != 3 && city == 0) return t('isi') + t('City')
    else if (ptype == '') return t('isi') + t('Product Type')
    else if (pnumber == '') return t('isi') + t('Product Name')
    else if (!tempData.is_formulated_price && subprice == 0) return t('isi') + t('Submission Price')
    else if (quantum == 0) return t('isi') + t('Quantum')
    else if (ckharga && tempData.fixed_quantum - tempData.so_qty_realized > quantum)
      return t('minamemdmentquantum')
    else if (pay1 == '') return t('isi') + t('Payment 1')
    // else if (shipping == 0 || Number.isNaN(shipping)) return 'Shipping Tolerance'
    // else if (Number.isNaN(shipping)) return t('shipping harus angka')
    else if (shipping > 100) return t('Shipping tolerance melebihi 100%')
    else return 'nothing'
  }

  const fieldClearer = (status: any) => {
    if (status > 0) {
      const hargap = document.getElementById('hargap') as HTMLInputElement
      if (hargap != null) hargap!.value = ''
      const ckformula = document.getElementById('formula_Price') as HTMLInputElement
      if (ckformula != null) ckformula.checked = false
      setSubprice(0)
      setIsFormulatedPrice(false)
      const kuantum = document.getElementById('kuantum') as HTMLInputElement
      if (kuantum != null) kuantum!.value = ''
      setQuantum(0)
      const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
      if (ckbox != null) ckbox.checked = false
      const shipping = document.getElementById('shipping') as HTMLInputElement
      if (shipping != null) shipping!.value = ''
      setShipping(0)
      if (status > 1) {
        setPname('')
        setPnumber('')
        setFullProductName([])
        if (status > 2) {
          const jenis = document.getElementById('jenis') as HTMLSelectElement
          if (jenis != null) jenis!.selectedIndex = 0
          setPtype('')
          setPtype2('')
          if (status > 3) {
            setWarehouse('')
            setWarehouseDesc('')
            setPlantcity('')
            if (status > 4) {
              setCity(0)
              setCityDesc('')
              if (status > 5) {
                setProvince(0)
                setProvinceDesc('')
                setCountry('')
                setCountryDesc('')
                if (status > 6) {
                  const note = document.getElementById('note') as HTMLInputElement
                  if (note != null) note!.value = ''
                  setNote('')
                  const pay1 = document.getElementById('payment1') as HTMLSelectElement
                  if (pay1 != null) pay1!.selectedIndex = 0
                  const pay2 = document.getElementById('payment2') as HTMLSelectElement
                  if (pay2 != null) pay2!.selectedIndex = 0
                  setPay1('')
                  setPay2('')
                  setPay1Desc('')
                  setPay2Desc('')
                  const enduser = document.getElementById('enduser') as HTMLInputElement
                  if (enduser != null) enduser!.value = ''
                  const enduser2 = document.getElementById('enduser2') as HTMLSelectElement
                  if (enduser2 != null) enduser2!.selectedIndex = 0
                  setEnduser('')
                  setEnduserDesc('')
                  setEnduserArray([])
                  setIsNoEnduser(false)
                  const segmen = document.getElementById('segment') as HTMLInputElement
                  if (segmen != null) segmen!.value = ''
                  setSegment('')
                  setSegmentDesc('')
                  const spek = document.getElementById('spek') as HTMLInputElement
                  if (spek != null) spek!.value = ''
                  setPspec('')
                  const keterangan = document.getElementById('keterangan') as HTMLInputElement
                  if (keterangan != null) keterangan!.value = ''
                  setketerangan('')
                  setIncoterm1(0)
                  setIncoterm2(0)
                  setIncoterm1Desc(0)
                  setIncoterm2Desc(0)
                  if (status > 7) {
                    const sektor = document.getElementById('sektor') as HTMLSelectElement
                    if (sektor != null) sektor!.selectedIndex = 0
                    setIDSector(0)
                    setSektorDesc('')
                  }
                }
              }
            }
          }
        }
      }
    } else if (status == 'province') {
      setCity(0)
      setCityDesc('')
    } else if (status == 'tipe') {
      setPname('')
      setPnumber('')
    }
  }

  const separateValue = (state: any, value: any, desc: any) => {
    const temp = value.split('~#~')
    state(temp[0])
    desc(temp[1])
  }

  const separateValue2 = (state: any, value: any, desc: any) => {
    const temp = value.split('~#~')
    state(temp[0] ? parseInt(temp[0]) : null)
    desc(temp[1])
  }

  //#region

  CustomUseEffect(() => {
    const priceListData2 = async () => {
      if (pnumber != '') {
        await getPriceList(localStorage.getItem('cust-code'), produsen, pnumber, city)
          .then((res) => {
            setSubprice(res.data.data.price)
          })
          .catch((error) => {
            swal({
              closeOnClickOutside: false,
              title: t(error.response.data.message),
              icon: 'error',
            })
          })
      }
    }
    if (retailFlag) {
      setSubprice(0)
      priceListData2()
    } else return
  }, [pnumber])

  //#endregion

  CustomUseEffect(() => {
    const productNameData = async () => {
      let tempwarehouse = warehouse
      if (tempwarehouse == null) tempwarehouse = ''
      await getProductName(tempwarehouse, disctribution, ptype, produsen, sektorID).then((res) => {
        setFullProductName(
          res.data.data.map((item: any) => {
            return {
              value: [
                item.material_number,
                item.material_description,
                item.base_of_measure,
              ].join('~#~'),
              label: parseInt(item.material_number) + " - " + item.material_description,
              truevalue: parseInt(item.material_number),
            }
          })
        )
      })
    }
    productNameData()
  }, [ptype2])

  CustomUseEffect(() => {
    reloadData()
    getprov()
    if (localStorage.getItem('cust-group') == 'AR06') plantData()
  }, [produsen])

  CustomUseEffect(() => {
    plantData()
  }, [province, country])

  CustomUseEffect(() => {
    const paymentData = async () => {
      await getAllPaymentList().then((res) => {
        setFullPayment(res.data.data)
      })
    }

    paymentData()
  }, [produsen])

  const [loadingAmend, setLoadingAmend] = useState(false)

  const handleAmandement = async (data: any) => {
    try {
      setLoadingAmend(true)
      await getSalesArea(localStorage.getItem('cust-code')).then((res) => {
        setSalesArea(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_org + '~#~' + item.distribution_channel + '~#~' + item.produsen?.name,
              label: item.produsen?.name,
            }
          })
        )
      })
      let tempsektor = ''
      if (sektorID != 0) tempsektor = String(sektorID)
      await getProductName(
        '',
        disctribution,
        data?.product_type,
        data?.produsen?.code,
        tempsektor
      ).then((res) => {
        setFullProductName(
          res.data.data.map((item: any) => {
            return {
              value: item.material_number + '~#~' + item.material_description,
              label: parseInt(item.material_number) + " - " + item.material_description,
              truevalue: parseInt(item.material_number),
            }
          })
        )
      })
      await getCity(data?.province_id).then((res) => {
        setFullCity(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.value,
              label: item.value,
            }
          })
        )
      })
      await getPlant(data?.produsen?.code, disctribution, data?.province_id, {
        city_code: data?.city_id
      }).then((res) => {
        setFullPlant(
          res.data.data.map((item: any) => {
            return {
              value: item.plant + '~#~' + item.plant_name + '~#~' + item.city_name,
              label: item.plant + '-' + item.plant_name,
            }
          })
        )
      })

      let options: Record<string, any> = {}
      if(data.sector_id == 2) options.customer_code = localStorage.getItem("cust-code")
      await getProvince3(options).then((res) => {
        setFullProvince(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_office + '~#~' + item.controlling_area,
              label: item.controlling_area,
            }
          })
        )
      })
      await getAllPaymentList().then((res) => {
        setFullPayment(res.data.data)
      })
      await getCusGrup().then((res) => {
        setFullSegment(res.data.data)
      })
      try {
        await getEndUser('').then((res) => {
          setFullEndUser(res.data.data)
        })
      } catch {}
      setLoadingAmend(false)
    } catch {
      setLoadingAmend(false)
    }
  }

  const setState = async (item: any) => {
    clearState()
    if (!item.end_user_multiple) {
      setIsNoEnduser(true)
      setEnduserArray([])
      setEnduserDesc(item.end_user)
      setEnduser(item.end_user)
    } else {
      const tempenduser = item.end_user.split(',')
      const temparray: any = []
      tempenduser.forEach((items: any, _index: any) => {
        let temp = {label: items, value: items}
        temparray.push(temp)
      })
      setIsNoEnduser(false)
      setEnduserArray(temparray)
    }
    setItemNumber(item.item_number)
    setProdusen(item.sales_org_code)
    setProdusen(item.sales_org_code)
    setIsFormulatedPrice(item.is_formulated_price)
    setSegment(item.segment_code)
    setSegmentDesc(item.segment_name)
    setIDSector(item.sector_id)
    setIncoterm1(item.incoterm1_id)
    setIncoterm2(item.incoterm2_id)
    setProvince(item.province_id)
    setCountry(item.country)
    setCountryDesc(item.country_desc)
    setCity(item.city_id)
    setCityDesc(item.city?.city_name)
    setWarehouse(item.plant)
    setWarehouseDesc(item.plant_desc)
    setPnumber(item.material_number)
    setPunit(item.unit)
    setPtype(item.product_type)
    setPtype2(item.product_type_desc)
    setNote(item.notes)
    setketerangan(item.payment_note)
    setPname(item.product_name)
    setPspec(item.product_spec)
    setSubprice(item.ischanged ? item.request_price : item.fixed_price)
    if (item.so_qty_realized == undefined) {
      setQuantum(item.ischanged ? item.request_quantum : item.fixed_quantum)
      setMinQuantum(item.ischanged ? item.request_quantum : item.fixed_quantum)
    } else {
      setQuantum(
        parseFloat(item.ischanged ? item.request_quantum : item.fixed_quantum) -
          parseFloat(item.so_qty_realized)
      )
      setMinQuantum(
        parseFloat(item.ischanged ? item.request_quantum : item.fixed_quantum) -
          parseFloat(item.so_qty_realized)
      )
    }
    setPay1(item.payment_type_1)
    setPay2(item.payment_type_2)
    setPay1Desc(item.payment_type_1_desc)
    setPay2Desc(item.payment_type_2_desc)
    setPlantcity(item.city_plant)
    setShipping(item.shipping_tolerance)
    setProdusenDesc(item.produsen?.name)
    setSektorDesc(item.sector?.name)
    setIncoterm1Desc(item.incoterm1?.code)
    setTanggalPerpanjangan(item.extension_date)
    setAlasan(item.amandement_notes)
    if (item.incoterm2 == null) setIncoterm2Desc(item.incoterm2_id)
    else setIncoterm2Desc(item.incoterm2?.code)
    setProvinceDesc(item.province?.region_name)
    reloadData()

    if (isCreating) {
      setShowAmandemend(true)
      // const munculEdit = setTimeout(() => {
      //   // setEnduser(item.end_user)
      // }, 4000)
      // return () => clearTimeout(munculEdit)
    } else {
      setShowEditNewProduct(true)
      // const munculEdit = setTimeout(() => {
      // }, 4000)
      // return () => clearTimeout(munculEdit)
    }
  }

  const setState2 = async (item: any, item2: any) => {
    setLoading(true)
    clearState()
    setItemNumber(item.item_number)
    setProdusen(item.sales_org_code)
    if (item.end_user_multiple) setIsNoEnduser(false)
    else setIsNoEnduser(true)
    if (!item.end_user_multiple) {
      setEnduserArray([])
      setEnduser(item.end_user)
      setEnduserDesc(item.end_user)
    } else {
      const tempenduser = item.end_user.split(',')
      const temparray: any = []
      tempenduser.forEach((items: any, _index: any) => {
        let temp = {label: items, value: items}
        temparray.push(temp)
      })
      setEnduserArray(temparray)
    }
    setQuantum(item.request_quantum)
    setIsFormulatedPrice(item.is_formulated_price)
    setSegment(item.segment_code)
    setSegmentDesc(item.segment_name)
    setIDSector(item.sector_id)
    setIncoterm1(item.incoterm1_id)
    setIncoterm2(item.incoterm2_id)
    setProvince(item.province_id)
    setCountry(item.country)
    setCountryDesc(item.country_desc)
    setCity(item.city_id)
    setCityDesc(item2.city_id)
    setWarehouse(item.plant)
    setWarehouseDesc(item.plant_desc)
    setPnumber(item.material_number)
    setPunit(item.unit)
    setPtype(item.product_type)
    setPtype2(item.product_type_desc)
    setNote(item.notes)
    setketerangan(item.payment_note)
    setPname(item.product_name)
    setPspec(item.product_spec)
    setSubprice(item.request_price)
    setPay1(item.payment_type_1)
    setPay2(item.payment_type_2)
    setPay1Desc(item.payment_type_1_desc)
    setPay2Desc(item.payment_type_2_desc)
    setPlantcity(item.city_plant)
    setShipping(item.shipping_tolerance)
    setProdusenDesc(item2.sales_org_code)
    setSektorDesc(item2.sector_id)
    setIncoterm1Desc(item2.incoterm1_id)
    setIncoterm2Desc(item2.incoterm2_id)
    setProvinceDesc(item2.province_id)
    setLoading(false)
    reloadData()
    try {
      setLoading(true)
      await getSalesArea(localStorage.getItem('cust-code')).then((res) => {
        setSalesArea(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_org + '~#~' + item.distribution_channel + '~#~' + item.produsen?.name,
              label: item.produsen?.name,
            }
          })
        )
      })
      let tempsektor = ''
      if (sektorID != 0) tempsektor = String(sektorID)
      await getProductName(
        '',
        disctribution,
        item?.product_type,
        item?.sales_org_code,
        tempsektor
      ).then((res) => {
        setFullProductName(
          res.data.data.map((item: any) => {
            return {
              value: item.material_number + '~#~' + item.material_description,
              label: parseInt(item.material_number) + " - " + item.material_description,
              truevalue: parseInt(item.material_number),
            }
          })
        )
      })
      await getCity(item?.province_id).then((res) => {
        setFullCity(
          res.data.data.map((item: any) => {
            return {
              value: item.id + '~#~' + item.value,
              label: item.value,
            }
          })
        )
      })
      await getPlant(item?.sales_org_code, disctribution, item?.province_id, {
        city_code: item?.city_id
      }).then((res) => {
        setFullPlant(
          res.data.data.map((item: any) => {
            return {
              value: item.plant + '~#~' + item.plant_name + '~#~' + item.city_name,
              label: item.plant + '-' + item.plant_name,
            }
          })
        )
      })

      let options: Record<string, any> = {}
      if(item.sector_id == 2) options.customer_code = localStorage.getItem("cust-code")
      await getProvince3(options).then((res) => {
        setFullProvince(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_office + '~#~' + item.controlling_area,
              label: item.controlling_area,
            }
          })
        )
      })
      await getAllPaymentList().then((res) => {
        setFullPayment(res.data.data)
      })
      await getCusGrup().then((res) => {
        setFullSegment(res.data.data)
      })
      try {
        await getEndUser('').then((res) => {
          setFullEndUser(res.data.data)
        })
      } catch {}
      setLoading(false)
    } catch {
      setLoading(false)
    }
    const munculEdit = setTimeout(() => {
      // setEnduser(item.end_user)
      setShowEditNewProduct(true)
    }, 4000)
    return () => clearTimeout(munculEdit)
  }

  const clearState = () => {
    setEnduser('')
    setEnduserDesc('')
    setIDSector(0)
    setIncoterm1(0)
    setIncoterm2(0)
    setProvince(0)
    setCountry('')
    setCountryDesc('')
    setCity(0)
    setWarehouse('')
    setWarehouseDesc('')
    setSegment('')
    setSegmentDesc('')
    setPtype('')
    setPname('')
    setPnumber('')
    setPspec('')
    setSubprice(0)
    setQuantum(0)
    setPay1('')
    setPay2('')
    setketerangan('')
    setShipping(0)
    setEnduserArray([])
    setIsChanged(false)
    setNewProductFlag(false)
    setIsFormulatedPrice(false)
    setPlantcity('')
    if (localStorage.getItem('cust-group') == 'AR06') {
      setIDSector(3)
      setSektorDesc('Export')
    }
  }

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const handleShowEndUser = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return <label>{temp}</label>
  }

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const onclickCheckBox = (value: any) => {
    const temp = value.split('~#~')
    const tempIndex: string[] = [...indexItem]
    const tempArray: string[] = [...itemIndex]
    if (!tempIndex.includes(temp[1])) {
      tempArray.push(temp[0])!
      tempIndex.push(temp[1])!

      setItemIndex(tempArray)
      setIndexItem(tempIndex)
    } else {
      const tempindex = tempArray.indexOf(temp[0])!
      const tempIndexindex = tempIndex.indexOf(temp[1])!
      tempIndex.splice(tempIndexindex, 1)
      tempArray.splice(tempindex, 1)

      setItemIndex(tempArray)
      setIndexItem(tempIndex)
    }

    // console.log(amandemenPresent)
    // if (tempIndex.length != 0) setButtonFlag(true)
    // else setButtonFlag(false)
    // console.log(isChecked.value)
    if (tempIndex.length > 0) setButtonFlag(true)
    else setButtonFlag(false)
  }

  const onclickCheckBox2 = (index: any) => {
    const isChecked = document.getElementById(`checkbox-new-item-${index}`) as HTMLInputElement
    const temp = isChecked.value
    const tempIndex: string[] = indexItem2
    if (isChecked.checked) {
      tempIndex.push(index)
    } else {
      const tempIndexindex = tempIndex.indexOf(index)
      tempIndex.splice(tempIndexindex, 1)
    }
    setIndexItem2(tempIndex)

    if (tempIndex.length > 0) setButtonFlag2(true)
    else setButtonFlag2(false)
  }

  CustomUseEffect(() => {
    // console.log(indexItem.length, addedItems.length)
    if (indexItem.length > 0) setButtonFlag(true)
    else setButtonFlag(false)
  }, [addedItems])

  const removeSubOrder = (index: any) => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        const tempArray: any[] = [...addedItems]
        const tempArray2: string[] = [...addedItems2]
        tempArray.splice(index, 1)
        tempArray2.splice(index, 1)

        setAddedItems(tempArray)
        setAddedItems2(tempArray2)
        swal({
          title: `${t('deleted successfully')}`,
          icon: 'success',
        })
      }
    })
  }

  const [loadingDetail, setLoadingDetail] = useState(false)
  const handleDataForApprovalAmandemen = async (item: any) => {
    clearState()
    setShowAmandemendApproval(true)
    setLoadingDetail(true)

    setAlasan(item.amandement_notes)
    setTanggalPerpanjangan(item.extension_date)
    let options: Record<string, any> = {}
    if(item?.sector_id == 2) options.customer_code = localStorage.getItem("cust-code")

    await getIncoterm().then((res) => {
      let temparray: any[] = [{value: '~#~', label: t('Pilih-incoterm')}]
      res.data.data.forEach((item: any) => {
        temparray.push({value: item.id + '~#~' + item.code, label: item.code})
      })
      setFullIncoterm(
        res.data.data.map((item: any) => {
          return {
            value: item.id + '~#~' + item.code,
            label: item.code,
          }
        })
      )
      // console.log(temparray)
      setFullIncoterm2(temparray)
    })

    await getProvince3(options).then((res) => {
      setFullProvince(
        res.data.data.map((item: any) => {
          return {
            value: item.sales_office + '~#~' + item.controlling_area,
            label: item.controlling_area,
          }
        })
      )
    })

    await getCity(item.province_id).then((res) => {
      setFullCity(
        res.data.data.map((item: any) => {
          return {
            value: item.id + '~#~' + item.value,
            label: item.value,
          }
        })
      )
    })

    await getProductType('').then((res) => {
      setFullProductType(res.data.data)
    })

    await getAllPaymentList().then((res) => {
      setFullPayment(res.data.data)
    })
    await getCusGrup().then((res) => {
      setFullSegment(res.data.data)
    })

    await getProductName(
      '',
      disctribution,
      item?.product_type,
      item?.sales_org_code,
      item.sector_id
    ).then((res) => {
      setFullProductName(
        res.data.data.map((data: any) => {
          return {
            value: data.material_number + '~#~' + data.material_description,
            label: parseInt(data.material_number) + " - " + data.material_description,
            truevalue: parseInt(data.material_number),
          }
        })
      )
    })

    await getEndUser('').then((res) => {
      setFullEndUser(res.data.data)
    })

    setIncludePPN(item.include_ppn)
    setIncoterm1(item.incoterm1_id)
    setIncoterm1Desc(item.incoterm1?.code)
    setIncoterm2(item.incoterm2_id == 0 ? null : item.incoterm2_id)
    setIncoterm2Desc(
      item?.incoterm2 != null
        ? item?.incoterm2.code
        : item.incoterm2_id != null
        ? item.incoterm2_id
        : ''
    )

    setProvince(item.province?.id)
    setProvinceDesc(item.province?.region_name)
    setCity(item.city?.id)
    setCityDesc(item.city?.city_name)

    if (item.sector_id == 1) {
      // setProvince(item.province?.id)
      // setProvinceDesc(item.province?.region_name)
      // setCity(item.city?.id)
      // setCityDesc(item.city?.city_name)
    } else {
      setCountry(item.country)
      setCountryDesc(item.country_desc)
    }
    setSegment(item.segment_code)
    setSegmentDesc(item.segment_name)
    setPtype(item.product_type)
    setPtype2(item.product_type_desc)
    setPnumber(item.material_number)
    setPunit(item.unit)
    setPname(item.product_name)
    setSubprice(item.request_price)
    setShipping(item.shipping_tolerance)
    setPay1(item.payment_type_1)
    setPay2(item.payment_type_2)
    setPay1Desc(item.payment_type_1_desc)
    setPay2Desc(item.payment_type_2_desc)
    setPlantcity(item.city_plant)
    setketerangan(item.payment_note)
    setPspec(item.product_spec)
    setNote(item.notes)
    setQuantum(item.request_quantum - parseFloat(item.quantum_realisazied))
    if (item.end_user_multiple) setIsNoEnduser(false)
    else setIsNoEnduser(true)
    if (!item.end_user_multiple) {
      setEnduserArray([])
      setEnduser(item.end_user)
      setEnduserDesc(item.end_user)
    } else {
      const tempenduser = item.end_user.split(',')
      const temparray: any = []
      tempenduser.forEach((items: any, _index: any) => {
        let temp = {label: items, value: items}
        temparray.push(temp)
      })
      setEnduserArray(temparray)
    }

    setLoadingDetail(false)
  }

  const handleShowAttachmentHeader = async () => {
    getFile('header', ID, localStorage.getItem('credential')!).then((res) => {
      setFullHeader(res.data.data)
      setShowHeader(true)
    })
  }

  const [loadingUpload, setLoadingUpload] = useState(false)

  const handleUploadHeader = async () => {
    const checkvalidasi = validasiFile()
    if (checkvalidasi == 'nothing') {
      let temparray: any[] = []
      if (tempRole.length > 0) {
        tempRole.forEach((data: any) => {
          temparray.push(data.value)
        })
      }

      let tempObject = {
        file_r: files,
        name: namaFile,
        description: description,
        file_type: dataType,
        private: isPrivate,
        roles: temparray,
        is_new: true
      }
      let tempArray = [...stateFileHeader]
      tempArray.push(tempObject)

      setStateFileHeader(tempArray)
      swal({
        title: `${t('document uploaded successfully')}`,
        icon: 'success',
      })

      // try{
      //   await create('amandemen', formdata)
      //   clearInputUpload()
      //   removeFileState()

      //   handleShowAttachmentHeader()

      //   setLoadingUpload(false)
      //   swal({
      //     title: `${t('document uploaded successfully')}`,
      //     icon: 'success',
      //   })
      // }catch(e: any){
      //   console.log(e)
      //   setLoadingUpload(false)
      //   if (e.response) {
      //     swal({
      //       title: t(e.response.data.message),
      //       icon: 'error',
      //     })
      //   }
      // }

    } else {
      swal({
        title: t('isi') + checkvalidasi,
        icon: 'error',
      })
    }
  }
  const handleDeleteUploadHeader2 = (index: number) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
    const _files = [...stateFileHeader];
    _files.splice(index, 1)
    setStateFileHeader(_files)
        }})
  }

  const [selectedItemForComment, setSelectedItemForComment] = useState('')
  const handleShowComment = async (id: any, status: any) => {
    setShowComment(true)
    setSelectedItemForComment(id)
    
    let temp = 'order'
    if (status) temp = 'amendment_notes'
    else temp = 'order'
    await getCommentOrder(id, 'order_submission').then((res) => {
      setFullComment(res.data.data)
    })
  }

  const handleProfileCustomer = () => {
    const curpo_AllAndalan = async () => {
      let tempaging: any[] = []
      let tempoutstanding: any[] = []
      let tempinvoices: any[] = invoices
      let temptotal: any[] = totalInvoices
      const res = await axios.get(
        `${process.env.REACT_APP_PI_BACKEND_API_MASTERDATA}/customer/profiling/${customerCode}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )

      setCustStatus({
        customer_address: res.data.data.customerprofile?.customer_address,
        customer_id: res.data.data.customerprofile?.customer_id,
        customer_name: res.data.data.customerprofile?.customer_name,
        status: res.data.data.customerprofile?.status,
      })

      if (res.data.data.customerprofile?.billing_due.length > 0) {
        res.data.data.customerprofile?.billing_due.forEach((element: any) => {
          if (element.aging == '0 - 30 days') {
            element.invoice.forEach((elementInvoice: any) => {
              if (elementInvoice.company == 'B000')
                tempinvoices[0].B000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'C000')
                tempinvoices[0].C000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'D000')
                tempinvoices[0].D000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'E000')
                tempinvoices[0].E000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'F000')
                tempinvoices[0].F000 = elementInvoice.billing_due_count
            })
          } else if (element.aging == '31 - 90 days') {
            element.invoice.forEach((elementInvoice: any) => {
              if (elementInvoice.company == 'B000')
                tempinvoices[1].B000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'C000')
                tempinvoices[1].C000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'D000')
                tempinvoices[1].D000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'E000')
                tempinvoices[1].E000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'F000')
                tempinvoices[1].F000 = elementInvoice.billing_due_count
            })
          } else if (element.aging == '91 - 365 days') {
            element.invoice.forEach((elementInvoice: any) => {
              if (elementInvoice.company == 'B000')
                tempinvoices[2].B000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'C000')
                tempinvoices[2].C000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'D000')
                tempinvoices[2].D000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'E000')
                tempinvoices[2].E000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'F000')
                tempinvoices[2].F000 = elementInvoice.billing_due_count
            })
          } else if (element.aging == '>365 days') {
            element.invoice.forEach((elementInvoice: any) => {
              if (elementInvoice.company == 'B000')
                tempinvoices[3].B000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'C000')
                tempinvoices[3].C000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'D000')
                tempinvoices[3].D000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'E000')
                tempinvoices[3].E000 = elementInvoice.billing_due_count
              else if (elementInvoice.company == 'F000')
                tempinvoices[3].F000 = elementInvoice.billing_due_count
            })
          }
        })
      }
      tempinvoices.forEach((element: any, index: any) => {
        temptotal[index] += element.B000
        temptotal[index] += element.C000
        temptotal[index] += element.D000
        temptotal[index] += element.E000
        temptotal[index] += element.F000
      })
      setInvoices(tempinvoices)
      setTotalInvoices(temptotal)
    }

    curpo_AllAndalan().then(() => {
      setShowCustPro(true)
    })
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  function handleShowRoleNameFromState(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length)
        temp = temp + fullRole[fullRole.findIndex((item: any) => item.value == element)].label
      else
        temp =
          temp + fullRole[fullRole.findIndex((item: any) => item.value == element)].label + ', '
    })
    return temp
  }

  const [loadingPostChat, setLoadingPostChat] = useState(false)
  const [tempChat, setTempChat] = useState('')

  const handlePostChat = async () => {
    setLoadingPostChat(true)
    await postChatOrder(
      i18next.language,
      {
        parent_id: selectedItemForComment,
        user_id: localStorage.getItem('user-id'),
        comment: tempChat,
        credentials: localStorage.getItem('credential'),
      },
      'order_submission'
    )
      .then((res: any) => {
        swal({
          title: `${t('Chat Berhasil Ditambahkan')}`,
          icon: 'success',
        }).then(() => {
          getCommentOrder(selectedItemForComment, 'order_submission').then((res) => {
            setFullComment(res.data.data)
          })

          setTempChat('')
          const areacomment = document.getElementById('areachat') as HTMLInputElement
          if (areacomment != null) areacomment.value = ''
        })
      })
      .catch((error: any) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setLoadingPostChat(false)
      })
  }

  const [editIncludePPN, setEditIncludePPN] = useState(false)

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {t('page detail order amandemen')}
      </PageTitle>
      <div className='card'>
        {/* begin::Header */}
        {/* <button onClick={() => {
          dispath(setItemNego({id: 8843, type: 'single'}))
          navigate('/negotiate')
        }}>klik me</button> */}

        {loading ? (
          <div className='card-body p-5'>
            <SkeletonOrderDetail />
          </div>
        ) : (
          <>
            {(roleUser == null || roleUser == 'null') || (isCreating) ? (
              <div className='card-body mt-8'>
                <Row>
                  <Col md={6}>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 me-2'>{t('order-perihal')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Select aria-label='Default select example' size='sm' disabled>
                          {regarding == 'PO002' ? (
                            <option selected disabled hidden>
                              {t('Non-penjualan')}
                            </option>
                          ) : (
                            <option selected disabled hidden>
                              {t('penjualan')}
                            </option>
                          )}
                        </Form.Select>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control type='text' value={customerCode} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control type='text' value={customerName} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Address')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control as='textarea' value={customerAddress} disabled size='sm' />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row className='mb-3'>
                      <Col lg={4}>
                        <p className='fs-4 mt-2'>{t('Order Number')}</p>
                      </Col>
                      <Col lg={8}>
                        <Form.Control
                          type='text'
                          value={orderNumber == '' ? '' : '10' + orderNumber}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Phone Number')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control type='text' value={phoneNumber} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Email')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control type='text' value={emailCust} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('PIC Customer')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control type='text' value={PICCust} disabled size='sm' />
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <hr className='my-0' />

                <div className='mt-2 d-flex'>
                  <Button
                    className='btn btn-primary me-2'
                    hidden={numberRevisedItem > 0 ? true : false}
                    onClick={() => handleTambahProduct()}
                  >
                    {t('+tambah product')}
                  </Button>
                  <Button
                    variant='primary'
                    onClick={() => handleShowAttachmentHeader()}
                    className='btn btn-primary me-2'
                  >
                    {numberRevisedItem > 0 ? t('order-lampiran') : t('order-lampiranUpload')}
                  </Button>
                </div>

                <div className='table-responsive bdr mt-2' style={{marginTop: '2rem'}}>
                  {/* Table Head */}
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='border-bottom'>
                      <tr className='fw-bold  d-flex jusify-content-center w-100 align-items-center'>
                        <th className='td-order-1 text-center'>{t('pilih')}</th>
                        <th className='td-order-1 text-center'>{t('sub-order-item')}</th>
                        <th className='td-order-2 text-center'>{t('sip-number')}</th>
                        <th className='td-order-2 text-center'>{t('kontrak-nomor')}</th>
                        <th className='td-order-2 text-center'>Status</th>
                        <th className='td-order-4 text-center'>{t('order-aksi')}</th>
                        <th className='td-order-4 text-center'>Sales Org</th>
                        <th className='td-order-2 text-center'>{t('sub-order-incoterm')}</th>
                        {sektorID != 3 ? (
                          <th className='td-order-2 text-center'>{t('sub-order-wilayah')}</th>
                        ) : (
                          ''
                        )}
                        {sektorID == 1 ? (
                          <th className='td-order-2 text-center'>{t('segment')}</th>
                        ) : (
                          ''
                        )}
                        <th className='td-order-2 text-center'>{t('End Customer')}</th>
                        <th className='td-order-2 text-center'>{t('sub-order-jenis')}</th>
                        <th className='td-order-2 text-center'>{t('Product Code')}</th>
                        <th className='td-order-2 text-center'>{t('sub-order-produk')}</th>
                        <th className='td-order-2 text-center'>{t('sub-order-spek')}</th>
                        <th className='td-order-2 text-center'>{t('Kuantum Pengajuan')}</th>
                        <th className='td-order-2 text-center'>{t('sub-order-kuantumD')}</th>
                        <th className='td-order-2 text-center'>
                          {underAmandment ? t('Quantum') : t('remaining quantum')}
                        </th>
                        <th className='td-order-2 text-center'>{t('Price')}</th>
                        {sektorID == 1 && (
                          <th className='td-order-2 text-center'>Status {t('Price')}</th>
                        )}
                        {sektorID == 2 ? (
                          <th className='td-order-2 text-center'>{t('sub-order-gudang')}</th>
                        ) : (
                          ''
                        )}
                      </tr>
                    </thead>
                    {detailOrder.map((item, _index) => (
                      <>
                        {(item.is_amendment == false || item.amendment_status == 2) && (
                          <tbody>
                            <tr
                              className={
                                item.ischanged
                                  ? 'd-flex jusify-content-center w-100 align-items-center bg-secondary'
                                  : 'd-flex jusify-content-center w-100 align-items-center'
                              }
                            >
                              <td className='td-order-1 text-center column'>
                                <div className='py-3'>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    id={'checkbox' + _index}
                                    defaultChecked={itemIndex.includes(item.id)}
                                    value={item.id + '~#~' + _index}
                                    onClick={() => onclickCheckBox(item.id + '~#~' + _index)}
                                  />
                                </div>
                              </td>
                              <td className='td-order-1 text-center column'>
                                <div className='fs-6 py-3'>{_index + 1}</div>
                              </td>
                              <td className='td-order-2 text-center column'>
                                <div className='fs-6 py-3'>
                                  {item.sip_number == null || item.sip_number == '' ? (
                                    <label className='opacity-0'>-</label>
                                  ) : (
                                    '11' + item.sip_number
                                  )}
                                </div>
                              </td>
                              <td className='td-order-2 text-center column'>
                                <div className='fs-6 py-3'>
                                  {item.contract_number == null || item.contract_number == '' ? (
                                    <label className='opacity-0'>-</label>
                                  ) : (
                                    '12' + item.contract_number
                                  )}
                                </div>
                              </td>
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {item['status'] == '0' ? (
                                    <span className='badge badge-light-success'>
                                      {t(item['status_text'])}
                                    </span>
                                  ) : item['status'] == '1' ? (
                                    <span className='badge badge-light-primary'>
                                      {t(item['status_text'])}
                                    </span>
                                  ) : item['status'] == '2' ? (
                                    <span className='badge badge-light-warning'>
                                      {t(item['status_text'])}
                                    </span>
                                  ) : item['status'] == '3' ? (
                                    <span className='badge badge-light-warning'>
                                      {t(item['status_text'])}
                                    </span>
                                  ) : item['status'] == '4' ? (
                                    <span className='badge badge-light-success'>
                                      {t(item['status_text'])}
                                    </span>
                                  ) : item['status'] == '5' ? (
                                    <span className='badge badge-light-success'>
                                      {t(item['status_text'])}
                                    </span>
                                  ) : item['status'] == '6' ? (
                                    <span className='badge badge-light-success'>
                                      {t(item['status_text'])}
                                    </span>
                                  ) : (
                                    <span className='badge badge-light-danger'>
                                      {t(item['status_text'])}
                                    </span>
                                  )}
                                </span>
                              </td>
                              <td className='td-order-4 text-center column'>
                                <div>
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title='Detail'
                                    // disabled={
                                    //   indexAmandement != 0
                                    //     ? indexAmandement == _index + 1
                                    //       ? false
                                    //       : true
                                    //     : false
                                    // }
                                    onClick={() => {
                                      setTempDetail(item)
                                      setTempData(item)
                                      handleShow()
                                    }}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/file-text-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>

                                  {regarding == 'PO001' ? (
                                    <>
                                      <button
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        data-bs-toggle='tooltip'
                                        data-bs-placement='top'
                                        data-bs-trigger='hover'
                                        title={t('Jadwal')}
                                        // disabled={
                                        //   indexAmandement != 0
                                        //     ? indexAmandement == _index + 1
                                        //       ? false
                                        //       : true
                                        //     : false
                                        // }
                                        onClick={() => {
                                          setSektor(item.sector_id)
                                          setSubID(item.id)
                                          setIsChanged(true)
                                          setNewProductFlag(false)
                                          setProvinceDesc(item.province?.region_name)
                                          setCityDesc(item.city?.city_name)
                                          setPname(item.product_name)
                                          if (item.so_qty_realized == undefined) {
                                            setQuantum(
                                              item.ischanged ? item.request_quantum : item.fixed_quantum
                                            )
                                            formattingTon(
                                              item.ischanged ? item.request_quantum : item.fixed_quantum
                                            )
                                          } else {
                                            setQuantum(
                                              parseFloat(
                                                item.ischanged
                                                  ? item.request_quantum
                                                  : item.fixed_quantum
                                              ) - parseFloat(item.so_qty_realized)
                                            )
                                            formattingTon(
                                              parseFloat(
                                                item.ischanged
                                                  ? item.request_quantum
                                                  : item.fixed_quantum
                                              ) - parseFloat(item.so_qty_realized)
                                            )
                                          }
                                          handleShow3(item['id'])
                                          setFixedQuantum(
                                            item.ischanged ? item.request_quantum : item.fixed_quantum
                                          )
                                          setTempIndex(_index)
                                          setTempJadwal(item.schedules)
                                          sessionStorage.setItem('isCustomer', 'false')
                                        }}
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/calendar-check-fill.svg'
                                          className='svg-icon-3'
                                        />
                                      </button>
                                    </>
                                  ) : (
                                    ''
                                  )}

                                  <button
                                    onClick={() => {
                                      setIsFileBox(item)
                                      ambilAttachment(item.id, item.id)
                                      setIDAttachments([item.id, item.id])
                                      setTempIndex(_index)
                                      setIsChanged(item.ischanged)
                                      setNewProductFlag(false)
                                      if (item.ischanged) setOrderItemsFiles(item.attachments)
                                      removeFileState()
                                    }}
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('order-lampiran')}
                                    // disabled={
                                    //   indexAmandement != 0
                                    //     ? indexAmandement == _index + 1
                                    //       ? false
                                    //       : true
                                    //     : false
                                    // }
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/archive-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>

                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('amandement')}
                                    // disabled={
                                    //   indexAmandement != 0
                                    //     ? indexAmandement == _index + 1
                                    //       ? false
                                    //       : true
                                    //     : false
                                    // }
                                    onClick={() => {
                                      handleAmandement(item)
                                      setTempData(item)
                                      setTempIndex(_index)
                                      setState(item)
                                      setSubID(item.id)
                                    }}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/pencil-square.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>

                                  <button
                                    onClick={() => {
                                      if (item.amendment_status == 2) {
                                        handleShowComment(item.id, true)
                                      } else {
                                        handleShowComment(item.id, false)
                                      }
                                    }}
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Comment')}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/chat-left-text-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                </div>
                              </td>
                              <td className='td-order-4 text-center column'>
                                <div className='fs-6 py-3'>{item.produsen?.name}</div>
                              </td>
                              {item.sector?.id == 2 ? (
                                <>
                                  {item.incoterm2 == null ? (
                                    <td className='td-order-2 text-center column'>
                                      <div className='fs-6 py-3'>
                                        {item.incoterm2_id == '' || item.incoterm2_id == '0'
                                          ? item.incoterm1?.code
                                          : item.inconterm1?.code + '-' + item.incoterm2_id}
                                      </div>
                                    </td>
                                  ) : (
                                    <td className='td-order-2 text-center column'>
                                      <div className='fs-6 py-3'>
                                        {item.incoterm1?.code}-{item.incoterm2?.code}
                                      </div>
                                    </td>
                                  )}
                                </>
                              ) : (
                                <>
                                  {item.incoterm2 == null ? (
                                    <td className='td-order-2 text-center column'>
                                      <div className='fs-6 py-3'>
                                        {item.incoterm1?.code}
                                        {item.incoterm2_id == null ||
                                        item.incoterm2_id == '0' ||
                                        item.incoterm2_id == ''
                                          ? ''
                                          : '-' + item.incoterm2_id}
                                      </div>
                                    </td>
                                  ) : (
                                    <td className='td-order-2 text-center column'>
                                      <div className='fs-6 py-3'>
                                        {item.incoterm1?.code}-{item.incoterm2?.code}
                                      </div>
                                    </td>
                                  )}
                                </>
                              )}
                              {sektorID != 3 ? (
                                <td className='td-order-2 text-center column'>
                                  <div className='fs-6 py-3'>
                                    <PopoverText
                                      content={
                                        item['province']?.region_name + ', ' + item['city']?.city_name
                                      }
                                      index={_index}
                                      className='desc-slicee'
                                    />
                                  </div>
                                </td>
                              ) : (
                                ''
                              )}
                              {sektorID == 1 ? (
                                <td className='td-order-2 text-center column'>
                                  <div className='fs-6 py-3'>{t(item.segment_name)}</div>
                                </td>
                              ) : (
                                ''
                              )}
                              <td className='td-order-2 text-center column'>
                                <div className='fs-6 py-3'>
                                  <PopoverText
                                    content={
                                      item?.end_user_multiple
                                        ? handleShowValue(item.end_user)
                                        : item.end_user
                                    }
                                    index={_index}
                                    className='desc-slice'
                                  />
                                </div>
                              </td>
                              <td className='td-order-2 text-center column'>
                                <div className='fs-6 py-3'>{item['product_type_desc']}</div>
                              </td>
                              <td className='td-order-2 text-center column'>
                                <div className='fs-6 py-3'>
                                  {parseInt(item.material_number) == 0 ? (
                                    <label className='opacity-0'>-</label>
                                  ) : (
                                    item.material_number.slice(-7)
                                  )}
                                </div>
                              </td>
                              <td className='td-order-2 text-center column'>
                                <div className='fs-6 py-3'>
                                  <PopoverText
                                    content={item['product_name']}
                                    index={_index}
                                    className='desc-slice'
                                  />
                                </div>
                              </td>
                              <td className='td-order-2 text-center column'>
                                <div className='fs-6 py-3'>
                                  <PopoverText
                                    content={item['product_spec'] ? item['product_spec'] : '-'}
                                    index={_index}
                                    className='desc-slice'
                                  />
                                </div>
                              </td>
                              <td className='td-order-2 text-center column'>
                                <div className='fs-6 py-3'>
                                  {i18next.language === 'en'
                                    ? item.request_quantum?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : item.request_quantum?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}{' '}
                                  {item.sector_id === 3 ? 'MT' : 'Ton'}
                                </div>
                              </td>
                              <td className='td-order-2 text-center column'>
                                <div className='fs-6 py-3'>
                                  {i18next.language === 'en'
                                    ? item.fixed_quantum?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : item.fixed_quantum?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}{' '}
                                  {item.sector_id === 3 ? 'MT' : 'Ton'}
                                </div>
                              </td>
                              <td className='td-order-2 text-center column'>
                                <div className='fs-6 py-3'>
                                  {i18next.language === 'en'
                                    ? (
                                        parseFloat(item.fixed_quantum) -
                                        parseFloat(item.so_qty_realized)
                                      )?.toLocaleString('en', {maximumFractionDigits: 4})
                                    : (
                                        parseFloat(item.fixed_quantum) -
                                        parseFloat(item.so_qty_realized)
                                      )?.toLocaleString('id', {maximumFractionDigits: 4})}{' '}
                                  {item.sector_id === 3 ? 'MT' : 'Ton'}
                                </div>
                              </td>
                              <td className='td-order-2 text-center column'>
                                <div className='fs-6 py-3'>
                                  {(item.sector?.id != 3 ? 'Rp' : 'USD') +
                                    (i18next.language === 'en'
                                      ? item.fixed_price?.toLocaleString('en')
                                      : item.fixed_price?.toLocaleString('id')) +
                                    (item.sector?.id != 3 ? '/Ton' : '/MT')}
                                </div>
                              </td>
                              {item.sector_id == 1 && (
                                <td className='td-order-2 text-center column'>
                                  <div className='fs-6 py-3'>
                                    {item.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                                  </div>
                                </td>
                              )}
                              {item.sector_id == 2 ? (
                                <td className='td-order-2 text-center column'>
                                  <div className='fs-6 py-3'>{item['plant_desc']}</div>
                                </td>
                              ) : (
                                ''
                              )}
                            </tr>
                          </tbody>
                        )}
                      </>
                    ))}
                    {addedItems2.map((item, _index) => (
                      <tbody key={item?.id ?? _index}>
                        <tr className='d-flex jusify-content-center w-100 align-items-center bg-secondary'>
                          <td className='td-order-1 text-center column'>
                            <div className='py-3'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                id={'checkbox' + _index}
                                checked={true}
                                disabled
                              />
                            </div>
                          </td>
                          <td className='td-order-1 text-center column'>
                            <div className='fs-6 py-3'>{detailOrder.length + 1}</div>
                          </td>
                          <td className='td-order-2 text-center column'>
                            <div className='fs-6 py-3'>
                              <label className='opacity-0'>-</label>
                            </div>
                          </td>
                          <td className='td-order-2 text-center column'>
                            <div className='fs-6 py-3'>
                              <label className='opacity-0'>-</label>
                            </div>
                          </td>
                          <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              <span className='badge badge-light-primary'>{t('new item')}</span>
                            </span>
                          </td>
                          <td className='td-order-4 text-center column'>
                            <div>
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title='Detail'
                                onClick={() => {
                                  setTempDetail(item)
                                  setTempData(item)
                                  setShowDetailNewProduct(true)
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/file-text-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>

                              {regarding == 'PO001' ? (
                                <>
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Jadwal')}
                                    // disabled={
                                    //   indexAmandement != 0
                                    //     ? indexAmandement == _index + 1
                                    //       ? false
                                    //       : true
                                    //     : false
                                    // }
                                    onClick={() => {
                                      setSektor(item.sector_id)
                                      setProvinceDesc(item.province_id)
                                      setCityDesc(item.city_id)
                                      setPname(item.product_name)
                                      setQuantum(item.request_quantum)
                                      formattingTon(item.request_quantum)
                                      setTempIndex(_index)
                                      setFixedQuantum(item.request_quantum)
                                      setTempJadwal(addedItems[_index].schedules)
                                      setNewProductFlag(true)
                                      setIsChanged(true)
                                      setShow3(true)
                                    }}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/calendar-check-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                </>
                              ) : (
                                ''
                              )}

                              <button
                                onClick={() => {
                                  setShowUpload1(true)
                                  setIsFileBox(item)
                                  setTempIndex(_index)
                                  setOrderItemsFiles(addedItems[_index].attachments)
                                  setNewProductFlag(true)
                                  setIsChanged(true)
                                  removeFileState()
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('order-lampiran')}
                                // disabled={
                                //   indexAmandement != 0
                                //     ? indexAmandement == _index + 1
                                //       ? false
                                //       : true
                                //     : false
                                // }
                              >
                                <KTSVG
                                  path='/media/icons/duotune/archive-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>

                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('amandement')}
                                // disabled={
                                //   indexAmandement != 0
                                //     ? indexAmandement == _index + 1
                                //       ? false
                                //       : true
                                //     : false
                                // }
                                onClick={() => {
                                  setTempData(item)
                                  setTempIndex(_index)
                                  setState2(addedItems[_index], item)
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/pencil-square.svg'
                                  className='svg-icon-3'
                                />
                              </button>

                              <button
                                onClick={() => removeSubOrder(_index)}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Hapus')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/trash-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>

                              <button
                                onClick={() => handleShowComment(item.id, true)}
                                hidden={item.id ? false : true}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Comment')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/chat-left-text-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            </div>
                          </td>
                          <td className='td-order-4 text-center column'>
                            <div className='fs-6 py-3'>{item.sales_org_code}</div>
                          </td>
                          <td className='td-order-2 text-center column'>
                            <div className='fs-6 py-3'>
                              {item.incoterm1_id +
                                (item.incoterm2_id != '' ? '-' + item.incoterm2_id : '')}
                            </div>
                          </td>
                          {sektorID != 3 ? (
                            <td className='td-order-2 text-center column'>
                              <div className='fs-6 py-3'>
                                {item.province_id}, {item.city_id}
                              </div>
                            </td>
                          ) : (
                            ''
                          )}
                          {sektorID == 1 ? (
                            <td className='td-order-2 text-center column'>
                              <div className='fs-6 py-3'>{t(item.segment_name)}</div>
                            </td>
                          ) : (
                            ''
                          )}
                          <td className='td-order-2 text-center column'>
                            <div className='fs-6 py-3'>
                              <PopoverText
                                content={
                                  item?.end_user_multiple
                                    ? handleShowValue(item.end_user)
                                    : item.end_user
                                }
                                index={_index}
                                className='desc-slice'
                              />
                            </div>
                          </td>
                          <td className='td-order-2 text-center column'>
                            <div className='fs-6 py-3'>{item['product_type_desc']}</div>
                          </td>
                          <td className='td-order-2 text-center column'>
                            <div className='fs-6 py-3'>
                              {parseInt(item.material_number) == 0 ? (
                                <label className='opacity-0'>-</label>
                              ) : (
                                item.material_number.slice(-7)
                              )}
                            </div>
                          </td>
                          <td className='td-order-2 text-center column'>
                            <div className='fs-6 py-3'>
                              <PopoverText
                                content={item['product_name']}
                                index={_index}
                                className='desc-slice'
                              />
                            </div>
                          </td>
                          <td className='td-order-2 text-center column'>
                            <div className='fs-6 py-3'>
                              <PopoverText
                                content={item['product_spec'] ? item['product_spec'] : '-'}
                                index={_index}
                                className='desc-slice'
                              />
                            </div>
                          </td>
                          <td className='td-order-2 text-center column'>
                            <div className='fs-6 py-3'>
                              {i18next.language === 'en'
                                ? item.request_quantum?.toLocaleString('en', {maximumFractionDigits: 4})
                                : item.request_quantum?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}{' '}
                              {item.sector_id === 3 ? 'MT' : 'Ton'}
                            </div>
                          </td>
                          <td className='td-order-2 text-center column'>
                            <div className='fs-6 py-3'>
                              <label className='opacity-0'>-</label>
                            </div>
                          </td>
                          <td className='td-order-2 text-center column'>
                            <div className='fs-6 py-3'>
                              <label className='opacity-0'>-</label>
                            </div>
                          </td>
                          <td className='td-order-2 text-center column'>
                            <div className='fs-6 py-3'>
                              {(item.sector_id != 3 ? 'Rp' : 'USD') +
                                (i18next.language === 'en'
                                  ? item.request_price?.toLocaleString('en')
                                  : item.request_price?.toLocaleString('id')) +
                                (item.sector_id != 3 ? '/Ton' : '/MT')}
                            </div>
                          </td>
                          {item.sector_id == 1 && (
                            <td className='td-order-2 text-center column'>
                              <div className='fs-6 py-3'>
                                {item.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                              </div>
                            </td>
                          )}
                          {item.sector_id == 2 ? (
                            <td className='td-order-2 text-center column'>
                              <div className='fs-6 py-3'>{item['plant_desc']}</div>
                            </td>
                          ) : (
                            ''
                          )}
                        </tr>
                      </tbody>
                    ))}
                  </table>
                  {/* End Table Head */}
                </div>

                <div className='d-flex justify-content-end my-5'>
                  <Link to={'/management/order/create'} className='me-2'>
                    <Button className='btn btn-secondary'>
                      {indexAmandement != 0 ? t('cancel') : t('order-kembali')}
                    </Button>
                  </Link>
                  <div className='me-2' hidden={buttonFlag ? false : true}>
                    <Button onClick={() => postAmandement()} className='btn btn-primary'>
                      {btnLoading ? (
                        <Spinner animation='border' variant='light' size='sm' />
                      ) : (
                        t('amandement')
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className='card-body'>
                <Row>
                  <Col md={6}>
                    <Row className='mb-3'>
                      <Col lg={5}>
                        <p className='fs-4'>{t('order-perihal')}</p>
                      </Col>
                      <Col lg={7}>
                        <Form.Select placeholder={t('Pembelian')} size='sm' disabled>
                          {regarding == 'PO002' ? (
                            <option selected disabled hidden>
                              {t('Non-penjualan')}
                            </option>
                          ) : (
                            <option selected disabled hidden>
                              {t('penjualan')}
                            </option>
                          )}
                        </Form.Select>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control type='text' value={customerName} disabled size='sm' />
                      </Col>
                    </Row>

                <Row className='mb-3'>
                  <Col lg={5}>
                    <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                  </Col>
                  <Col lg={7}>
                    <Form.Control type='text' value={customerCode} disabled size='sm' />
                  </Col>
                </Row>
                <Row className='mb-3'>
                  <Col lg={5}>
                    <p className='fs-4'>{t('Customer Support Data')}</p>
                  </Col>
                  <Col lg={7}>
                    <div className='d-flex align-items-center'>
                      <Button className='btn btn-primary' onClick={() => handleProfileCustomer()}>
                        {t('order-lihat')}
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Row className='mb-3'>
                  <Col lg={5}>
                    <p className='fs-4'>{t('order-reqHarga')}</p>
                  </Col>
                  <Col lg={7}>
                    <Button className='btn btn-primary' disabled>
                      {t('order-lihat')}
                    </Button>
                  </Col>
                </Row>
                <Row className='mb-3'>
                  <Col lg={5}>
                    <p className='fs-4'>{t('order-cekStock')}</p>
                  </Col>
                  <Col lg={7}>
                    <Button variant='primary' onClick={() => handleStock()}>
                          {btnStock ? (
                            <Spinner animation='border' variant='light' size='sm' />
                          ) : (
                            <>{t('order-lihat')}</>
                          )}
                    </Button>

                    <ShowStock show={showStock} setShow={setShowStock} loading={btnStock} reload={loadDetailStock} datas={allStock}/>
                  </Col>
                  </Row>
                  </Col>
                  <Col md={6}>
                    <Row className='mb-3'>
                      <Col lg={4}>
                        <p className='fs-4 mt-2'>{t('Order Number')}</p>
                      </Col>
                      <Col lg={8}>
                        <Form.Control
                          type='text'
                          value={orderNumber == '' ? '' : '10' + orderNumber}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>

                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Address')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control as='textarea' value={customerAddress} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Phone Number')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control type='text' value={phoneNumber} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('Email')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control type='text' value={emailCust} disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <p className='fs-4 mt-2'>{t('PIC Customer')}</p>
                      </Col>
                      <Col md={8}>
                        <Form.Control type='text' value={PICCust} disabled size='sm' />
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <hr className='my-0' />

                <div className='mt-2 d-flex'>
                  <Button
                    variant='primary'
                    onClick={() => handleShowAttachmentHeader()}
                    className='btn btn-primary me-2'
                  >
                    {t('order-lampiranUpload')}
                  </Button>
                </div>

                <div className='table-responsive bdr mt-2' style={{marginTop: '3rem'}}>
                  {/* Table Head */}
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='border-bottom'>
                      <tr className='fw-bold  d-flex jusify-content-center w-100 align-items-center'>
                        <th className='td-order-1 text-center'>{t('pilih')}</th>
                        <th className='td-order-1 text-center'>{t('sub-order-item')}</th>
                        <th className='td-order-2 text-center'>Status</th>
                        <th className='td-order-2 text-center'>{t('order-aksi')}</th>
                        <th className='td-order-4 text-center'>Sales Org</th>
                        <th className='td-order-2 text-center'>{t('sub-order-incoterm')}</th>
                        {sektorID != 3 ? (
                          <th className='td-order-3 text-center'>{t('sub-order-wilayah')}</th>
                        ) : (
                          ''
                        )}
                        {sektorID == 1 ? (
                          <th className='td-order-2 text-center'>{t('segment')}</th>
                        ) : (
                          ''
                        )}
                        <th className='td-order-2 text-center'>{t('End Customer')}</th>
                        <th className='td-order-2 text-center'>{t('sub-order-jenis')}</th>
                        <th className='td-order-2 text-center'>{t('Product Code')}</th>
                        <th className='td-order-2 text-center'>{t('sub-order-produk')}</th>
                        <th className='td-order-2 text-center'>{t('sub-order-spek')}</th>
                        <th className='td-order-2 text-center'>{t('Kuantum Pengajuan')}</th>
                        <th className='td-order-2 text-center'>{t('Quantum')}</th>
                        <th className='td-order-2 text-center'>{t('Price')}</th>
                        {sektorID == 1 && (
                          <th className='td-order-2 text-center'>Status {t('Price')}</th>
                        )}
                        {sektorID == 2 ? (
                          <th className='td-order-2 text-center'>{t('sub-order-gudang')}</th>
                        ) : (
                          ''
                        )}
                      </tr>
                    </thead>
                    {detailOrder.map((item, _index) => (
                      <tbody key={item?.id ?? _index}>
                        <tr className='d-flex jusify-content-center w-100 align-items-center'>
                          {item.is_amendment && (
                            <>
                              <td className='td-order-1 text-center'>
                                <div className='d-block py-3' style={{margin: '-1px 0 auto'}}>
                                {
                                  UserSegment(item?.segment_code) ? <>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    id={'checkbox' + _index}
                                    defaultChecked={indexItem.includes(_index.toString())}
                                    value={item.id + '~#~' + _index}
                                    onClick={() => onclickCheckBox(item.id + '~#~' + _index)}
                                  />
                                </> : <>
                                <span data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('not-match-segment')}>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    disabled
                                  />
                                </span>
                                </>
                                }
                                </div>
                              </td>
                              <td className='td-order-1 text-center'>
                                <div className='fs-6 py-3'>{_index + 1}</div>
                              </td>
                              <td className='td-order-2 text-center'>
                                <div className='py-3'>
                                  <span className='badge badge-light-primary'>
                                    {t(item.amendment_orders[0]?.['status_text'])}
                                  </span>
                                </div>
                              </td>
                              <td className='td-order-2 text-center'>
                                <div
                                  className='d-flex justify-content-center align-items-center'
                                  style={{margin: '1px 0'}}
                                >
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('detail')}
                                    onClick={() => {
                                      setTempData(item.amendment_orders[0])
                                      setTempData2({... item, incoterm2_id: item?.incoterm2_id == 0 ? null : item?.incoterm2_id})
                                      handleDataForApprovalAmandemen(item.amendment_orders[0])
                                      // console.log('kondisi ', item.amendment_orders[0].request_quantum, item.fixed_quantum)
                                      setIDSector(item.sector_id)
                                      setTempIndex(_index)
                                      // if (isAmandemend == 'true') {
                                      //   const munculEdit = setTimeout(() => {
                                      //     setShowAmandemendApproval(true)
                                      //   }, 2000)
                                      //   return () => clearTimeout(munculEdit)
                                      // }
                                    }}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/file-text-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Jadwal')}
                                    onClick={() => {
                                      setTempJadwal(item.amendment_orders[0].schedules)
                                      formattingTon(item.amendment_orders[0]?.fixed_quantum)
                                      setSektor(item.amendment_orders[0]?.sector_id)
                                      setProvinceDesc(item.amendment_orders[0]?.province?.region_name)
                                      setCityDesc(item.amendment_orders[0]?.city?.city_name)
                                      setPname(item.amendment_orders[0]?.product_name)
                                      setShowJadwal(true)
                                    }}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/calendar-check-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>

                                  <button
                                    onClick={() => {
                                      setIsFileBox(item.amendment_orders[0])
                                      ambilAttachment(item.id, item.amendment_orders[0]?.id)
                                      setIDAttachments([item.id, item.amendment_orders[0]?.id])
                                      removeFileState()
                                    }}
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('order-lampiran')}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/archive-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  <button
                                    onClick={() => handleShowComment(item.id, true)}
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Comment')}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/chat-left-text-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                </div>
                              </td>
                              <td className='td-order-4 text-center'>
                                <div className='fs-6 py-3'>
                                  {item.amendment_orders[0]?.produsen?.name}
                                </div>
                              </td>
                              {item.amendment_orders[0]?.sector?.id == 2 ? (
                                <>
                                  {item.amendment_orders[0]?.incoterm2 == null ? (
                                    <td className='td-order-2 text-center'>
                                      <div className='fs-6 py-3'>
                                        {item.amandment_orders[0]?.incoterm2_id == '' ||
                                        item.amandment_orders[0].incoterm2_id == '0'
                                          ? item.amendment_orders[0]?.incoterm1?.code
                                          : item.amendment_orders[0]?.incoterm1?.code +
                                            '-' +
                                            item.amendment_orders[0]?.incoterm2_id}
                                      </div>
                                    </td>
                                  ) : (
                                    <td className='td-order-2 text-center'>
                                      <div className='fs-6 py-3'>
                                        {item.amendment_orders[0]?.incoterm1?.code}-
                                        {item.amendment_orders[0]?.incoterm2?.code}
                                      </div>
                                    </td>
                                  )}
                                </>
                              ) : (
                                <>
                                  {item.amendment_orders[0]?.incoterm2 == null ? (
                                    <td className='td-order-2 text-center'>
                                      <div className='fs-6 py-3'>
                                        {item.amendment_orders[0]?.incoterm1?.code}
                                        {item.amendment_orders[0]?.incoterm2_id == null ||
                                        item.amendment_orders[0]?.incoterm2_id == '0' ||
                                        item.incoterm2_id == ''
                                          ? ''
                                          : '-' + item.amendment_orders[0]?.incoterm2_id}
                                      </div>
                                    </td>
                                  ) : (
                                    <td className='td-order-2 text-center'>
                                      <div className='fs-6 py-3'>
                                        {
                                          [item.amendment_orders[0]?.incoterm1?.code, item.amendment_orders[0]?.incoterm2?.code]
                                            .filter((item: any) => item)
                                            .join('-')
                                        }
                                      </div>
                                    </td>
                                  )}
                                </>
                              )}
                              {sektorID != 3 ? (
                                <td className='td-order-3 text-center'>
                                  <div className='fs-6 py-3'>
                                    <PopoverText
                                      content={
                                        item.amendment_orders[0]?.['province']?.region_name +
                                        ', ' +
                                        item.amendment_orders[0]?.['city']?.city_name
                                      }
                                      index={_index}
                                      className='desc-slicee'
                                    />
                                  </div>
                                </td>
                              ) : (
                                ''
                              )}
                              {sektorID == 1 ? (
                                <td className='td-order-2 text-center'>
                                  <div className='fs-6 py-3'>
                                    {t(item.amendment_orders[0]?.segment_name)}
                                  </div>
                                </td>
                              ) : (
                                ''
                              )}
                              <td className='td-order-2 text-center'>
                                <div className='fs-6 py-3'>
                                  <PopoverText
                                    content={
                                      item?.end_user_multiple
                                        ? handleShowValue(item.end_user)
                                        : item.end_user
                                    }
                                    index={_index}
                                    className='desc-slice'
                                  />
                                </div>
                              </td>
                              <td className='td-order-2 text-center'>
                                <div className='fs-6 py-3'>
                                  {item.amendment_orders[0]?.['product_type_desc']}
                                </div>
                              </td>
                              <td className='td-order-2 text-center'>
                                <div className='fs-6 py-3'>
                                  {parseInt(item.material_number) == 0
                                    ? ''
                                    : item.material_number.slice(-7)}
                                </div>
                              </td>
                              <td className='td-order-2 text-center'>
                                <div className='fs-6 py-3'>
                                  <PopoverText
                                    content={item.amendment_orders[0]?.['product_name']}
                                    index={_index}
                                    className='desc-slice'
                                  />
                                </div>
                              </td>
                              <td className='td-order-2 text-center'>
                                <div className='fs-6 py-3'>
                                  <PopoverText
                                    content={item.amendment_orders[0]?.['product_spec'] || '-'}
                                    index={_index}
                                    className='desc-slice'
                                  />
                                </div>
                              </td>
                              <td className='td-order-2 text-center'>
                                <div className='fs-6 py-3'>
                                  {i18next.language === 'en'
                                    ? item.fixed_quantum?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : item.fixed_quantum?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })}{' '}
                                  {item.sector_id === 3 ? 'MT' : 'Ton'}
                                </div>
                              </td>
                              <td className='td-order-2 text-center'>
                                <div className='fs-6 py-3'>
                                  {i18next.language === 'en'
                                    ? item.amendment_orders[0]?.['fixed_quantum']?.toLocaleString(
                                        'en',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      )
                                    : item.amendment_orders[0]?.['fixed_quantum']?.toLocaleString(
                                        'id',
                                        {
                                          maximumFractionDigits: 4,
                                        }
                                      )}{' '}
                                  {item.sector_id === 3 ? 'MT' : 'Ton'}
                                </div>
                              </td>
                              <td className='td-order-2 text-center'>
                                <div className='fs-6 py-3'>
                                  {(sektorID != 3 ? 'Rp' : 'USD') +
                                    (i18next.language === 'en'
                                      ? item.amendment_orders[0]?.['fixed_price']?.toLocaleString('en')
                                      : item.amendment_orders[0]?.['fixed_price']?.toLocaleString(
                                          'id'
                                        )) +
                                    (sektorID != 3 ? '/Ton' : '/MT')}
                                </div>
                              </td>
                              {item.sector_id == 1 && (
                                <td className='td-order-2 text-center'>
                                  <div className='fs-6 py-3'>
                                    {item.amendment_orders[0]?.include_ppn
                                      ? 'Include PPN'
                                      : 'Exclude PPN'}
                                  </div>
                                </td>
                              )}
                              {item.sector_id == 2 ? (
                                <td className='td-order-2 text-center'>
                                  <div className='fs-6 py-3'>
                                    {item.amendment_orders[0]?.['plant_desc']}
                                  </div>
                                </td>
                              ) : (
                                ''
                              )}
                            </>
                          )}
                        </tr>
                      </tbody>
                    ))}
                    {addedItems.map((item, _index) => (
                      <tbody key={item?.id ?? _index}>
                        <tr className='d-flex jusify-content-center w-100 align-items-center'>
                          <td className='td-order-1 text-center'>
                            <div className='d-block py-3' style={{margin: '-1px 0 auto'}}>
                            {
                              UserSegment(item?.segment_code) ? <>
                                  <input
                                  className='form-check-input'
                                  type='checkbox'
                                  id={'checkbox-new-item-' + (_index)}
                                  defaultChecked={indexItem2.includes(_index)}
                                  value={_index}
                                  onClick={() => onclickCheckBox2(_index)}
                                />
                              </> : <>
                                <span data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('not-match-segment')}>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    disabled
                                  />
                                </span>
                              </>
                              }
                            </div>
                          </td>
                          <td className='td-order-1 text-center'>
                            <div className='fs-6 py-3'>{detailOrder.length + _index + 1}</div>
                          </td>
                          <td className='td-order-2 text-center'>
                            <div className='fs-6 py-3'>
                              <span className='badge badge-light-primary'>{t(item.status_text)}</span>
                            </div>
                          </td>
                          <td className='td-order-2 text-center'>
                            <div
                              className='d-flex justify-content-center align-items-center'
                              style={{margin: '1px 0'}}
                            >
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('detail')}
                                onClick={() => {
                                  // setTempDetail(item)
                                  // setTempData(item)
                                  // handleShow()
                                  handleAmandement(item)
                                  setTempData(item)
                                  setTempIndex(_index)
                                  setState(item)
                                  setSubID(item.id)
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/file-text-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Jadwal')}
                                onClick={() => {
                                  setTempJadwal(item.schedules)
                                  formattingTon(item.fixed_quantum)
                                  setSektor(item.sector_id)
                                  setProvinceDesc(item.province?.region_name)
                                  setCityDesc(item.city?.city_name)
                                  setPname(item.product_name)
                                  setShowJadwal(true)
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/calendar-check-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>

                              <button
                                onClick={() => {
                                  setIsFileBox(item)
                                  ambilAttachment(item.id, 0)
                                  setIDAttachments([item.id, 0])
                                  removeFileState()
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('order-lampiran')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/archive-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                              <button
                                onClick={() => handleShowComment(item.id, true)}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Comment')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/chat-left-text-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            </div>
                          </td>
                          <td className='td-order-4 text-center'>
                            <div className='fs-6 py-3'>{item.produsen?.name}</div>
                          </td>
                          {item.incoterm2 == null ? (
                            <td className='td-order-2 text-center'>
                              <div className='fs-6 py-3'>
                                {item.incoterm1?.code}
                                {item.incoterm2_id == null ||
                                item.incoterm2_id == '0' ||
                                item.incoterm2_id == ''
                                  ? ''
                                  : '-' + item.incoterm2_id}
                              </div>
                            </td>
                          ) : (
                            <td className='td-order-2 text-center'>
                              <div className='fs-6 py-3'>
                                {item.incoterm1?.code}-{item.incoterm2?.code}
                              </div>
                            </td>
                          )}
                          {sektorID != 3 ? (
                            <td className='td-order-3 text-center'>
                              <div className='fs-6 py-3'>
                                <PopoverText
                                  content={item.province?.region_name + ', ' + item.city?.city_name}
                                  index={_index}
                                  className='desc-slicee'
                                />
                              </div>
                            </td>
                          ) : (
                            ''
                          )}
                          {sektorID == 1 ? (
                            <td className='td-order-2 text-center'>
                              <div className='fs-6 py-3'>{t(item.segment_name)}</div>
                            </td>
                          ) : (
                            ''
                          )}
                          <td className='td-order-2 text-center'>
                            <div className='fs-6 py-3'>
                              <PopoverText
                                content={
                                  item?.end_user_multiple
                                    ? handleShowValue(item.end_user)
                                    : item.end_user
                                }
                                index={_index}
                                className='desc-slice'
                              />
                            </div>
                          </td>
                          <td className='td-order-2 text-center'>
                            <div className='fs-6 py-3'>{item.product_type_desc}</div>
                          </td>
                          <td className='td-order-2 text-center'>
                            <div className='fs-6 py-3'>
                              {parseInt(item.material_number) == 0
                                ? ''
                                : item.material_number.slice(-7)}
                            </div>
                          </td>
                          <td className='td-order-2 text-center'>
                            <div className='fs-6 py-3'>
                              <PopoverText
                                content={item.product_name}
                                index={_index}
                                className='desc-slice'
                              />
                            </div>
                          </td>
                          <td className='td-order-2 text-center'>
                            <div className='fs-6 py-3'>
                              <PopoverText
                                content={item.product_spec ? item.product_spec : '-'}
                                index={_index}
                                className='desc-slice'
                              />
                            </div>
                          </td>
                          <td className='td-order-2 text-center'>
                            <div className='fs-6 py-3'>
                              {i18next.language === 'en'
                                ? item.fixed_quantum?.toLocaleString('en', {maximumFractionDigits: 4})
                                : item.fixed_quantum?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}{' '}
                              {item.sector_id === 3 ? 'MT' : 'Ton'}
                            </div>
                          </td>
                          <td className='td-order-2 text-center'>
                            <div className='fs-6 py-3'>
                              {i18next.language === 'en'
                                ? item.fixed_quantum.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : item.fixed_quantum.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}{' '}
                              {item.sector_id === 3 ? 'MT' : 'Ton'}
                            </div>
                          </td>
                          <td className='td-order-2 text-center'>
                            <div className='fs-6 py-3'>
                              {(sektorID != 3 ? 'Rp' : 'USD') +
                                (i18next.language === 'en'
                                  ? item.fixed_price.toLocaleString('en')
                                  : item.fixed_price.toLocaleString('id')) +
                                (sektorID != 3 ? '/Ton' : '/MT')}
                            </div>
                          </td>
                          {item.sector_id == 1 && (
                            <td className='td-order-2 text-center'>
                              <div className='fs-6 py-3'>
                                {item.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                              </div>
                            </td>
                          )}
                          {item.sector_id == 2 ? (
                            <td className='td-order-2 text-center'>
                              <div className='fs-6 py-3'>{item.plant_desc}</div>
                            </td>
                          ) : (
                            ''
                          )}
                        </tr>
                      </tbody>
                    ))}
                  </table>
                  {/* End Table Head */}
                </div>
                <div style={{marginTop: '2rem'}}>
                  <div className='d-flex justify-content-end'>
                    <Button
                      variant='secondary'
                      className='me-2'
                      onClick={() => navigate('/management/order/all')}
                    >
                      {t('order-kembali')}
                    </Button>
                    <Button
                      variant='danger'
                      hidden={buttonFlag || buttonFlag2 ? false : true}
                      onClick={() => amandementReject()}
                      className='me-2'
                      disabled={btnLoadingRej || btnLoadingApp}
                    >
                      {btnLoadingRej ? (
                        <Spinner animation='border' variant='light' size='sm' />
                      ) : (
                        t('order-tolak')
                      )}
                    </Button>
                    <Button
                      hidden={buttonFlag || buttonFlag2 ? false : true}
                      className='btn btn-warning me-2'
                      id='btn-revision'
                      onClick={() => setShowRevisionNote(true)}
                    >
                      {btnLoadingRef ? (
                        <Spinner animation='border' variant='light' size='sm' />
                      ) : (
                        t('order-revisi')
                      )}
                    </Button>
                    <Button
                      onClick={() => sendApproveAmandemen()}
                      className='btn btn-success me-2'
                      hidden={buttonFlag || buttonFlag2 ? false : true}
                    >
                      {btnLoading ? (
                        <Spinner animation='border' variant='light' size='sm' />
                      ) : (
                        t('setujui')
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}


        {/* modal attachment db */}
        <Modal
          size='lg'
          show={showUpload}
          onHide={() => {
            setShowUpload(false)
            setIsFileBox({})
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isFileBox?.product_name
                ? (isFileBox.province ? isFileBox.province?.region_name : '') +
                  (isFileBox.city ? ', ' + isFileBox.city?.city_name : '') +
                  (isFileBox.province ? ' | ' : '') +
                  isFileBox.product_name +
                  (isFileBox.request_quantum ? ' | ' + isFileBox.request_quantum + ' Ton' : '')
                : t('File Box')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
                    <Col sm={6}>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-fileUnggah')}</h6>
                          </td>
                          <td className='w-75'>
                            <InputFile
                                setFileName={setNamaFile}
                                setFiles={setFiles}
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-keterangan')}</h6>
                          </td>
                          <td className='w-75'>
                            <Form.Control
                              type='text'
                              disabled={loadingUpload}
                              id='uploadketerangan'
                              placeholder={t('order-keterangan')}
                              onChange={(e: any) => setDescription(e.target.value)}
                            />
                          </td>
                        </tr>
                      </table>
                      <table
                        className='mb-3'
                        hidden={roleUser == 'null' || roleUser == null ? true : false}
                      >
                        <tr>
                          <td>
                            <h6 className='me-11'>{t('Private')}</h6>
                          </td>
                          <td className='w-75 d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='isPrivate'
                              disabled={loadingUpload}
                              type='checkbox'
                              className='mt-5 mb-2'
                              onClick={() => {
                                setIsPrivate(!isPrivate)
                                setTempRole([])
                              }}
                              id='isPrivate'
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3' hidden={isPrivate ? false : true}>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('Akses Role')}</h6>
                          </td>
                          <td className='w-75' style={{maxWidth: '274px'}}>
                            <MultiSelect
                              key={files}
                              options={fullRole?.map((item: any) => {
                                return {label: item.label, value: item.value}
                              })}
                              disabled={loadingUpload}
                              value={tempRole}
                              onChange={(e: any) => setTempRole(e)}
                              labelledBy='Select'
                            />
                          </td>
                        </tr>
                      </table>
                      <div className='d-flex justify-content-end'>
                        <Button
                          variant='primary'
                          className='w-100'
                          disabled={loadingUpload}
                          onClick={() => handleUpload()}
                        >
                          {loadingUpload ? '...' : t('order-kirim')}
                        </Button>
                      </div>
                    </Col>
                  </Row>

              <div className='table-responsive mt-4 bdr'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='fw-bold border-bottom'>
                    <tr className=''>
                      <th className='text-center'>{t('order-noo')}</th>
                      <th className='text-center'>{t('order-keterangan')}</th>
                      <th className='text-center'>{t('order-tglUpload')}</th>
                      {/* <th className='text-center'>{t('User Code')}</th> */}
                      <th className='text-center'>{t('order-user')}</th>
                      <th className='text-center'>{t('Akses Role')}</th>
                      <th className='text-center'>{t('order-aksi')}</th>
                    </tr>
                  </thead>
                  {allFile.map((data: any, _index: number) => (
                    <tbody key={data?.id ?? _index}>
                      <tr className=''>
                        <td className='text-center'>
                          <label>{_index + 1}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.description}</label>
                        </td>
                        <td className='text-center'>
                          {
                            data.is_new ? <label>{dateformat(getCurrentFormattedDate())}</label>
                            : <label>{dateformat(data.updated_at)}</label>
                          }
                        </td>
                        {/* <td className='text-center'>
                          <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                        </td> */}
                        <td className='text-center'>
                          { data.is_new ? <label>{localStorage.getItem('username')}</label> 
                          : data.user?.customer_code == null ? (
                            <label>{data.user?.name}</label>
                          ) : (
                            <label>{data.user?.customer?.name}</label>
                          )}
                        </td>
                        <td className='text-center'>
                          {data.private ? (
                            data.roles?.length > 0 ? (
                              <PopoverText
                                content={handleShowRoleName(data.roles)}
                                index={_index}
                                className='desc-slice'
                              />
                            ) : (
                              'Private'
                            )
                          ) : (
                            'Public'
                          )}
                        </td>
                        <td className='text-center'>
                          { !data.is_new && <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('unduh')}
                            onClick={() =>
                              window.open(
                                data.file_path + `&token=${localStorage.getItem('token')}`
                              )
                            }
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrow-down-square-fill.svg'
                              className='svg-icon-3'
                            />
                          </button> }
                          {(data.is_new ||  accsessDelete || CheckSameIDAttachment(data.user_role_flag)) && (
                            <button
                              onClick={() => deleteAttachment(data.id)}
                              className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Hapus')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/trash-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
          </Modal.Body>
        </Modal>

        {/* modal detail */}
        <Modal show={show} onHide={handleClose} centered scrollable size='xl' backdrop='static'>
          <Modal.Header closeButton>
            <Modal.Title>Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {tempDetail?.sector_id == 1 && (
              <Row>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>Sales Org</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.produsen?.name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.incoterm1?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        type='text'
                        value={tempDetail.province?.region_name}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_type_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? (
                                parseFloat(tempData.request_quantum)
                              )?.toLocaleString('en', {maximumFractionDigits: 4}) + ' Ton'
                            : (
                                parseFloat(tempData.request_quantum)
                              )?.toLocaleString('id', {maximumFractionDigits: 4}) + ' Ton'
                        }
                        // value={i18next.language === 'en'
                        //     ?  parseFloat(tempData.request_quantum)?.toLocaleString('en', { maximumFractionDigits: 4 }) + ' Ton'
                        //     :  parseFloat(tempData.request_quantum)?.toLocaleString('id', { maximumFractionDigits: 4 }) + ' Ton'}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-kuantumD')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? (
                                parseFloat(tempData.fixed_quantum) -
                                parseFloat(tempData.so_qty_realized)
                              )?.toLocaleString('en', {maximumFractionDigits: 4}) + ' Ton'
                            : (
                                parseFloat(tempData.fixed_quantum) -
                                parseFloat(tempData.so_qty_realized)
                              )?.toLocaleString('id', {maximumFractionDigits: 4}) + ' Ton'
                        }
                        // value={i18next.language === 'en'
                        //     ?  parseFloat(tempData.request_quantum)?.toLocaleString('en', { maximumFractionDigits: 4 }) + ' Ton'
                        //     :  parseFloat(tempData.request_quantum)?.toLocaleString('id', { maximumFractionDigits: 4 }) + ' Ton'}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='fs-6 mt-3'>{t('Shipping Tolerance')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control
                        // placeholder={t("Shipping Tolerance")}
                        size='sm'
                        type='text'
                        id='shipping'
                        value={
                          tempDetail?.shipping_tolerance == 0
                            ? ''
                            : tempDetail?.shipping_tolerance + '%'
                        }
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_1_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4} className='d-flex align-items-center'>
                      <p className='fs-6'>{t('keterangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_note}
                        as='textarea'
                        disabled
                        size='sm'
                        style={{height: '40px'}}
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('segment')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={t(tempDetail?.segment_name)}
                        type='text'
                        size='sm'
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('End Customer')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          tempDetail.end_user_multiple
                            ? handleShowValue(tempDetail.end_user)
                            : tempDetail.end_user
                          // tempDetail.end_user_detail?.name
                          //   ? tempDetail.end_user_detail?.name
                          //   : tempDetail.end_user
                        }
                        as='textarea'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={t(tempDetail.sector?.name)}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                    </Col>
                    <Col md={8}>
                      {tempDetail?.incoterm2 == null ? (
                        <Form.Control
                          value={
                            tempDetail?.incoterm2_id == null || tempDetail?.incoterm2_id == '0'
                              ? ''
                              : tempDetail?.incoterm2_id
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      ) : (
                        <Form.Control
                          value={tempDetail?.incoterm2?.code}
                          type='text'
                          disabled
                          size='sm'
                        />
                      )}
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        type='text'
                        value={tempDetail.city?.city_name}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/Ton</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          'Rp' + i18next.language === 'en'
                            ? parseInt(tempDetail?.request_price).toLocaleString('en')
                            : parseInt(tempDetail?.request_price).toLocaleString('id')
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-hargaD')}/Ton</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          'Rp' + i18next.language === 'en'
                            ? parseInt(tempDetail?.fixed_price).toLocaleString('en')
                            : parseInt(tempDetail?.fixed_price).toLocaleString('id')
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='mt-4 fs-6'>{t('termasuk-ppn')}</p>
                    </Col>
                    <Col sm={8} className='d-flex justify-content-start'>
                      <Form.Check
                        reverse
                        name='ppn'
                        className='mt-5 mb-2'
                        type='checkbox'
                        id='ckbox-ppn'
                        checked={tempDetail?.include_ppn}
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_2_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_spec}
                        as='textarea'
                        style={{height: '40px'}}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.notes}
                        as='textarea'
                        style={{height: '40px'}}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>

                  { tempData?.sector_id != 2 && <>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='fs-6 mt-3'>{t('alasan perpanjangan')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control
                        as='textarea'
                        disabled
                        value={tempData?.amandement_notes}
                        size='sm'
                        style={{height: '40px'}}
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='fs-6 mt-3'>{t('tanggal perpanjangan')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control
                        defaultValue={tempData?.extension_date}
                        style={{height: '40px'}}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  </> }
                </Col>
              </Row>
            )}

            {tempDetail?.sector_id == 2 && (
              <Row>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>Sales Org</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.produsen?.name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.incoterm1?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        type='text'
                        value={tempDetail.province?.region_name}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control value={tempDetail.plant_desc} type='text' disabled size='sm' />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? (
                                parseFloat(tempData.fixed_quantum) -
                                parseFloat(tempData.so_qty_realized)
                              )?.toLocaleString('en', {maximumFractionDigits: 4}) + ' Ton'
                            : (
                                parseFloat(tempData.fixed_quantum) -
                                parseFloat(tempData.so_qty_realized)
                              )?.toLocaleString('id', {maximumFractionDigits: 4}) + ' Ton'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_1_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='fs-6'>{t('keterangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_note}
                        as='textarea'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={t(tempDetail.sector?.name)}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('End Customer')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          tempDetail.end_user_multiple
                            ? handleShowValue(tempDetail.end_user)
                            : tempDetail.end_user
                        }
                        as='textarea'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                    </Col>
                    <Col md={8}>
                      {tempDetail?.incoterm2 == null ? (
                        <Form.Control
                          value={
                            tempDetail?.incoterm2_id == null || tempDetail?.incoterm2_id == '0'
                              ? ''
                              : tempDetail?.incoterm2_id
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      ) : (
                        <Form.Control
                          value={tempDetail?.incoterm2?.code}
                          type='text'
                          disabled
                          size='sm'
                        />
                      )}
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        type='text'
                        value={tempDetail.city?.city_name}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_type_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_spec}
                        as='textarea'
                        style={{height: '40px'}}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='fs-6 mt-3'>{t('Price')}/Ton</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          'Rp' + i18next.language === 'en'
                            ? parseInt(tempDetail?.fixed_price).toLocaleString('en')
                            : parseInt(tempDetail?.fixed_price).toLocaleString('id')
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.notes}
                        as='textarea'
                        style={{height: '40px'}}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}

            {tempDetail?.sector_id == 3 && (
              <Row>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>Sales Org</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.produsen?.name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.incoterm1?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        type='text'
                        value={tempDetail.province?.region_name}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_type_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? (
                                parseFloat(tempData.request_quantum)
                              )?.toLocaleString('en', {maximumFractionDigits: 4}) + ' MT'
                            : (
                                parseFloat(tempData.request_quantum)
                              )?.toLocaleString('id', {maximumFractionDigits: 4}) + ' MT'
                        }
                        // value={i18next.language === 'en'
                        // ?  parseFloat(tempData.request_quantum)?.toLocaleString('en', { maximumFractionDigits: 4 }) + ' Ton'
                        // :  parseFloat(tempData.request_quantum)?.toLocaleString('id', { maximumFractionDigits: 4 }) + ' Ton'}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-kuantumD')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? (
                                parseFloat(tempData.fixed_quantum) -
                                parseFloat(tempData.so_qty_realized)
                              )?.toLocaleString('en', {maximumFractionDigits: 4}) + ' MT'
                            : (
                                parseFloat(tempData.fixed_quantum) -
                                parseFloat(tempData.so_qty_realized)
                              )?.toLocaleString('id', {maximumFractionDigits: 4}) + ' MT'
                        }
                        // value={i18next.language === 'en'
                        // ?  parseFloat(tempData.request_quantum)?.toLocaleString('en', { maximumFractionDigits: 4 }) + ' Ton'
                        // :  parseFloat(tempData.request_quantum)?.toLocaleString('id', { maximumFractionDigits: 4 }) + ' Ton'}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='fs-6 mt-3'>{t('Shipping Tolerance')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control
                        // placeholder={t("Shipping Tolerance")}
                        size='sm'
                        type='text'
                        id='shipping'
                        value={
                          tempDetail?.shipping_tolerance == 0
                            ? ''
                            : tempDetail?.shipping_tolerance + '%'
                        }
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_1_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='fs-6 mt-3'>{t('keterangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_note}
                        as='textarea'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('End Customer')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          tempDetail.end_user_multiple
                            ? handleShowValue(tempDetail.end_user)
                            : tempDetail.end_user
                        }
                        as='textarea'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={t(tempDetail.sector?.name)}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                    </Col>
                    <Col md={8}>
                      {tempDetail?.incoterm2 == null ? (
                        <Form.Control
                          value={
                            tempDetail?.incoterm2_id == null || tempDetail?.incoterm2_id == '0'
                              ? ''
                              : tempDetail?.incoterm2_id
                          }
                          type='text'
                          disabled
                          size='sm'
                        />
                      ) : (
                        <Form.Control
                          value={tempDetail?.incoterm2?.code}
                          type='text'
                          disabled
                          size='sm'
                        />
                      )}
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        type='text'
                        value={tempDetail.city?.city_name}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/MT</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={'USD' + PriceFormater(tempDetail?.request_price)}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-hargaD')}/MT</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={'USD' + PriceFormater(tempDetail?.fixed_price)}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_spec}
                        type='text'
                        as='textarea'
                        style={{height: '40px'}}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_2_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.notes}
                        as='textarea'
                        style={{height: '40px'}}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  { tempData?.sector_id != 2 && <>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('alasan perpanjangan')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          as='textarea'
                          disabled
                          value={tempData?.amandement_notes}
                          size='sm'
                          style={{height: '40px'}}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('tanggal perpanjangan')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          defaultValue={tempData?.extension_date}
                          style={{height: '40px'}}
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                  </> }
                </Col>
              </Row>
            )}
          </Modal.Body>
        </Modal>

        {/* modal amandemen */}
        <Modal
          show={showAmandemend}
          onHide={() => setShowAmandemend(false)}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t('amandement')} {t('Order')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loadingAmend ? (
              <div className='d-flex justify-content-center'>
                <Spinner animation='border' variant='primary' />
              </div>
            ) : (
              <>
                {idSektor == 3 && (
                  <>
                    <Row>
                      <Col md={6}>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('kontrak-produsen')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='produsen'
                              isDisabled
                              placeholder={t('pilih')}
                              defaultValue={
                                salesArea[
                                  salesArea.findIndex(
                                    (item: any) => item.label === tempData?.produsen?.name
                                  )
                                ]
                              }
                              options={salesArea}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-incoterm1')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='incoterm1'
                              key={idSektor}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullIncoterm[
                                  fullIncoterm.findIndex(
                                    (item: any) => item.label === tempData?.incoterm1?.code
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                              }}
                              options={fullIncoterm}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-provinsi')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='provinsi'
                              key={idSektor + produsen}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullProvince[
                                  fullProvince.findIndex((item: any) => item.label === provinceDesc)
                                ]
                              }
                              onChange={(e: any) => {
                                setFullCity([])
                                cityData(e?.value)
                              }}
                              options={fullProvince}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-jenis')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='jenis'
                              onChange={(e: any) => productTypeChange(e.target.value)}
                            >
                              <option hidden value='~#~'>
                                {t('Pilih-productType')}
                              </option>
                              {fullProductType.map((item: any) => {
                                return (
                                  <>
                                    {item.id != 12 && (
                                      <>
                                        {item.material_group == tempData?.product_type ? (
                                          <option
                                            selected
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        ) : (
                                          <option
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        )}
                                      </>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        {parseInt(pnumber) == 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>
                                Custom Product Name<span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                placeholder=' Custom Product Name'
                                size='sm'
                                defaultValue={pname}
                                aria-label='Default select example'
                                type='text'
                                id='custom'
                                onChange={(e: any) => setPname(e.target.value)}
                              />
                            </Col>
                          </Row>
                        )}
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('Kuantum Pengajuan')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <CurrencyInput
                                className='form-control form-control-sm'
                                id='kuantum'
                                // key={pname}
                                placeholder={t('Kuantum Pengajuan')}
                                defaultValue={quantum}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                onValueChange={(value: any) => {
                                  setQuantum(value?.replace(/,/g, '.'))
                                }}
                                decimalsLimit={3}
                              />
                              <InputGroup.Text id='basic-addon2'>MT</InputGroup.Text>
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col sm={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('Shipping Tolerance')}</p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <Form.Control
                                placeholder={t('Shipping Tolerance')}
                                type='number'
                                id='shipping'
                                defaultValue={shipping}
                                onChange={(e: any) => setShipping(parseFloat(e.target.value))}
                              />
                              <InputGroup.Text id='basic-addon2'>
                                <span className='px-1'>%</span>
                              </InputGroup.Text>
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-payment1')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='payment1'
                              onChange={(e: any) => separateValue(setPay1, e.target.value, setPay1Desc)}
                            >
                              <option hidden value='~#~'>
                                {t('Pilih-payment')}
                              </option>
                              {fullPayment.map((item: any) => {
                                return (
                                  <>
                                    {item.payment_desc == tempData?.payment_type_1_desc ? (
                                      <option selected value={item.code + '~#~' + item.payment_desc}>
                                        {item.payment_desc}
                                      </option>
                                    ) : (
                                      <option value={item.code + '~#~' + item.payment_desc}>
                                        {item.payment_desc}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('keterangan')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              as='textarea'
                              defaultValue={tempData?.payment_note}
                              placeholder={t('keterangan')}
                              id='keterangan'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => setketerangan(e.target.value)}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('End Customer')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              size='sm'
                              as='textarea'
                              id='enduser'
                              placeholder={t('End Customer')}
                              defaultValue={enduserDesc}
                              onChange={(e: any) => {
                                setEnduser(e.target.value)
                                setEnduserDesc(e.target.value)
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md={6}>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-sektor')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            {localStorage.getItem('cust-group') != 'AR06' ? (
                              <Form.Control
                                type='text'
                                size='sm'
                                disabled
                                value={t(tempData?.sector?.name)}
                              />
                            ) : (
                              <Form.Control type='text' size='sm' disabled value='Export' />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='incoterm2'
                              key={idSektor}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullIncoterm2[
                                  fullIncoterm2.findIndex(
                                    (item: any) => item.label == tempData?.incoterm2_id
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                              }}
                              options={fullIncoterm2}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-kota')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='kota'
                              key={province}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullCity[fullCity.findIndex((item: any) => item.label === cityDesc)]
                              }
                              onChange={(e: any) => {
                                separateValue2(setCity, e?.value, setCityDesc)
                                // fieldClearer(4)
                              }}
                              options={fullCity}
                              isDisabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-produk')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='produk'
                              key={ptype}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullProductName[
                                  fullProductName.findIndex(
                                    (item: any) =>
                                      item.truevalue == parseInt(tempData?.material_number)
                                  )
                                ]
                              }
                              onChange={(e: any) => productNameChange(e?.value)}
                              options={fullProductName}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('Harga Pengajuan')}/MT<span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <InputGroup.Text>
                                <span className='px-2'>USD</span>
                              </InputGroup.Text>
                              {isFormulatedPrice ? (
                                <CurrencyInput
                                  className='form-control form-control-sm'
                                  id='hargap'
                                  disabled
                                  defaultValue={0}
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  decimalsLimit={2}
                                />
                              ) : (
                                <CurrencyInput
                                  className='form-control form-control-sm'
                                  id='hargap'
                                  // key={pname}
                                  defaultValue={subprice}
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  onValueChange={(value: any) => {
                                    setSubprice(value?.replace(/,/g, '.'))
                                  }}
                                  decimalsLimit={2}
                                  placeholder={t('Harga Pengajuan')}
                                />
                              )}
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              placeholder={t('sub-order-spek')}
                              as='textarea'
                              defaultValue={tempData?.product_spec}
                              id='spek'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => setPspec(e.target.value)}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='payment2'
                              onChange={(e: any) => separateValue(setPay2, e.target.value, setPay2Desc)}
                            >
                              {/* <option selected hidden disabled>{t(tempData?.payment_type_2)}</option> */}
                              <option value='~#~'>{t('Pilih-payment')}</option>
                              {fullPayment.map((item: any) => {
                                return (
                                  <>
                                    {item.payment_desc == tempData?.payment_type_2_desc ? (
                                      <option selected value={item.code + '~#~' + item.payment_desc}>
                                        {item.payment_desc}
                                      </option>
                                    ) : (
                                      <option value={item.code + '~#~' + item.payment_desc}>
                                        {item.payment_desc}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              as='textarea'
                              placeholder={t('sub-order-catatan')}
                              defaultValue={tempData?.notes}
                              id='note'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => setNote(e.target.value)}
                            />
                          </Col>
                        </Row>
                        { tempData?.sector_id != 2 && <>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('alasan perpanjangan')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('alasan perpanjangan')}
                                defaultValue={tempData?.amandement_notes}
                                size='sm'
                                style={{height: '40px'}}
                                onChange={(e: any) => setAlasan(e.target.value)}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('tanggal perpanjangan')}</p>
                            </Col>
                            <Col sm={8}>
                              <input
                                type='date'
                                defaultValue={tempData?.extension_date}
                                style={{height: '40px'}}
                                onChange={(e: any) => {
                                  setTanggalPerpanjangan(e.target.value)
                                }}
                                className='form-control form-control-sm'
                              />
                            </Col>
                          </Row>
                        </> }
                      </Col>
                    </Row>
                  </>
                )}

                {idSektor == 1 && (
                  <>
                    <Row>
                      <Col md={6}>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('kontrak-produsen')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='produsen'
                              isDisabled
                              placeholder={t('pilih')}
                              defaultValue={
                                salesArea[
                                  salesArea.findIndex(
                                    (item: any) => item.label === tempData?.produsen?.name
                                  )
                                ]
                              }
                              options={salesArea}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-incoterm1')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='incoterm1'
                              key={idSektor + produsen}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullIncoterm[
                                  fullIncoterm.findIndex(
                                    (item: any) => item.label === incoterm1Desc
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                              }}
                              options={fullIncoterm}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-provinsi')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='provinsi'
                              key={idSektor + produsen}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullProvince[
                                  fullProvince.findIndex((item: any) => item.label === provinceDesc)
                                ]
                              }
                              onChange={(e: any) => {
                                setFullCity([])
                                cityData(e?.value)
                              }}
                              options={fullProvince}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-jenis')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='jenis'
                              onChange={(e: any) => productTypeChange(e.target.value)}
                            >
                              <option hidden value='~#~'>
                                {t('Pilih-productType')}
                              </option>
                              {fullProductType.map((item: any) => {
                                return (
                                  <>
                                    {item.id != 12 && (
                                      <>
                                        {item.material_group_desc == tempData?.product_type_desc ? (
                                          <option
                                            selected
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        ) : (
                                          <option
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        )}
                                      </>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        {parseInt(pnumber) == 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>
                                Custom Product Name<span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                placeholder=' Custom Product Name'
                                size='sm'
                                defaultValue={pname}
                                aria-label='Default select example'
                                type='text'
                                id='custom'
                                onChange={(e: any) => setPname(e.target.value)}
                              />
                            </Col>
                          </Row>
                        )}
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('Kuantum Pengajuan')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <CurrencyInput
                                className='form-control form-control-sm'
                                id='kuantum'
                                // key={pname}
                                placeholder={t('Kuantum Pengajuan')}
                                defaultValue={quantum}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                onValueChange={(value: any) => {
                                  setQuantum(value?.replace(/,/g, '.'))
                                }}
                                decimalsLimit={3}
                              />
                              <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col sm={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('Shipping Tolerance')}</p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <Form.Control
                                placeholder={t('Shipping Tolerance')}
                                type='number'
                                id='shipping'
                                defaultValue={shipping}
                                onChange={(e: any) => setShipping(parseFloat(e.target.value))}
                              />
                              <InputGroup.Text id='basic-addon2'>
                                <span className='px-2'>%</span>
                              </InputGroup.Text>
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-payment1')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='payment1'
                              onChange={(e: any) => separateValue(setPay1, e.target.value, setPay1Desc)}
                            >
                              <option hidden value='~#~'>
                                {t('Pilih-payment')}
                              </option>
                              {fullPayment.map((item: any) => {
                                return (
                                  <>
                                    {item.code == tempData?.payment_type_1 ? (
                                      <option
                                        selected
                                        value={item.code + '~#~' + item.payment_desc_id}
                                      >
                                        {item.payment_desc_id}
                                      </option>
                                    ) : (
                                      <option value={item.code + '~#~' + item.payment_desc_id}>
                                        {item.payment_desc_id}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('keterangan')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              as='textarea'
                              defaultValue={tempData?.payment_note}
                              placeholder={t('keterangan')}
                              id='keterangan'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => setketerangan(e.target.value)}
                            />
                          </Col>
                        </Row>
                        {parseInt(pnumber) != 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className=' mt-4 fs-6'>
                                {t('segment')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={8}>
                              <Form.Select
                                size='sm'
                                id='segment'
                                onChange={(e: any) =>
                                  separateValue(setSegment, e.target.value, setSegmentDesc)
                                }
                                aria-label='Default select example'
                              >
                                {fullSegment.map((item: any) => {
                                  if (item.code == 'Z2' || item.code == 'Z3') {
                                    if (item.code == segment) {
                                      return (
                                        <option selected value={item.code + '~#~' + item.name}>
                                          {item.name}
                                        </option>
                                      )
                                    } else {
                                      return (
                                        <option value={item.code + '~#~' + item.name}>
                                          {item.name}
                                        </option>
                                      )
                                    }
                                  } else {
                                    return null
                                  }
                                })}
                              </Form.Select>
                            </Col>
                          </Row>
                        )}
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('End Customer')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            {isNoEnduser ? (
                              <Form.Control
                                size='sm'
                                as='textarea'
                                id='enduser'
                                placeholder={t('End Customer')}
                                defaultValue={tempData?.end_user}
                                onChange={(e: any) => {
                                  setEnduser(e.target.value)
                                  setEnduserDesc(e.target.value)
                                }}
                              />
                            ) : (
                              <MultiSelect
                                options={fullEndUser?.map((item: any) => {
                                  return {label: item.name, value: item.name}
                                })}
                                value={arrayEnduser}
                                onChange={(e: any) => setEnduserArray(e)}
                                labelledBy='Select'
                              />
                            )}
                          </Col>
                        </Row>
                        {idSektor == 1 && parseInt(pnumber) != 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}></Col>
                            <Col sm={8} className='d-flex'>
                              <Form.Check
                                onClick={() => setIsNoEnduser(!isNoEnduser)}
                                defaultChecked={isNoEnduser}
                                // disabled={ptype == 'P13'}
                                name='ppn'
                                className='mb-2'
                                type='checkbox'
                                id='noenduser'
                              />
                              {i18next.language == 'en' ? (
                                <p className='ms-2 fs-6'>{t('TidakAdaEndUser')}</p>
                              ) : (
                                <p className='ms-2 fs-6'>{t('TidakAdaEndUser')}</p>
                              )}
                            </Col>
                          </Row>
                        )}
                      </Col>
                      <Col md={6}>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-sektor')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              size='sm'
                              aria-label='Default select example'
                              id='sektor'
                              disabled
                              value={tempData?.sector?.name}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='incoterm2'
                              key={idSektor + produsen}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullIncoterm2[
                                  fullIncoterm2.findIndex(
                                    (item: any) => item.label === incoterm2Desc
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                              }}
                              options={fullIncoterm2}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-kota')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='kota'
                              key={province}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullCity[fullCity.findIndex((item: any) => item.label === cityDesc)]
                              }
                              onChange={(e: any) => {
                                separateValue2(setCity, e?.value, setCityDesc)
                                // fieldClearer(4)
                              }}
                              options={fullCity}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-produk')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='produk'
                              key={ptype}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullProductName[
                                  fullProductName.findIndex(
                                    (item: any) => item.truevalue == parseInt(pnumber)
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                productNameChange(e?.value)
                              }}
                              options={fullProductName}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('Harga Pengajuan')}/Ton<span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <InputGroup.Text>
                                <span className='px-1'>Rp</span>
                              </InputGroup.Text>
                              {isFormulatedPrice ? (
                                <CurrencyInput
                                  className='form-control form-control-sm'
                                  id='hargap'
                                  disabled
                                  value={0}
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  decimalsLimit={-1}
                                />
                              ) : (
                                <CurrencyInput
                                  className='form-control form-control-sm'
                                  id='hargap'
                                  // key={pname}
                                  defaultValue={subprice}
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  onValueChange={(value: any) => {
                                    setSubprice(value?.replace(/,/g, '.'))
                                  }}
                                  decimalsLimit={-1}
                                  placeholder={t('Harga Pengajuan')}
                                />
                              )}
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='mt-5 fs-6'>{t('termasuk-ppn')}</p>
                          </Col>
                          <Col sm={8} className='d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='ppn'
                              className='mt-5 mb-2'
                              type='checkbox'
                              id='ckbox-ppn'
                              defaultChecked={tempData?.include_ppn}
                              onClick={() => {
                                setEditIncludePPN(!editIncludePPN)
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='mt-5 fs-6'>{t('Formulated Price')}</p>
                          </Col>
                          <Col sm={8} className='d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='formula'
                              className='mt-5 mb-2'
                              type='checkbox'
                              id='ckbox-formula'
                              defaultChecked={isFormulatedPrice}
                              onClick={() => {
                                setIsFormulatedPrice(!isFormulatedPrice)
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='payment2'
                              onChange={(e: any) => separateValue(setPay2, e.target.value, setPay2Desc)}
                            >
                              <option value='~#~'>{t('Pilih-payment')}</option>
                              {fullPayment.map((item: any) => {
                                return (
                                  <>
                                    {item.code == tempData?.payment_type_2 ? (
                                      <option
                                        selected
                                        value={item.code + '~#~' + item.payment_desc_id}
                                      >
                                        {item.payment_desc_id}
                                      </option>
                                    ) : (
                                      <option value={item.code + '~#~' + item.payment_desc_id}>
                                        {item.payment_desc_id}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              placeholder={t('sub-order-spek')}
                              as='textarea'
                              defaultValue={tempData?.product_spec}
                              id='spek'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => setPspec(e.target.value)}
                            />
                          </Col>
                        </Row>
                        {parseInt(pnumber) != 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('sub-order-catatan')}
                                defaultValue={tempData?.notes}
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                                onChange={(e: any) => setNote(e.target.value)}
                              />
                            </Col>
                          </Row>
                        )}
                        {idSektor == 1 && pnumber == '0' && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              {i18next.language == 'en' ? (
                                <p className='fs-6 mt-3'>{t('TidakAdaEndUser')}</p>
                              ) : (
                                <p className='fs-6'>{t('TidakAdaEndUser')}</p>
                              )}
                            </Col>
                            <Col sm={8}>
                              <Form.Check
                                onClick={() => setIsNoEnduser(!isNoEnduser)}
                                defaultChecked={isNoEnduser}
                                // disabled={ptype == 'P13'}
                                name='ppn'
                                id='noenduser'
                                className='mt-5 mb-2'
                                type='checkbox'
                              />
                            </Col>
                          </Row>
                        )}
                        {parseInt(pnumber) == 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className=' mt-3 fs-6'>
                                {t('segment')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={8}>
                              <Form.Select
                                size='sm'
                                id='segment'
                                onChange={(e: any) =>
                                  separateValue(setSegment, e.target.value, setSegmentDesc)
                                }
                                aria-label='Default select example'
                              >
                                {fullSegment.map((item: any) => {
                                  if (item.code == 'Z2' || item.code == 'Z3') {
                                    if (item.code == segment) {
                                      return (
                                        <option selected value={item.code + '~#~' + item.name}>
                                          {item.name}
                                        </option>
                                      )
                                    } else {
                                      return (
                                        <option value={item.code + '~#~' + item.name}>
                                          {item.name}
                                        </option>
                                      )
                                    }
                                  } else {
                                    return null
                                  }
                                })}
                              </Form.Select>
                            </Col>
                          </Row>
                        )}
                        { tempData?.sector_id != 2 && <>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('alasan perpanjangan')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('alasan perpanjangan')}
                                defaultValue={tempData?.amandement_notes}
                                size='sm'
                                style={{height: '40px'}}
                                onChange={(e: any) => setAlasan(e.target.value)}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('tanggal perpanjangan')}</p>
                            </Col>
                            <Col sm={8}>
                              <input
                                type='date'
                                defaultValue={tempData?.extension_date}
                                style={{height: '40px'}}
                                onChange={(e: any) => {
                                  setTanggalPerpanjangan(e.target.value)
                                }}
                                className='form-control form-control-sm'
                              />
                            </Col>
                          </Row>
                        </> }
                      </Col>
                    </Row>
                  </>
                )}

                {idSektor == 2 && (
                  <>
                    <Row>
                      <Col md={6}>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>
                              {t('kontrak-produsen')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control disabled value={tempData?.produsen?.name} />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>
                              {t('sub-order-incoterm1')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='incoterm1'
                              key={idSektor}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullIncoterm[
                                  fullIncoterm.findIndex(
                                    (item: any) => item.label === incoterm1Desc
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                              }}
                              options={fullIncoterm}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>
                              {t('sub-order-provinsi')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='provinsi'
                              key={idSektor}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullProvince[
                                  fullProvince.findIndex((item: any) => item.label === provinceDesc)
                                ]
                              }
                              onChange={(e: any) => {
                                setFullCity([])
                                cityData(e?.value)
                              }}
                              options={fullProvince}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>{t('sub-order-gudang')}</p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='gudang'
                              key={city}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullPlant[
                                  fullPlant.findIndex(
                                    (item: any) => item.label === warehouse + '-' + warehouseDesc
                                  )
                                ]
                              }
                              onChange={(e: any) => plantChange(e?.value)}
                              options={fullPlant}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='mt-3'>
                              {t('sub-order-produk')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='produk'
                              key={ptype}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullProductName[
                                  fullProductName.findIndex((item: any) => item.label === pname)
                                ]
                              }
                              onChange={(e: any) => {
                                productNameChange(e?.value)
                              }}
                              options={fullProductName}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('Kuantum Pengajuan')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <CurrencyInput
                                className='form-control form-control-sm'
                                id='kuantum'
                                // key={pname}
                                placeholder={t('Kuantum Pengajuan')}
                                defaultValue={quantum}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                onValueChange={(value: any) => {
                                  setQuantum(value?.replace(/,/g, '.'))
                                }}
                                decimalsLimit={3}
                              />
                              <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>
                              {t('sub-order-payment1')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='payment1'
                              onChange={(e: any) => separateValue(setPay1, e.target.value, setPay1Desc)}
                            >
                              <option hidden value='~#~'>
                                {t('Pilih-payment')}
                              </option>
                              {fullPayment.map((item: any) => {
                                return (
                                  <>
                                    {item.payment_desc_id == tempData?.payment_type_1_desc ? (
                                      <option
                                        selected
                                        value={item.code + '~#~' + item.payment_desc_id}
                                      >
                                        {item.payment_desc_id}
                                      </option>
                                    ) : (
                                      <option value={item.code + '~#~' + item.payment_desc_id}>
                                        {item.payment_desc_id}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6'>{t('keterangan')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              as='textarea'
                              defaultValue={tempData?.payment_note}
                              placeholder={t('keterangan')}
                              id='keterangan'
                              disabled
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => setketerangan(e.target.value)}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('End Customer')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              size='sm'
                              as='textarea'
                              id='enduser'
                              disabled
                              placeholder={t('End Customer')}
                              defaultValue={tempData.end_user}
                              onChange={(e: any) => setEnduser(e.target.value)}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md={6}>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>
                              {t('sub-order-sektor')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            {localStorage.getItem('cust-group') != 'AR06' ? (
                              <Form.Control
                                type='text'
                                size='sm'
                                disabled
                                value={tempData?.sector?.name}
                              />
                            ) : (
                              <Form.Control type='text' size='sm' disabled value='Export' />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='incoterm2'
                              key={idSektor}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullIncoterm2[
                                  fullIncoterm2.findIndex(
                                    (item: any) => item.label === tempData?.incoterm2_id
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                              }}
                              options={fullIncoterm2}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>
                              {t('sub-order-kota')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='kota'
                              key={provinceDesc}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullCity[fullCity.findIndex((item: any) => item.label === cityDesc)]
                              }
                              onChange={(e: any) => {
                                separateValue2(setCity, e?.value, setCityDesc)
                                // fieldClearer(4)
                              }}
                              options={fullCity}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>
                              {t('sub-order-jenis')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='jenis'
                              onChange={(e: any) => productTypeChange(e.target.value)}
                            >
                              <option hidden value='~#~'>
                                {t('Pilih-productType')}
                              </option>
                              {fullProductType.map((item: any) => {
                                return (
                                  <>
                                    {item.id != 12 && (
                                      <>
                                        {item.material_group == ptype2 ? (
                                          <option
                                            selected
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        ) : (
                                          <option
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        )}
                                      </>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              placeholder={t('sub-order-spek')}
                              as='textarea'
                              defaultValue={tempData?.product_spec}
                              id='spek'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => setPspec(e.target.value)}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('Price')}/Ton<span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              placeholder={t('Price')}
                              size='sm'
                              key={pnumber}
                              type='text'
                              value={
                                'Rp' + i18next.language === 'en'
                                  ? parseInt(subprice).toLocaleString('en')
                                  : parseInt(subprice).toLocaleString('id')
                              }
                              id='hargap'
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-4'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='payment2'
                              onChange={(e: any) => separateValue(setPay2, e.target.value, setPay2Desc)}
                            >
                              {/* <option selected hidden disabled>{t(tempData?.payment_type_2)}</option> */}
                              <option hidden value='~#~'>
                                {t('Pilih-payment')}
                              </option>
                              {fullPayment.map((item: any) => {
                                return (
                                  <>
                                    {item.payment_desc_id == tempData?.payment_type_2_desc ? (
                                      <option
                                        selected
                                        value={item.code + '~#~' + item.payment_desc_id}
                                      >
                                        {item.payment_desc_id}
                                      </option>
                                    ) : (
                                      <option value={item.code + '~#~' + item.payment_desc_id}>
                                        {item.payment_desc_id}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              as='textarea'
                              placeholder={t('sub-order-catatan')}
                              defaultValue={tempData?.notes}
                              id='note'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => setNote(e.target.value)}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                )}

                <div className='d-flex justify-content-end mt-5'>
                  <Button variant='primary' onClick={() => addAmandement()} disabled={btnLoading}>
                    {btnLoading ? (
                      <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                      <>
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr075.svg'
                          className='svg-icon-3'
                        />
                        {t('order-kirim')}
                      </>
                    )}
                  </Button>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        {/* modal amandemen approval */}
        <Modal
          show={showAmandemendApproval}
          onHide={() => setShowAmandemendApproval(false)}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t('amandement')} {t('Order')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              loadingDetail ?
              <>
                <SkeletonForm />
              </>
              : <>
                {idSektor == 1 && (
                  <Row>
                    <Col md='6'>
                      <h5 className='mb-3 text-danger'>{t('Before')}</h5>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            defaultChecked={checkDetector[tempIndex]?.sales_org_code}
                            type='checkbox'
                            id={'ck-sales'}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>Sales Org</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2?.produsen?.name}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            defaultChecked={checkDetector[tempIndex]?.sector_id}
                            type='checkbox'
                            id={'ck-sektor'}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={t(tempData2?.sector?.name)}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            defaultChecked={checkDetector[tempIndex]?.incoterm1_id}
                            id={'ck-incoterm1'}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2?.incoterm1?.code}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            defaultChecked={checkDetector[tempIndex]?.incoterm2_id}
                            id={'ck-incoterm2'}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                        </Col>
                        <Col md={7}>
                          {tempData2?.incoterm2 == null ? (
                            <Form.Control
                              value={
                                tempData2?.incoterm2_id == null || tempData2?.incoterm2_id == '0'
                                  ? ''
                                  : tempData2?.incoterm2_id
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          ) : (
                            <Form.Control
                              value={tempData2?.incoterm2?.code}
                              type='text'
                              disabled
                              size='sm'
                            />
                          )}
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-provinsi'}
                            defaultChecked={checkDetector[tempIndex]?.province_id}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            type='text'
                            value={tempData2.province?.region_name}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-kota'}
                            defaultChecked={checkDetector[tempIndex]?.city_id}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            type='text'
                            value={tempData2.city?.city_name}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-segment'}
                            defaultChecked={checkDetector[tempIndex]?.segment_code}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('segment')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            type='text'
                            value={t(tempData2.segment_name)}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      {tempData2.is_so_release == false ? (
                        <Row className='mb-4'>
                          <Col md={1}>
                            <input
                              disabled
                              className='form-check-input mt-3'
                              type='checkbox'
                              id={'ck-plant'}
                            />
                          </Col>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control type='text' value={tempData2.plant_desc} disabled size='sm' />
                          </Col>
                        </Row>
                      ) : (
                        ''
                      )}

                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-jenis'}
                            defaultChecked={checkDetector[tempIndex]?.product_type}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2.product_type_desc}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-produk'}
                            defaultChecked={checkDetector[tempIndex]?.product_name}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control value={tempData2.product_name} type='text' disabled size='sm' />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-kuantum'}
                            defaultChecked={checkDetector[tempIndex]?.request_quantum}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={
                              i18next.language === 'en'
                                ? parseFloat(tempData2?.fixed_quantum).toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  }) + ' Ton'
                                : parseFloat(tempData2?.fixed_quantum).toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  }) + ' Ton'
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}></Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sisaquantum')}</p>
                        </Col>
                        <Col md={7}>
                          {tempData2.so_qty_realized == undefined ? (
                            <Form.Control
                              value={
                                i18next.language === 'en'
                                  ? parseFloat(tempData2?.fixed_quantum).toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    }) + ' Ton'
                                  : parseFloat(tempData2?.fixed_quantum).toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    }) + ' Ton'
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          ) : (
                            <Form.Control
                              value={
                                i18next.language === 'en'
                                  ? (
                                      parseFloat(tempData2.fixed_quantum) -
                                      parseFloat(tempData2.so_qty_realized)
                                    ).toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    }) + ' Ton'
                                  : (
                                      parseFloat(tempData2.fixed_quantum) -
                                      parseFloat(tempData2.so_qty_realized)
                                    ).toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    }) + ' Ton'
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          )}
                        </Col>
                      </Row>
                      <Row className='mb-2'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-harga'}
                            defaultChecked={checkDetector[tempIndex]?.request_price}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/Ton</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={
                              'Rp' + i18next.language === 'en'
                                ? parseInt(tempData2?.fixed_price).toLocaleString('en') + '/Ton'
                                : parseInt(tempData2?.fixed_price).toLocaleString('id') + '/Ton'
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-ppn'}
                            defaultChecked={checkDetector[tempIndex]?.include_ppn}
                          />
                        </Col>
                        <Col sm={4}>
                          <p className='mt-4 fs-6'>{t('termasuk-ppn')}</p>
                        </Col>
                        <Col sm={7} className='d-flex justify-content-start'>
                          <Form.Check
                            reverse
                            name='ppn'
                            className='mt-5 mb-2'
                            type='checkbox'
                            id='ckbox-ppn'
                            checked={tempData2?.include_ppn}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-shipping'}
                            defaultChecked={checkDetector[tempIndex]?.shipping_tolerance}
                          />
                        </Col>
                        <Col sm={4}>
                          <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                        </Col>
                        <Col sm={7} className='d-flex justify-content-start'>
                          <Form.Control
                            disabled
                            size='sm'
                            type='text'
                            value={
                              tempData2?.shipping_tolerance == 0
                                ? ''
                                : tempData2?.shipping_tolerance + '%'
                            }
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-payment1'}
                            defaultChecked={checkDetector[tempIndex]?.payment_type_1}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2?.payment_type_1_desc}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-payment2'}
                            defaultChecked={checkDetector[tempIndex]?.payment_type_2}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2?.payment_type_2_desc}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            defaultChecked={checkDetector[tempIndex]?.payment_note}
                            type='checkbox'
                            id={'ck-keterangan'}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('keterangan')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2?.payment_note}
                            as='textarea'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-spek'}
                            defaultChecked={checkDetector[tempIndex]?.product_spec}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2.product_spec}
                            as='textarea'
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-enduser'}
                            defaultChecked={checkDetector[tempIndex]?.end_user}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('End Customer')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={
                              tempData2.end_user_multiple
                                ? handleShowValue(tempData2.end_user)
                                : tempData2.end_user
                            }
                            as='textarea'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-catatan'}
                            defaultChecked={checkDetector[tempIndex]?.notes}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2?.notes}
                            as='textarea'
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      { tempData2?.sector_id != 2 && <>
                        <Row className='mb-4'>
                          <Col md={1}>
                            <input
                              className='form-check-input mt-3'
                              type='checkbox'
                              id={'ck-alasan-perpanjangan'}
                              defaultChecked={checkDetector[tempIndex]?.amandement_notes}
                            />
                          </Col>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={tempData2?.amandement_notes}
                              as='textarea'
                              style={{height: '40px'}}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={1}>
                            <input
                              className='form-check-input mt-3'
                              type='checkbox'
                              id={'ck-periode-perpanjangan'}
                              defaultChecked={checkDetector[tempIndex]?.extension_date}
                            />
                          </Col>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={tempData2?.extension_date}
                              style={{height: '40px'}}
                              type='date'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </> }
                    </Col>
                    <Col md='6' className='ps-4'>
                      <h5 className='mb-3' style={{color: '#2664b5'}}>
                        {t('After')}
                      </h5>
                      <Row className='mb-4'>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>Sales Org</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            value={tempData.produsen?.name}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            value={t(tempData.sector?.name)}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.incoterm1?.id != incoterm1 ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={tempData.incoterm1?.code}
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                          <Select
                            id='incoterm1'
                            key={idSektor + produsen}
                            placeholder={t('pilih')}
                            defaultValue={
                              fullIncoterm[
                                fullIncoterm.findIndex(
                                  (item: any) => item.label === tempData.incoterm1?.code
                                )
                              ]
                            }
                            onChange={(e: any) => {
                              separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                            }}
                            options={fullIncoterm}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={
                          ((tempData2?.incoterm2?.id || tempData2?.incoterm2_id) != incoterm2)
                          ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                        </Col>
                        <Col md={8}>
                          <Select
                            id='incoterm2'
                            key={idSektor + produsen + fullIncoterm2}
                            placeholder={t('pilih')}
                            defaultValue={
                              fullIncoterm2[
                                fullIncoterm2.findIndex((item: any) => item.label === incoterm2Desc)
                              ]
                            }
                            onChange={(e: any) => {
                              separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                            }}
                            options={fullIncoterm2}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.province_id != province ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            type='text'
                            value={tempData.province?.region_name}
                            disabled
                            size='sm'
                          /> */}
                          <Select
                            id='provinsi'
                            key={idSektor + produsen}
                            placeholder={t('pilih')}
                            defaultValue={
                              fullProvince[
                                fullProvince.findIndex(
                                  (item: any) => item.label === tempData.province?.region_name
                                )
                              ]
                            }
                            onChange={(e: any) => {
                              setFullCity([])
                              cityData(e?.value)
                            }}
                            options={fullProvince}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.city_id != city ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            type='text'
                            value={tempData.city?.city_name}
                            disabled
                            size='sm'
                          /> */}
                          <Select
                            id='kota'
                            key={province}
                            placeholder={t('pilih')}
                            defaultValue={
                              fullCity[
                                fullCity.findIndex(
                                  (item: any) => item.label === tempData.city?.city_name
                                )
                              ]
                            }
                            onChange={(e: any) => {
                              separateValue2(setCity, e?.value, setCityDesc)
                              // fieldClearer(4)
                            }}
                            options={fullCity}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.segment_name != segmentDesc ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('segment')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control type='text' value={t(tempData.segment_name)} disabled size='sm' /> */}
                          <Form.Select
                            size='sm'
                            id='segment'
                            onChange={(e: any) => separateValue(setSegment, e.target.value, setSegmentDesc)}
                            aria-label='Default select example'
                          >
                            {fullSegment.map((item: any) => {
                              if (item.code == 'Z2' || item.code == 'Z3') {
                                if (item.code == tempData.segment_code) {
                                  return (
                                    <option selected value={item.code + '~#~' + item.name}>
                                      {item.name}
                                    </option>
                                  )
                                } else {
                                  return (
                                    <option value={item.code + '~#~' + item.name}>{item.name}</option>
                                  )
                                }
                              } else {
                                return null
                              }
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                      {tempData2.is_so_release == false ? (
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control type='text' value={tempData.plant_desc} disabled size='sm' />
                          </Col>
                        </Row>
                      ) : (
                        ''
                      )}

                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.product_type_desc != tempData.product_type_desc ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={tempData.product_type_desc}
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                          <Form.Select
                            size='sm'
                            aria-label='Default select example'
                            id='jenis'
                            onChange={(e: any) => productTypeChange(e.target.value)}
                          >
                            <option hidden value='~#~'>
                              {t('Pilih-productType')}
                            </option>
                            {fullProductType.map((item: any) => {
                              return (
                                <>
                                  {item.id != 12 && (
                                    <>
                                      {item.material_group_desc == tempData?.product_type_desc ? (
                                        <option
                                          selected
                                          value={item.material_group_desc + '~#~' + item.material_group}
                                        >
                                          {t(item.material_group_desc)}
                                        </option>
                                      ) : (
                                        <option
                                          value={item.material_group_desc + '~#~' + item.material_group}
                                        >
                                          {t(item.material_group_desc)}
                                        </option>
                                      )}
                                    </>
                                  )}
                                </>
                              )
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.material_number != tempData.material_number ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control value={tempData.product_name} type='text' disabled size='sm' /> */}
                          <Select
                            id='produk'
                            key={ptype + fullProductName}
                            placeholder={t('pilih')}
                            defaultValue={
                              fullProductName[
                                fullProductName.findIndex(
                                  (item: any) => item.truevalue == parseInt(tempData.material_number)
                                )
                              ]
                            }
                            onChange={(e: any) => {
                              productNameChange(e?.value)
                            }}
                            options={fullProductName}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.fixed_quantum != quantum ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                        </Col>
                        <Col md={8}>
                          <InputGroup size='sm'>
                            <CurrencyInput
                              className='form-control form-control-sm'
                              id='kuantum'
                              // key={pname}
                              placeholder={t('Kuantum Pengajuan')}
                              defaultValue={
                                parseFloat(tempData2.so_qty_realized) +
                                parseFloat(tempData.fixed_quantum)
                              }
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                setQuantum(value?.replace(/,/g, '.'))
                                // console.log(value)
                              }}
                              decimalsLimit={3}
                            />
                            <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                          </InputGroup>
                          {/* <Form.Control
                            value={
                              i18next.language === 'en'
                                ? (
                                  parseFloat(tempData.fixed_quantum) -
                                  parseFloat(tempData.so_qty_realized)
                                )?.toLocaleString('en', { maximumFractionDigits: 4 }) + ' Ton'
                                : (
                                  parseFloat(tempData.fixed_quantum) -
                                  parseFloat(tempData.so_qty_realized)
                                )?.toLocaleString('id', { maximumFractionDigits: 4 }) + ' Ton'
                            }
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}></Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6 opacity-0'>{t('Kuantum Pengajuan')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control type='text' className='opacity-0' disabled size='sm' />
                        </Col>
                      </Row>
                      <Row className='mb-2'>
                        <Col md={4} className={tempData2?.fixed_price != subprice ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/Ton</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={
                              i18next.language === 'en'
                                ? 'Rp' + parseInt(tempData?.fixed_price).toLocaleString('en') + '/Ton'
                                : 'Rp' + parseInt(tempData?.fixed_price).toLocaleString('id') + '/Ton'
                            }
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                          <InputGroup size='sm'>
                            <InputGroup.Text>
                              <span className='px-1'>Rp</span>
                            </InputGroup.Text>
                            {isFormulatedPrice ? (
                              <CurrencyInput
                                className='form-control form-control-sm'
                                id='hargap'
                                disabled
                                defaultValue={0}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                decimalsLimit={-1}
                              />
                            ) : (
                              <CurrencyInput
                                className='form-control form-control-sm'
                                id='hargap'
                                // key={pname}
                                defaultValue={tempData.request_price}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                onValueChange={(value: any) => {
                                  setSubprice(value?.replace(/,/g, '.'))
                                }}
                                decimalsLimit={-1}
                                placeholder={t('Harga Pengajuan')}
                              />
                            )}
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col sm={4} className={tempData2?.include_ppn != includePPN ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-5 fs-6'>{t('termasuk-ppn')}</p>
                        </Col>
                        <Col sm={8} className='d-flex justify-content-start'>
                          <Form.Check
                            reverse
                            name='ppn'
                            className='mt-5 mb-2'
                            type='checkbox'
                            id='ckbox-ppn'
                            onClick={() => setIncludePPN(!includePPN)}
                            defaultChecked={tempData?.include_ppn}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col sm={4} className={tempData2?.shipping_tolerance != shipping ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                        </Col>
                        <Col sm={8} className='d-flex justify-content-start'>
                          {/* <Form.Control
                            disabled
                            size='sm'
                            type='text'
                            value={tempData?.shipping_tolerance == 0 ? '' : tempData?.shipping_tolerance + '%'}
                          /> */}
                          <InputGroup size='sm'>
                            <Form.Control
                              placeholder={t('Shipping Tolerance')}
                              type='number'
                              id='shipping'
                              defaultValue={tempData.shipping_tolerance}
                              onChange={(e: any) => setShipping(parseFloat(e.target.value))}
                            />
                            <InputGroup.Text id='basic-addon2'>
                              <span className='px-2'>%</span>
                            </InputGroup.Text>
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.payment_type_1 != pay1 ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={t(tempData?.payment_type_1_desc)}
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                          <Form.Select
                            size='sm'
                            aria-label='Default select example'
                            id='payment1'
                            onChange={(e: any) => separateValue(setPay1, e.target.value, setPay1Desc)}
                          >
                            <option hidden value='~#~'>
                              {t('Pilih-payment')}
                            </option>
                            {fullPayment.map((item: any) => {
                              return (
                                <>
                                  {item.code == tempData?.payment_type_1 ? (
                                    <option selected value={item.code + '~#~' + item.payment_desc_id}>
                                      {item.payment_desc_id}
                                    </option>
                                  ) : (
                                    <option value={item.code + '~#~' + item.payment_desc_id}>
                                      {item.payment_desc_id}
                                    </option>
                                  )}
                                </>
                              )
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.payment_type_2 != pay2 ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={t(tempData?.payment_type_2_desc)}
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                          <Form.Select
                            size='sm'
                            aria-label='Default select example'
                            id='payment2'
                            onChange={(e: any) => separateValue(setPay2, e.target.value, setPay2Desc)}
                          >
                            <option value='~#~'>{t('Pilih-payment')}</option>
                            {fullPayment.map((item: any) => {
                              return (
                                <>
                                  {item.code == tempData?.payment_type_2 ? (
                                    <option selected value={item.code + '~#~' + item.payment_desc_id}>
                                      {item.payment_desc_id}
                                    </option>
                                  ) : (
                                    <option value={item.code + '~#~' + item.payment_desc_id}>
                                      {item.payment_desc_id}
                                    </option>
                                  )}
                                </>
                              )
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={(tempData2?.payment_note || "") != (keterangan || "") ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('keterangan')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={t(tempData?.payment_note)}
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                          <Form.Control
                            as='textarea'
                            defaultValue={tempData?.payment_note}
                            placeholder={t('keterangan')}
                            id='keterangan'
                            size='sm'
                            onChange={(e: any) => setketerangan(e.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={(tempData2?.product_spec || "") != (pspec || "") ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control value={tempData.product_spec} as='textarea' style={{ height: '40px' }} type='text' disabled size='sm' /> */}
                          <Form.Control
                            placeholder={t('sub-order-spek')}
                            as='textarea'
                            defaultValue={tempData?.product_spec}
                            id='spek'
                            size='sm'
                            onChange={(e: any) => setPspec(e.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4' style={{height: '58px'}}>
                        <Col md={4} className={(
                          (isNoEnduser && tempData2.end_user != enduser)
                          || (!isNoEnduser && tempData2.end_user != arrayEnduser.map((item: any) => item.label).join(","))
                        ) ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('End Customer')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={tempData.end_user_multiple ? handleShowValue(tempData.end_user) : tempData.end_user}
                            as='textarea'
                            disabled
                            size='sm'
                          /> */}
                          {isNoEnduser ? (
                            <Form.Control
                              size='sm'
                              as='textarea'
                              id='enduser'
                              placeholder={t('End Customer')}
                              defaultValue={enduserDesc}
                              onChange={(e: any) => {
                                setEnduser(e.target.value)
                                setEnduserDesc(e.target.value)
                              }}
                            />
                          ) : (
                            <MultiSelect
                              options={fullEndUser?.map((item: any) => {
                                return {label: item.name, value: item.name}
                              })}
                              value={arrayEnduser}
                              onChange={(e: any) => setEnduserArray(e)}
                              labelledBy='Select'
                            />
                          )}
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={(tempData2?.notes || "") != (note || "") ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control value={tempData?.notes} as='textarea' style={{ height: '40px' }} type='text' disabled size='sm' /> */}
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            defaultValue={tempData?.notes}
                            id='note'
                            size='sm'
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                      { tempData2?.sector_id != 2 && <>
                        <Row className='mb-4'>
                          <Col md={4} className={tempData2?.amandement_notes != alasan ? 'text-light-primary fw-bold' : ''}>
                            <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              as='textarea'
                              placeholder={t('alasan perpanjangan')}
                              defaultValue={alasan}
                              disabled={false}
                              id='note'
                              onChange={(e: any) => setAlasan(e.target.value)}
                              size='sm'
                              style={{height: '40px'}}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4} className={tempData2?.extension_date != tanggalPerpanjangan ? 'text-light-primary fw-bold' : ''}>
                            <p className='fs-6 mt-3'>{t('tanggal perpanjangan')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              defaultValue={tanggalPerpanjangan}
                              style={{height: '40px'}}
                              disabled={false}
                              onChange={(e: any) => setTanggalPerpanjangan(e.target.value)}
                              type='date'
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </> }
                    </Col>
                  </Row>
                )}

                {idSektor == 3 && (
                  <Row>
                    <Col md='6'>
                      <h5 className='mb-3 text-danger'>{t('Before')}</h5>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id='ck-sales'
                            defaultChecked={checkDetector[tempIndex]?.sales_org_code}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>Sales Org</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2.produsen?.name}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-sektor'}
                            defaultChecked={checkDetector[tempIndex]?.sector_id}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={t(tempData2.sector?.name)}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            defaultChecked={checkDetector[tempIndex]?.incoterm1_id}
                            type='checkbox'
                            id={'ck-incoterm1'}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2.incoterm1?.code}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            defaultChecked={checkDetector[tempIndex]?.incoterm2_id}
                            type='checkbox'
                            id={'ck-incoterm2'}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                        </Col>
                        <Col md={7}>
                          {tempData2?.incoterm2 == null ? (
                            <Form.Control
                              value={
                                tempData2?.incoterm2_id == null || tempData2?.incoterm2_id == '0'
                                  ? ''
                                  : tempData2?.incoterm2_id
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          ) : (
                            <Form.Control
                              value={tempData2?.incoterm2?.code}
                              type='text'
                              disabled
                              size='sm'
                            />
                          )}
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-provinsi'}
                            defaultChecked={checkDetector[tempIndex]?.province_id}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            type='text'
                            value={tempData2.province?.region_name}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-kota'}
                            defaultChecked={checkDetector[tempIndex]?.city_id}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            type='text'
                            value={tempData2.city?.city_name}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      {tempData2.is_so_release == false ? (
                        <Row className='mb-4'>
                          <Col md={1}>
                            <input
                              disabled
                              className='form-check-input mt-3'
                              type='checkbox'
                              id={'ck-plant'}
                            />
                          </Col>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control type='text' value={tempData2.plant_desc} disabled size='sm' />
                          </Col>
                        </Row>
                      ) : (
                        ''
                      )}

                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-jenis'}
                            defaultChecked={checkDetector[tempIndex]?.product_type}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2.product_type_desc}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-produk'}
                            defaultChecked={checkDetector[tempIndex]?.product_name}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control value={tempData2.product_name} type='text' disabled size='sm' />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-kuantum'}
                            defaultChecked={checkDetector[tempIndex]?.request_quantum}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={
                              i18next.language === 'en'
                                ? parseFloat(tempData2?.fixed_quantum).toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  }) + ' MT'
                                : parseFloat(tempData2?.fixed_quantum).toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  }) + ' MT'
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}></Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sisaquantum')}</p>
                        </Col>
                        <Col md={7}>
                          {tempData2.so_qty_realized == undefined ? (
                            <Form.Control
                              value={
                                i18next.language === 'en'
                                  ? parseFloat(tempData2?.fixed_quantum).toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    }) + ' MT'
                                  : parseFloat(tempData2?.fixed_quantum).toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    }) + ' MT'
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          ) : (
                            <Form.Control
                              value={
                                i18next.language === 'en'
                                  ? (
                                      parseFloat(tempData2.fixed_quantum) -
                                      parseFloat(tempData2.quantum_contract)
                                    ).toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    }) + ' MT'
                                  : (
                                      parseFloat(tempData2.fixed_quantum) -
                                      parseFloat(tempData2.quantum_contract)
                                    ).toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    }) + ' MT'
                              }
                              type='text'
                              disabled
                              size='sm'
                            />
                          )}
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-harga'}
                            defaultChecked={checkDetector[tempIndex]?.request_price}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/MT</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={'USD' + PriceFormater(tempData2?.fixed_price) + '/MT'}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-shipping'}
                            defaultChecked={checkDetector[tempIndex]?.shipping_tolerance}
                          />
                        </Col>
                        <Col sm={4}>
                          <p className='mt-4'>{t('Shipping Tolerance')}</p>
                        </Col>
                        <Col sm={7} className='d-flex justify-content-start'>
                          <Form.Control
                            disabled
                            type='text'
                            size='sm'
                            value={
                              tempData2?.shipping_tolerance == 0
                                ? ''
                                : tempData2?.shipping_tolerance + '%'
                            }
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-payment1'}
                            defaultChecked={checkDetector[tempIndex]?.payment_type_1}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2?.payment_type_1_desc}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-payment2'}
                            defaultChecked={checkDetector[tempIndex]?.payment_type_2}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2?.payment_type_2_desc}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            defaultChecked={checkDetector[tempIndex]?.payment_note}
                            type='checkbox'
                            id={'ck-keterangan'}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('keterangan')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2?.payment_note}
                            as='textarea'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-spek'}
                            defaultChecked={checkDetector[tempIndex]?.product_spec}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2.product_spec}
                            as='textarea'
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-enduser'}
                            defaultChecked={checkDetector[tempIndex]?.end_user}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('End Customer')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={
                              tempData2.end_user_multiple
                                ? handleShowValue(tempData2.end_user)
                                : tempData2.end_user
                            }
                            as='textarea'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}>
                          <input
                            className='form-check-input mt-3'
                            type='checkbox'
                            id={'ck-catatan'}
                            defaultChecked={checkDetector[tempIndex]?.notes}
                          />
                        </Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control
                            value={tempData2?.notes}
                            as='textarea'
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      { tempData2?.sector_id != 2 && <>
                        <Row className='mb-4'>
                          <Col md={1}>
                            <input
                              className='form-check-input mt-3'
                              type='checkbox'
                              id={'ck-alasan-perpanjangan'}
                              defaultChecked={checkDetector[tempIndex]?.amandement_notes}
                            />
                          </Col>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={tempData2?.amandement_notes}
                              as='textarea'
                              style={{height: '40px'}}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={1}>
                            <input
                              className='form-check-input mt-3'
                              type='checkbox'
                              id={'ck-periode-perpanjangan'}
                              defaultChecked={checkDetector[tempIndex]?.extension_date}
                            />
                          </Col>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                          </Col>
                          <Col md={7}>
                            <Form.Control
                              value={tempData2?.extension_date}
                              style={{height: '40px'}}
                              type='date'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </> }
                    </Col>
                    <Col md='6' className='ps-4'>
                      <h5 className='mb-3' style={{color: '#2664b5'}}>
                        {t('After')}
                      </h5>
                      <Row className='mb-4'>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>Sales Org</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            value={tempData.produsen?.name}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            value={t(tempData.sector?.name)}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.incoterm1?.id != incoterm1 ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={tempData.incoterm1?.code}
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                          <Select
                            id='incoterm1'
                            key={idSektor}
                            placeholder={t('pilih')}
                            defaultValue={
                              fullIncoterm[
                                fullIncoterm.findIndex(
                                  (item: any) => item.label === tempData?.incoterm1?.code
                                )
                              ]
                            }
                            onChange={(e: any) => {
                              separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                            }}
                            options={fullIncoterm}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={
                          ((tempData2?.incoterm2?.id || tempData2?.incoterm2_id) != incoterm2)
                          ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                        </Col>
                        <Col md={8}>
                          <Select
                            id='incoterm2'
                            key={idSektor}
                            placeholder={t('pilih')}
                            defaultValue={
                              fullIncoterm2[
                                fullIncoterm2.findIndex(
                                  (item: any) => item.label == tempData?.incoterm2_id || item.label == tempData?.incoterm2?.code
                                )
                              ]
                            }
                            onChange={(e: any) => {
                              separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                            }}
                            options={fullIncoterm2}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.province_id != province ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            type='text'
                            value={tempData.province?.region_name}
                            disabled
                            size='sm'
                          /> */}
                          <Select
                            id='provinsi'
                            key={idSektor + produsen}
                            placeholder={t('pilih')}
                            defaultValue={
                              fullProvince[
                                fullProvince.findIndex(
                                  (item: any) => item.label === tempData.province?.region_name
                                )
                              ]
                            }
                            onChange={(e: any) => {
                              setFullCity([])
                              cityData(e?.value)
                            }}
                            options={fullProvince}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.city_id != city ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            type='text'
                            value={tempData.city?.city_name}
                            disabled
                            size='sm'
                          /> */}
                          <Select
                            id='kota'
                            key={province}
                            placeholder={t('pilih')}
                            defaultValue={
                              fullCity[
                                fullCity.findIndex(
                                  (item: any) => item.label === tempData.city?.city_name
                                )
                              ]
                            }
                            onChange={(e: any) => {
                              separateValue2(setCity, e?.value, setCityDesc)
                              // fieldClearer(4)
                            }}
                            options={fullCity}
                          />
                        </Col>
                      </Row>
                      {tempData2.is_so_release == false ? (
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control type='text' value={tempData.plant_desc} disabled size='sm' />
                          </Col>
                        </Row>
                      ) : (
                        ''
                      )}

                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.product_type != ptype ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={tempData.product_type_desc}
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                          <Form.Select
                            size='sm'
                            aria-label='Default select example'
                            id='jenis'
                            onChange={(e: any) => productTypeChange(e.target.value)}
                          >
                            <option hidden value='~#~'>
                              {t('Pilih-productType')}
                            </option>
                            {fullProductType.map((item: any) => {
                              return (
                                <>
                                  {item.id != 12 && (
                                    <>
                                      {item.material_group == tempData?.product_type ? (
                                        <option
                                          selected
                                          value={item.material_group_desc + '~#~' + item.material_group}
                                        >
                                          {t(item.material_group_desc)}
                                        </option>
                                      ) : (
                                        <option
                                          value={item.material_group_desc + '~#~' + item.material_group}
                                        >
                                          {t(item.material_group_desc)}
                                        </option>
                                      )}
                                    </>
                                  )}
                                </>
                              )
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.material_number != pnumber ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control value={tempData.product_name} type='text' disabled size='sm' /> */}
                          <Select
                            id='produk'
                            key={ptype + fullProductName}
                            placeholder={t('pilih')}
                            defaultValue={
                              fullProductName[
                                fullProductName.findIndex(
                                  (item: any) => item.truevalue == parseInt(tempData?.material_number)
                                )
                              ]
                            }
                            onChange={(e: any) => productNameChange(e?.value)}
                            options={fullProductName}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                        </Col>
                        <Col md={8}>
                          <Form.Control
                            value={
                              i18next.language === 'en'
                                ? (
                                    parseFloat(tempData.fixed_quantum) -
                                    parseFloat(tempData.so_qty_realized)
                                  )?.toLocaleString('en', {maximumFractionDigits: 4}) + ' MT'
                                : (
                                    parseFloat(tempData.fixed_quantum) -
                                    parseFloat(tempData.so_qty_realized)
                                  )?.toLocaleString('id', {maximumFractionDigits: 4}) + ' MT'
                            }
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={1}></Col>
                        <Col md={4}>
                          <p className='mt-3 fs-6 opacity-0'>{t('Kuantum Pengajuan')}</p>
                        </Col>
                        <Col md={7}>
                          <Form.Control className='opacity-0' type='text' disabled size='sm' />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.fixed_price != subprice ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/MT</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={
                              i18next.language === 'en'
                                ? '$' + parseInt(tempData?.fixed_price).toLocaleString('en') + '/Ton'
                                : '$' + parseInt(tempData?.fixed_price).toLocaleString('id') + '/Ton'
                            }
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                          <InputGroup size='sm'>
                            <InputGroup.Text>
                              <span className='px-2'>USD</span>
                            </InputGroup.Text>
                            {isFormulatedPrice ? (
                              <CurrencyInput
                                className='form-control form-control-sm'
                                id='hargap'
                                disabled
                                defaultValue={0}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                decimalsLimit={2}
                              />
                            ) : (
                              <CurrencyInput
                                className='form-control form-control-sm'
                                id='hargap'
                                // key={pname}
                                defaultValue={subprice}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                onValueChange={(value: any) => {
                                  setSubprice(value?.replace(/,/g, '.'))
                                }}
                                decimalsLimit={2}
                                placeholder={t('Harga Pengajuan')}
                              />
                            )}
                          </InputGroup>
                        </Col>
                      </Row>
                      
                      <Row className='mb-4'>
                        <Col sm={4} className={tempData2?.shipping_tolerance != shipping ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-4'>{t('Shipping Tolerance')}</p>
                        </Col>
                        <Col sm={8} className='d-flex justify-content-start'>
                          {/* <Form.Control
                            disabled
                            type='text'
                            size='sm'
                            value={tempData?.shipping_tolerance == 0 ? '' : tempData?.shipping_tolerance + '%'}
                          /> */}
                          <InputGroup size='sm'>
                            <Form.Control
                              placeholder={t('Shipping Tolerance')}
                              type='number'
                              id='shipping'
                              defaultValue={shipping}
                              onChange={(e: any) => setShipping(parseFloat(e.target.value))}
                            />
                            <InputGroup.Text id='basic-addon2'>
                              <span className='px-1'>%</span>
                            </InputGroup.Text>
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.payment_type_1 != pay1 ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={t(tempData?.payment_type_1_desc)}
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                          <Form.Select
                            size='sm'
                            aria-label='Default select example'
                            id='payment1'
                            onChange={(e: any) => separateValue(setPay1, e.target.value, setPay1Desc)}
                          >
                            <option hidden value='~#~'>
                              {t('Pilih-payment')}
                            </option>
                            {fullPayment.map((item: any) => {
                              return (
                                <>
                                  {item.payment_desc == tempData?.payment_type_1_desc ? (
                                    <option selected value={item.code + '~#~' + item.payment_desc}>
                                      {item.payment_desc}
                                    </option>
                                  ) : (
                                    <option value={item.code + '~#~' + item.payment_desc}>
                                      {item.payment_desc}
                                    </option>
                                  )}
                                </>
                              )
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.payment_type_2 != pay2 ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={t(tempData?.payment_type_2_desc)}
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                          <Form.Select
                            size='sm'
                            aria-label='Default select example'
                            id='payment2'
                            onChange={(e: any) => separateValue(setPay2, e.target.value, setPay2Desc)}
                          >
                            {/* <option selected hidden disabled>{t(tempData?.payment_type_2)}</option> */}
                            <option value='~#~'>{t('Pilih-payment')}</option>
                            {fullPayment.map((item: any) => {
                              return (
                                <>
                                  {item.payment_desc == tempData?.payment_type_2_desc ? (
                                    <option selected value={item.code + '~#~' + item.payment_desc}>
                                      {item.payment_desc}
                                    </option>
                                  ) : (
                                    <option value={item.code + '~#~' + item.payment_desc}>
                                      {item.payment_desc}
                                    </option>
                                  )}
                                </>
                              )
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={(tempData2?.payment_note || "") != (keterangan || "") ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('keterangan')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={t(tempData?.payment_note)}
                            type='text'
                            disabled
                            size='sm'
                          /> */}
                          <Form.Control
                            as='textarea'
                            defaultValue={tempData?.payment_note}
                            placeholder={t('keterangan')}
                            id='keterangan'
                            size='sm'
                            onChange={(e: any) => setketerangan(e.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={(tempData2?.product_spec || "") != (pspec || "") ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control value={tempData.product_spec} as='textarea' style={{ height: '40px' }} type='text' disabled size='sm' /> */}
                          <Form.Control
                            placeholder={t('sub-order-spek')}
                            as='textarea'
                            defaultValue={tempData?.product_spec}
                            id='spek'
                            size='sm'
                            onChange={(e: any) => setPspec(e.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4' style={{height: '58px'}}>
                        <Col md={4} className={(
                          (isNoEnduser && tempData2.end_user != enduser)
                          || (!isNoEnduser && tempData2.end_user != arrayEnduser.map((item: any) => item.label).join(","))
                        ) ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('End Customer')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control
                            value={tempData.end_user_multiple ? handleShowValue(tempData.end_user) : tempData.end_user}
                            as='textarea'
                            disabled
                            size='sm'
                          /> */}
                          {isNoEnduser ? (
                            <Form.Control
                              size='sm'
                              as='textarea'
                              id='enduser'
                              key={sektorDesc}
                              placeholder={t('End Customer')}
                              defaultValue={enduserDesc}
                              onChange={(e: any) => {
                                setEnduser(e.target.value)
                                setEnduserDesc(e.target.value)
                              }}
                            />
                          ) : (
                            <MultiSelect
                              options={fullEndUser?.map((item: any) => {
                                return {label: item.name, value: item.name}
                              })}
                              value={arrayEnduser}
                              onChange={(e: any) => setEnduserArray(e)}
                              labelledBy='Select'
                            />
                          )}
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col md={4} className={tempData2?.notes != note ? 'text-light-primary fw-bold' : ''}>
                          <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col md={8}>
                          {/* <Form.Control value={tempData?.notes} as='textarea' style={{ height: '40px' }} type='text' disabled size='sm' /> */}
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            defaultValue={tempData?.notes}
                            id='note'
                            size='sm'
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                      { tempData2?.sector_id != 2 && <>
                        <Row className='mb-4'>
                          <Col md={4} className={tempData2?.amandement_notes != alasan ? 'text-light-primary fw-bold' : ''}>
                            <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              as='textarea'
                              placeholder={t('alasan perpanjangan')}
                              defaultValue={alasan}
                              disabled={false}
                              onChange={(e: any) => setAlasan(e.target.value)}
                              id='note'
                              size='sm'
                              style={{height: '40px'}}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4} className={tempData2?.extension_date != tanggalPerpanjangan ? 'text-light-primary fw-bold' : ''}>
                            <p className='fs-6 mt-3'>{t('tanggal perpanjangan')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              defaultValue={tanggalPerpanjangan}
                              style={{height: '40px'}}
                              disabled={false}
                              onChange={(e: any) => setTanggalPerpanjangan(e.target.value)}
                              type='date'
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </> }
                    </Col>
                  </Row>
                )}

                <div className='d-flex justify-content-end mt-5'>
                  {/* <Button
                    variant='danger'
                    onClick={() => amandementReject()}
                    className='me-2'
                    disabled={btnLoadingRej || btnLoadingApp}
                  >
                    {btnLoadingRej ? (
                      <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                      t('order-tolak')
                    )}
                  </Button> */}
                  <Button onClick={() => acceptAmandement()}>{t('save')}</Button>
                </div>
              </>
            }

          </Modal.Body>
        </Modal>

        {/* modal file modal */}
        <Modal
          size='lg'
          show={showUpload1}
          onHide={() => {
            setShowUpload1(false)
            setIsFileBox({})
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isFileBox?.product_name
                ? (isFileBox.province ? isFileBox.province?.region_name : '') +
                  (isFileBox.city ? ', ' + isFileBox.city?.city_name : '') +
                  (isFileBox.province ? ' | ' : '') +
                  isFileBox.product_name +
                  (isFileBox.request_quantum ? ' | ' + isFileBox.request_quantum + ' Ton' : '')
                : t('File Box')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {roleUser == 'salesAdmin' ? (
              <>
                <div className='table-responsive mt-4 bdr'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='fw-bold border-bottom'>
                      <tr className=''>
                        <th className='text-center'>{t('order-noo')}</th>
                        <th className='text-center'>{t('order-keterangan')}</th>
                        <th className='text-center'>{t('order-tglUpload')}</th>
                        {/* <th className='text-center'>{t('User Code')}</th> */}
                        <th className='text-center'>{t('order-user')}</th>
                        <th className='text-center'>{t('Akses Role')}</th>
                        <th className='text-center'>{t('order-aksi')}</th>
                      </tr>
                    </thead>
                    {allFile2.map((data: any, _index: any) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className=''>
                          <td className='text-center'>
                            <label>{_index + 1}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.description}</label>
                          </td>
                          <td className='text-center'>
                            <label>{dateformat(data.updated_at)}</label>
                          </td>
                          {/* <td className='text-center'>
                            <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                          </td> */}
                          <td className='text-center'>
                            {data.user?.customer_code == null ? (
                              <label>{data.user?.name}</label>
                            ) : (
                              <label>{data.user?.customer?.name}</label>
                            )}
                          </td>
                          <td className='text-center'>
                            {data.private ? (
                              data.roles?.length > 0 ? (
                                <PopoverText
                                  content={handleShowRoleName(data.roles)}
                                  index={_index}
                                  className='desc-slice'
                                />
                              ) : (
                                'Private'
                              )
                            ) : (
                              'Public'
                            )}
                          </td>
                          <td className='text-center'>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('unduh')}
                              onClick={() =>
                                window.open(
                                  data.file_path + `&token=${localStorage.getItem('token')}`
                                )
                              }
                            >
                              <KTSVG
                                path='/media/icons/duotune/arrow-down-square-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            {(accsessDelete || CheckSameIDAttachment(data.user_role_flag)) && (
                              <button
                                onClick={() => deleteAttachment(data.id)}
                                className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Hapus')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/trash-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </>
            ) : (
              <>
                <div hidden={ischanged ? false : true}>
                  <Row>
                    <Col sm={6}>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-fileUnggah')}</h6>
                          </td>
                          <td className='w-75'>
                            <InputFile
                                setFileName={setNamaFile}
                                setFiles={setFiles}
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-keterangan')}</h6>
                          </td>
                          <td className='w-75'>
                            <Form.Control
                              type='text'
                              id='uploadketerangan'
                              placeholder={t('order-keterangan')}
                              onChange={(e: any) => setDescription(e.target.value)}
                            />
                          </td>
                        </tr>
                      </table>
                      <table
                        className='mb-3'
                        hidden={roleUser == 'null' || roleUser == null ? true : false}
                      >
                        <tr>
                          <td>
                            <h6 className='me-11'>{t('Private')}</h6>
                          </td>
                          <td className='w-75 d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='isPrivate'
                              type='checkbox'
                              className='mt-5 mb-2'
                              onClick={() => {
                                setIsPrivate(!isPrivate)
                                setTempRole([])
                              }}
                              id='isPrivate'
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3' hidden={isPrivate ? false : true}>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('Akses Role')}</h6>
                          </td>
                          <td className='w-75' style={{maxWidth: '274px'}}>
                            <MultiSelect
                              key={files}
                              options={fullRole?.map((item: any) => {
                                return {label: item.label, value: item.value}
                              })}
                              value={tempRole}
                              onChange={(e: any) => setTempRole(e)}
                              labelledBy='Select'
                            />
                          </td>
                        </tr>
                      </table>
                      <div className='d-flex justify-content-end'>
                        <Button variant='primary' className='w-100' onClick={() => handleUpload()}>
                          {t('order-kirim')}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead className='fw-bold border-bottom'>
                        <tr className=''>
                          <th className='text-center'>{t('order-noo')}</th>
                          <th className='text-center'>{t('order-keterangan')}</th>
                          <th className='text-center'>{t('order-tglUpload')}</th>
                          <th className='text-center'>{t('order-user')}</th>
                          {/* <th className='text-center'>{t('User Code')}</th> */}
                          <th className='text-center'>{t('Akses Role')}</th>
                          <th className='text-center'>{t('order-aksi')}</th>
                        </tr>
                      </thead>
                      {orderItemFiles
                        .slice(0)
                        .reverse()
                        .map((data: any, _index: any) => (
                          <tbody key={data?.id ?? _index}>
                            <tr className=''>
                              <td className='text-center'>
                                <label>{_index + 1}</label>
                              </td>
                              <td className='text-center'>
                                <label>{data.description}</label>
                              </td>
                              <td className='text-center'>
                                <label>{dateformat(getCurrentFormattedDate())}</label>
                              </td>
                              {/* <td className='text-center'>
                                <label>
                                  {localStorage.getItem('cust-code') !== 'null'
                                    ? localStorage.getItem('cust-code')
                                    : localStorage.getItem('user_code')}
                                </label>
                              </td> */}
                              <td className='text-center'>
                                <label>{localStorage.getItem('username')}</label>
                              </td>
                              <td className='text-center'>
                                {data.private ? (
                                  data.roles?.length > 0 ? (
                                    <PopoverText
                                      content={handleShowRoleNameFromState(data.roles)}
                                      index={_index}
                                      className='desc-slice'
                                    />
                                  ) : (
                                    'Private'
                                  )
                                ) : (
                                  'Public'
                                )}
                              </td>
                              <td className='text-center'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('unduh')}
                                  onClick={() => download_file(data.file_r, data.name)}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/arrow-down-square-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                <button
                                  onClick={() =>
                                    handleDeleteUploadHeader(
                                      orderItemFiles.length - 1 - _index,
                                      orderItemFiles,
                                      setOrderItemsFiles,
                                      'order-item'
                                    )
                                  }
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('Hapus')}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/trash-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                    </table>
                  </div>
                </div>

                <div hidden={ischanged ? true : false} className='table-responsive mt-4 bdr'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='fw-bold border-bottom'>
                      <tr className=''>
                        <th className='text-center'>{t('order-noo')}</th>
                        <th className='text-center'>{t('order-keterangan')}</th>
                        <th className='text-center'>{t('order-tglUpload')}</th>
                        {/* <th className='text-center'>{t('User Code')}</th> */}
                        <th className='text-center'>{t('order-user')}</th>
                        <th className='text-center'>{t('Akses Role')}</th>
                        <th className='text-center'>{t('order-aksi')}</th>
                      </tr>
                    </thead>
                    {allFile.map((data: any, _index: number) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className=''>
                          <td className='text-center'>
                            <label>{_index + 1}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.description}</label>
                          </td>
                          <td className='text-center'>
                            <label>{dateformat(data.updated_at)}</label>
                          </td>
                          {/* <td className='text-center'>
                            <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                          </td> */}
                          <td className='text-center'>
                            {data.user?.customer_code == null ? (
                              <label>{data.user?.name}</label>
                            ) : (
                              <label>{data.user?.customer?.name}</label>
                            )}
                          </td>
                          <td className='text-center'>
                            {data.private ? (
                              data.roles?.length > 0 ? (
                                <PopoverText
                                  content={handleShowRoleName(data.roles)}
                                  index={_index}
                                  className='desc-slice'
                                />
                              ) : (
                                'Private'
                              )
                            ) : (
                              'Public'
                            )}
                          </td>
                          <td className='text-center'>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('unduh')}
                              onClick={() =>
                                window.open(
                                  data.file_path + `&token=${localStorage.getItem('token')}`
                                )
                              }
                            >
                              <KTSVG
                                path='/media/icons/duotune/arrow-down-square-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            {(accsessDelete || CheckSameIDAttachment(data.user_role_flag)) && (
                              <button
                                onClick={() => deleteAttachment(data.id)}
                                className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Hapus')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/trash-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        {/* modal jadwal local */}
        <Modal
          show={show3}
          onHide={() => {
            handleClose3()
            setIsChanged(false)
            setTempTanggal(0)
            setTempJadwal([])
            sessionStorage.setItem('isCustomer', 'true')
          }}
          centered
          size='xl'
          backdrop='static'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {sektor != '3' ? provinceDesc + ', ' + cityDesc + ' | ' : ''}
              {pname} | {fixedQuantum2} Ton
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12}>
                <div hidden={ischanged ? true : false} style={{marginTop: '-2rem'}}>
                  <span style={{fontSize: '15px'}} className='fw-bold d-block mt-3'>
                    {t('Jadwal')}
                  </span>
                  <AddRemoveJadwal id={subID} is_amendment={'false'} />
                </div>
              </Col>
              <Col hidden={ischanged ? false : true} md={12}>
                <span style={{fontSize: '15px'}} className='fw-bold d-block mt-3'>
                  {t('Jadwal')}
                </span>
                <div className='table-responsive bdr mt-1'>
                  <table className='table-border w-100'>
                    <thead>
                      <tr className='d-flex'>
                        {/* <th style={{ width: '60px' }} className="text-center">{t('order-aksi')}</th> */}
                        <th style={{width: '165.5px'}} className='text-center'>
                          {t('order-pengambilan')}
                        </th>
                        <th style={{width: '185.5px'}} className='text-center'>
                          {t('order-tanggal')}
                        </th>
                        <th style={{width: '185.5px'}} className='text-center'>
                          {t('order-minggu')}
                        </th>
                        <th style={{width: '185.5px'}} className='text-center'>
                          {t('order-bulan')}
                        </th>
                        <th style={{width: '185.5px'}} className='text-center'>
                          {t('order-tahun')}
                        </th>
                        <th style={{width: '185.5px'}} className='text-center'>
                          {t('order-tonase')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <div>
                        <tr className='d-flex'>
                          <td
                            style={{width: '165.5px'}}
                            className='d-flex align-items-center justify-content-center'
                          >
                            <p className=''>{tempJadwal.length + 1}</p>
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            <Form.Select
                              aria-label='Default select example'
                              id='jadwaltanggal1'
                              style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                              onChange={(e: any) => setTempTanggal(parseInt(e.target.value))}
                            >
                              <option selected value={0} disabled hidden>
                                {t('Pilih-Tanggal')}
                              </option>
                              {daysInMonth != 0 ? loopTanggal(daysInMonth) : ''}
                            </Form.Select>
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            <Form.Control
                              aria-label='Default select example'
                              id='jadwalminggu'
                              placeholder={t('order-minggu')}
                              style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                              value={tempTanggal == 0 ? '' : t('Week') + Math.ceil(tempTanggal / 7)}
                            />
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            <Form.Select
                              aria-label='Default select example'
                              style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                              id='jadwalbulan'
                              onChange={(e: any) => setTempBulan(parseInt(e.target.value))}
                            >
                              <option selected disabled>
                                {t('Pilih-Month')}
                              </option>
                              <option value='1'>{t('Januari')}</option>
                              <option value='2'>{t('Februari')}</option>
                              <option value='3'>{t('Maret')}</option>
                              <option value='4'>{t('April')}</option>
                              <option value='5'>{t('Mei')}</option>
                              <option value='6'>{t('Juni')}</option>
                              <option value='7'>{t('Juli')}</option>
                              <option value='8'>{t('Agustus')}</option>
                              <option value='9'>{t('September')}</option>
                              <option value='10'>{t('Oktober')}</option>
                              <option value='11'>{t('November')}</option>
                              <option value='12'>{t('Desember')}</option>
                            </Form.Select>
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            <Form.Select
                              aria-label='Default select example'
                              style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                              id='jadwaltahun'
                              onChange={(e: any) => setTempTahun(parseInt(e.target.value))}
                            >
                              <option selected disabled>
                                {t('Pilih-Year')}
                              </option>
                              {listYear.map((data: string, index: number) => {
                                return (
                                  <option key={data ?? index} value={data}>
                                    {data}
                                  </option>
                                )
                              })}
                            </Form.Select>
                          </td>
                          <td
                            style={{width: '185.5px'}}
                            className='text-center d-flex justify-content-center'
                          >
                            <CurrencyInput
                              id='jadwalton'
                              className='form-control form-control-sm'
                              placeholder={t('order-tonase')}
                              key={tempTahun}
                              style={{width: '90%'}}
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                // console.log(parseFloat(value?.replace(/,/g, '.')))
                                setTempTon(parseFloat(value?.replace(/,/g, '.')))
                              }}
                              decimalsLimit={3}
                            />
                          </td>
                        </tr>
                      </div>
                    </tbody>
                  </table>
                </div>

                <div className='mt-5 mb-5'>
                  <div className='d-flex justify-content-end mt-3'>
                    <Button
                      variant='primary'
                      onClick={() => {
                        sendJadwal()
                      }}
                    >
                      {t('order-kirim')}
                    </Button>
                  </div>
                </div>
                <div className='table-responsive bdr mt-3' hidden={!ischanged ? true : false}>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='border-bottom'>
                      <tr className='fw-bold d-flex'>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-pengambilan')}
                        </th>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-tanggal')}
                        </th>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-minggu')}
                        </th>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-bulan')}
                        </th>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-tahun')}
                        </th>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-tonase')}
                        </th>
                        <th className='text-center' style={{width: '156.2px'}}>
                          {t('order-aksi')}
                        </th>
                      </tr>
                    </thead>
                    {tempJadwal?.map((data: any, index: number) => (
                      <tbody key={data?.id ?? index}>
                        <tr className='d-flex'>
                          <td className='text-center' style={{width: '156.2px'}}>
                            <label className='mt-3'>{index + 1}</label>
                          </td>
                          <td className='text-center' style={{width: '156.2px'}}>
                            <label className='mt-3'>{data.date}</label>
                          </td>
                          <td className='text-center' style={{width: '156.2px'}}>
                            <label className='mt-3'>
                              {t('Week')}
                              {Math.ceil(data.date / 7)}
                            </label>
                          </td>
                          <td className='text-center' style={{width: '156.2px'}}>
                            <label className='mt-3'>{t(bulan[data.month - 1])}</label>
                          </td>
                          <td className='text-center' style={{width: '156.2px'}}>
                            <label className='mt-3'>{data.year}</label>
                          </td>
                          <td className='text-center' style={{width: '156.2px'}}>
                            {editedIndex == index ? (
                              <CurrencyInput
                                id='ton'
                                placeholder={t('order-tonase')}
                                className='form-control form-control-sm'
                                defaultValue={data.tonnage}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                onValueChange={(value: any) => {
                                  setTempTon(parseFloat(value?.replace(/,/g, '.')))
                                }}
                                decimalsLimit={3}
                              />
                            ) : (
                              <label className='mt-3'>
                                {(i18next.language === 'en'
                                  ? data.tonnage.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : data.tonnage.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })) +
                                  ' ' +
                                  'Ton'}
                              </label>
                            )}
                          </td>
                          <td style={{width: '156.2px'}} className='text-center'>
                            {editedIndex == index ? (
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Approve')}
                                onClick={() => rubahSchedule(index, tempTon, data.tonnage)}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/check-square.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            ) : (
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('ubah')}
                                onClick={() => {
                                  setEditedIndex(index)
                                  setTempTon(data.tonnage)
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/pencil-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            )}

                            <button
                              onClick={() => hapusSchedule(index)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Hapus')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/trash-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        {/* modal add product */}
        <Modal
          show={showAddProduct}
          onHide={() => setShowAddProduct(false)}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t('add')} {t('Order')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {sektorID == 3 && (
              <>
                <Row>
                  <Col md={6}>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('kontrak-produsen')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control value={produsenDesc} type='text' disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-incoterm1')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='incoterm1'
                          key={idSektor}
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                          }}
                          options={fullIncoterm}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-provinsi')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='provinsi'
                          key={idSektor + produsen}
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            setFullCity([])
                            cityData(e?.value)
                          }}
                          options={fullProvince}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-jenis')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Select
                          size='sm'
                          aria-label='Default select example'
                          id='jenis'
                          onChange={(e: any) => productTypeChange(e.target.value)}
                        >
                          <option hidden value='~#~'>
                            {t('Pilih-productType')}
                          </option>
                          {fullProductType.map((item: any) => {
                            return (
                              <>
                                {item.id != 12 && (
                                  <option
                                    value={item.material_group_desc + '~#~' + item.material_group}
                                  >
                                    {t(item.material_group_desc)}
                                  </option>
                                )}
                              </>
                            )
                          })}
                        </Form.Select>
                      </Col>
                    </Row>
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>
                            Custom Product Name<span className='text-danger'>*</span>
                          </p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            placeholder=' Custom Product Name'
                            size='sm'
                            aria-label='Default select example'
                            type='text'
                            id='custom'
                            onChange={(e: any) => setPname(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('Kuantum Pengajuan')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            id='kuantum'
                            // key={pname}
                            placeholder={t('Kuantum Pengajuan')}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setQuantum(value?.replace(/,/g, '.'))
                              // console.log(value)
                            }}
                            decimalsLimit={3}
                          />
                          <InputGroup.Text id='basic-addon2'>MT</InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('Shipping Tolerance')}</p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <Form.Control
                            placeholder={t('Shipping Tolerance')}
                            type='number'
                            id='shipping'
                            onChange={(e: any) => setShipping(parseFloat(e.target.value))}
                          />
                          <InputGroup.Text id='basic-addon2'>
                            <span className='px-1'>%</span>
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-payment1')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Select
                          size='sm'
                          aria-label='Default select example'
                          id='payment1'
                          onChange={(e: any) => separateValue(setPay1, e.target.value, setPay1Desc)}
                        >
                          <option hidden value='~#~'>
                            {t('Pilih-payment')}
                          </option>
                          {fullPayment.map((item: any, index: number) => {
                            return (
                              <option
                                key={item?.code ?? index}
                                value={item.code + '~#~' + item.payment_desc}
                              >
                                {item.payment_desc}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('keterangan')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          as='textarea'
                          placeholder={t('keterangan')}
                          id='keterangan'
                          size='sm'
                          style={{height: '40px'}}
                          onChange={(e: any) => setketerangan(e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('End Customer')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          as='textarea'
                          id='enduser'
                          key={sektorDesc}
                          defaultValue={enduserDesc}
                          placeholder={t('End Customer')}
                          onChange={(e: any) => {
                            setEnduser(e.target.value)
                            setEnduserDesc(e.target.value)
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-sektor')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control type='text' size='sm' disabled value={t('Export')} />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='incoterm2'
                          key={idSektor}
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                          }}
                          options={fullIncoterm2}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-kota')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='kota'
                          key={province}
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            separateValue2(setCity, e?.value, setCityDesc)
                            // fieldClearer(4)
                          }}
                          options={fullCity}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-produk')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='produk'
                          key={ptype}
                          placeholder={t('pilih')}
                          onChange={(e: any) => productNameChange(e?.value)}
                          options={fullProductName}
                        />
                      </Col>
                    </Row>
                    {pnumber == '0' && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            id='note'
                            size='sm'
                            style={{height: '40px'}}
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('Harga Pengajuan')}/MT<span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <InputGroup.Text>
                            <span className='px-2'>USD</span>
                          </InputGroup.Text>
                          {isFormulatedPrice ? (
                            <CurrencyInput
                              className='form-control form-control-sm'
                              id='hargap'
                              disabled
                              defaultValue={0}
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              decimalsLimit={2}
                            />
                          ) : (
                            <CurrencyInput
                              className='form-control form-control-sm'
                              id='hargap'
                              // key={pname}
                              defaultValue={subprice}
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                setSubprice(value?.replace(/,/g, '.'))
                              }}
                              decimalsLimit={2}
                              placeholder={t('Harga Pengajuan')}
                            />
                          )}
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='my-7'>
                      <Col sm={4} className='d-flex align-items-center'>
                        <p className=' fs-6'>{t('Formulated Price')}</p>
                      </Col>
                      <Col sm={8} className='d-flex justify-content-start align-items-center'>
                        <Form.Check
                          reverse
                          onClick={() => setIsFormulatedPrice(!isFormulatedPrice)}
                          name='formula_Price'
                          type='checkbox'
                          id='formula_Price'
                        />
                      </Col>
                    </Row>

                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          placeholder={t('sub-order-spek')}
                          as='textarea'
                          id='spek'
                          size='sm'
                          style={{height: '40px'}}
                          onChange={(e: any) => setPspec(e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Select
                          size='sm'
                          aria-label='Default select example'
                          id='payment2'
                          onChange={(e: any) => separateValue(setPay2, e.target.value, setPay2Desc)}
                        >
                          {/* <option selected hidden disabled>{t(tempData?.payment_type_2)}</option> */}
                          <option value='~#~'>{t('Pilih-payment')}</option>
                          {fullPayment.map((item: any, index: number) => {
                            return (
                              <option
                                key={item?.code ?? index}
                                value={item.code + '~#~' + item.payment_desc}
                              >
                                {item.payment_desc}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </Col>
                    </Row>
                    {parseInt(pnumber) != 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            id='note'
                            size='sm'
                            style={{height: '40px'}}
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </>
            )}

            {sektorID == 1 && (
              <>
                <Row>
                  <Col md={6}>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('kontrak-produsen')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control value={produsenDesc} type='text' disabled size='sm' />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-incoterm1')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='incoterm1'
                          key={idSektor + produsen}
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                          }}
                          options={fullIncoterm}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-provinsi')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='provinsi'
                          key={idSektor + produsen}
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            setFullCity([])
                            cityData(e?.value)
                          }}
                          options={fullProvince}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-jenis')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Select
                          size='sm'
                          aria-label='Default select example'
                          id='jenis'
                          onChange={(e: any) => productTypeChange(e.target.value)}
                        >
                          <option hidden value='~#~'>
                            {t('Pilih-productType')}
                          </option>
                          {fullProductType.map((item: any) => {
                            return (
                              <>
                                {item.id != 12 && (
                                  <option
                                    value={item.material_group_desc + '~#~' + item.material_group}
                                  >
                                    {t(item.material_group_desc)}
                                  </option>
                                )}
                              </>
                            )
                          })}
                        </Form.Select>
                      </Col>
                    </Row>
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>
                            Custom Product Name<span className='text-danger'>*</span>
                          </p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            placeholder=' Custom Product Name'
                            size='sm'
                            aria-label='Default select example'
                            type='text'
                            id='custom'
                            onChange={(e: any) => setPname(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('Kuantum Pengajuan')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            id='kuantum'
                            // key={pname}
                            placeholder={t('Kuantum Pengajuan')}
                            defaultValue={quantum}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setQuantum(value?.replace(/,/g, '.'))
                              // console.log(value)
                            }}
                            decimalsLimit={3}
                          />
                          <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('Shipping Tolerance')}</p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <Form.Control
                            placeholder={t('Shipping Tolerance')}
                            type='number'
                            id='shipping'
                            onChange={(e: any) => setShipping(parseFloat(e.target.value))}
                          />
                          <InputGroup.Text id='basic-addon2'>
                            <span className='px-2'>%</span>
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-payment1')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Select
                          size='sm'
                          aria-label='Default select example'
                          id='payment1'
                          onChange={(e: any) => separateValue(setPay1, e.target.value, setPay1Desc)}
                        >
                          <option hidden value='~#~'>
                            {t('Pilih-payment')}
                          </option>
                          {fullPayment.map((item: any, index: number) => {
                            return (
                              <option
                                key={item?.code ?? index}
                                value={item.code + '~#~' + item.payment_desc_id}
                              >
                                {item.payment_desc_id}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('keterangan')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          as='textarea'
                          placeholder={t('keterangan')}
                          id='keterangan'
                          size='sm'
                          style={{height: '40px'}}
                          onChange={(e: any) => setketerangan(e.target.value)}
                        />
                      </Col>
                    </Row>
                    {parseInt(pnumber) != 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='mt-3 fs-6'>
                            {t('segment')}
                            <span className='text-danger'>*</span>
                          </p>
                        </Col>
                        <Col sm={8}>
                          <Form.Select
                            size='sm'
                            id='segment'
                            onChange={(e: any) =>
                              separateValue(setSegment, e.target.value, setSegmentDesc)
                            }
                            aria-label='Default select example'
                          >
                            <option selected hidden disabled value='~#~'>
                              {t('pilih')} {t('segment')}
                            </option>
                            {fullSegment.map((item: any) => {
                              if (item.code == 'Z2' || item.code == 'Z3') {
                                return (
                                  <option value={item.code + '~#~' + item.name}>{item.name}</option>
                                )
                              } else {
                                return null
                              }
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('End Customer')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        {isNoEnduser ? (
                          <Form.Control
                            size='sm'
                            as='textarea'
                            id='enduser'
                            defaultValue={enduserDesc}
                            placeholder={t('End Customer')}
                            onChange={(e: any) => {
                              setEnduser(e.target.value)
                              setEnduserDesc(e.target.value)
                            }}
                          />
                        ) : (
                          <MultiSelect
                            options={fullEndUser?.map((item: any) => {
                              return {label: item.name, value: item.name}
                            })}
                            value={arrayEnduser}
                            onChange={(e: any) => setEnduserArray(e)}
                            labelledBy='Select'
                          />
                        )}
                      </Col>
                    </Row>
                    {idSektor == 1 && parseInt(pnumber) != 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}></Col>
                        <Col sm={8} className='d-flex'>
                          <Form.Check
                            onClick={() => setIsNoEnduser(!isNoEnduser)}
                            defaultChecked={isNoEnduser}
                            // disabled={ptype == 'P13'}
                            name='ppn'
                            className='mb-2'
                            type='checkbox'
                            id='noenduser'
                          />
                          {i18next.language == 'en' ? (
                            <p className='ms-2 fs-6'>{t('TidakAdaEndUser')}</p>
                          ) : (
                            <p className='ms-2 fs-6'>{t('TidakAdaEndUser')}</p>
                          )}
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <Col md={6}>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-sektor')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          id='sektor'
                          disabled
                          value={t('Domestik Korperasi')}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='incoterm2'
                          key={idSektor + produsen}
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                          }}
                          options={fullIncoterm2}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-kota')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='kota'
                          key={province}
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            separateValue2(setCity, e?.value, setCityDesc)
                            // fieldClearer(4)
                          }}
                          options={fullCity}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='mt-3'>
                          {t('sub-order-produk')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='produk'
                          key={ptype}
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            productNameChange(e?.value)
                          }}
                          options={fullProductName}
                        />
                      </Col>
                    </Row>
                    {pnumber == '0' && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            id='note'
                            size='sm'
                            style={{height: '40px'}}
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('Harga Pengajuan')}/Ton<span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <InputGroup.Text>
                            <span className='px-1'>Rp</span>
                          </InputGroup.Text>
                          {isFormulatedPrice ? (
                            <CurrencyInput
                              className='form-control form-control-sm'
                              id='hargap'
                              disabled
                              defaultValue={0}
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              decimalsLimit={-1}
                            />
                          ) : (
                            <CurrencyInput
                              className='form-control form-control-sm'
                              id='hargap'
                              // key={pname}
                              defaultValue={subprice}
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                setSubprice(value?.replace(/,/g, '.'))
                              }}
                              decimalsLimit={-1}
                              placeholder={t('Harga Pengajuan')}
                            />
                          )}
                        </InputGroup>
                      </Col>
                    </Row>
                    {/* <Row className='mb-4'>
                      <Col sm={6} className="d-flex">
                        <Row sm={8}>
                          <p className='mt-5 fs-6'>{t('termasuk-ppn')}</p>
                        </Row>
                        <Row sm={4} className='d-flex justify-content-start'>
                          <Form.Check
                            reverse
                            name='ppn'
                            className='mt-5 mb-2'
                            type='checkbox'
                            id='ckbox-ppn'
                          />
                        </Row>
                      </Col>

                      <Col sm={6} className="d-flex">
                        <Row sm={8} className="d-flex align-items-center">
                          <p className=' fs-6'>{t('Formulated Price')}</p>
                        </Row>
                        <Row sm={4} className='d-flex justify-content-start align-items-center ms-4'>
                          <Form.Check
                            reverse
                            name='formula_Price'
                            type='checkbox'
                            id='formula_Price'
                          />
                        </Row>
                      </Col>
                    </Row> */}

                    <Row className='my-7'>
                      <Col sm={6} className='d-flex '>
                        <Row sm={8} className='d-flex align-items-center'>
                          <p className='fs-6'>{t('termasuk-ppn')}</p>
                        </Row>
                        <Row
                          sm={4}
                          className='d-flex justify-content-start align-items-center ms-4'
                        >
                          <Form.Check reverse name='ppn' type='checkbox' id='ckbox-ppn' />
                        </Row>
                      </Col>
                      <Col sm={6} className='d-flex'>
                        <Row sm={8} className='d-flex align-items-center'>
                          <p className=' fs-6'>{t('Formulated Price')}</p>
                        </Row>
                        <Row
                          sm={4}
                          className='d-flex justify-content-start align-items-center ms-4'
                        >
                          <Form.Check
                            reverse
                            onClick={() => setIsFormulatedPrice(!isFormulatedPrice)}
                            name='formula_Price'
                            type='checkbox'
                            id='formula_Price'
                          />
                        </Row>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Select
                          size='sm'
                          aria-label='Default select example'
                          id='payment2'
                          onChange={(e: any) => separateValue(setPay2, e.target.value, setPay2Desc)}
                        >
                          <option value='~#~'>{t('Pilih-payment')}</option>
                          {fullPayment.map((item: any, index: number) => {
                            return (
                              <option
                                key={item?.code ?? index}
                                value={item.code + '~#~' + item.payment_desc_id}
                              >
                                {item.payment_desc_id}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          placeholder={t('sub-order-spek')}
                          as='textarea'
                          id='spek'
                          size='sm'
                          style={{height: '40px'}}
                          onChange={(e: any) => setPspec(e.target.value)}
                        />
                      </Col>
                    </Row>
                    {parseInt(pnumber) != 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            id='note'
                            size='sm'
                            style={{height: '40px'}}
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    {idSektor == 1 && pnumber == '0' && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          {i18next.language == 'en' ? (
                            <p className='fs-6 mt-4'>{t('TidakAdaEndUser')}</p>
                          ) : (
                            <p className='fs-6'>{t('TidakAdaEndUser')}</p>
                          )}
                        </Col>
                        <Col sm={8}>
                          <Form.Check
                            onClick={() => setIsNoEnduser(!isNoEnduser)}
                            defaultChecked={isNoEnduser}
                            // disabled={ptype == 'P13'}
                            name='ppn'
                            id='noenduser'
                            className='mt-5 mb-2'
                            type='checkbox'
                          />
                        </Col>
                      </Row>
                    )}
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='mt-3 fs-6'>
                            {t('segment')}
                            <span className='text-danger'>*</span>
                          </p>
                        </Col>
                        <Col sm={8}>
                          <Form.Select
                            size='sm'
                            id='segment'
                            onChange={(e: any) =>
                              separateValue(setSegment, e.target.value, setSegmentDesc)
                            }
                            aria-label='Default select example'
                          >
                            <option selected hidden disabled value='~#~'>
                              {t('pilih')} {t('segment')}
                            </option>
                            {fullSegment.map((item: any) => {
                              if (item.code == 'Z2' || item.code == 'Z3') {
                                return (
                                  <option value={item.code + '~#~' + item.name}>{item.name}</option>
                                )
                              } else {
                                return null
                              }
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </>
            )}

            <div className='d-flex justify-content-end mt-5'>
              <Button variant='primary' onClick={() => addNewProduct()} disabled={btnLoading}>
                {btnLoading ? (
                  <Spinner animation='border' variant='light' size='sm' />
                ) : (
                  <>
                    <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                    {t('order-kirim')}
                  </>
                )}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        {/* modal detail new product */}
        <Modal
          show={showDetailNewProduct}
          onHide={() => setShowDetailNewProduct(false)}
          centered
          scrollable
          size='xl'
          backdrop='static'
        >
          <Modal.Header closeButton>
            <Modal.Title>Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {tempDetail?.sector_id == 1 && (
              <Row>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>Sales Org</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.sales_org_code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.incoterm1_id}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control type='text' value={tempDetail.province_id} disabled size='sm' />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_type_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? tempData.request_quantum.toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' Ton'
                            : tempData.request_quantum.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' Ton'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control
                        // placeholder={t("Shipping Tolerance")}
                        size='sm'
                        type='text'
                        id='shipping'
                        value={
                          tempDetail?.shipping_tolerance == 0
                            ? ''
                            : tempDetail?.shipping_tolerance + '%'
                        }
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_1_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('keterangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_note}
                        as='textarea'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('segment')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={t(tempDetail?.segment_name)}
                        type='text'
                        size='sm'
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('End Customer')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          tempDetail.end_user_multiple
                            ? handleShowValue(tempDetail.end_user)
                            : tempDetail.end_user
                          // tempDetail.end_user_detail?.name
                          //   ? tempDetail.end_user_detail?.name
                          //   : tempDetail.end_user
                        }
                        as='textarea'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={t('Domestik Korperasi')}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.incoterm2_id}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control type='text' value={tempDetail.city_id} disabled size='sm' />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-2'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/Ton</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          'Rp' + i18next.language === 'en'
                            ? parseInt(tempDetail?.request_price).toLocaleString('en')
                            : parseInt(tempDetail?.request_price).toLocaleString('id')
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='my-7'>
                    <Col sm={6} className='d-flex '>
                      <Row sm={8} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('termasuk-ppn')}</p>
                      </Row>
                      <Row sm={4} className='d-flex justify-content-start align-items-center ms-4'>
                        <Form.Check
                          reverse
                          name='ppn'
                          type='checkbox'
                          id='ckbox-ppn'
                          checked={tempDetail?.include_ppn}
                        />
                      </Row>
                    </Col>
                    <Col sm={6} className='d-flex'>
                      <Row sm={8} className='d-flex align-items-center'>
                        <p className=' fs-6'>{t('Formulated Price')}</p>
                      </Row>
                      <Row sm={4} className='d-flex justify-content-start align-items-center ms-4'>
                        <Form.Check
                          reverse
                          name='formula_Price'
                          type='checkbox'
                          id='formula_Price'
                          onClick={() => setIsFormulatedPrice(!isFormulatedPrice)}
                          checked={tempDetail?.is_formulated_price}
                        />
                      </Row>
                    </Col>
                  </Row>
                  {/* <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='mt-4 fs-6'>{t('termasuk-ppn')}</p>
                    </Col>
                    <Col sm={8} className='d-flex justify-content-start'>
                      <Form.Check
                        reverse
                        name='ppn'
                        className='mt-5 mb-2'
                        type='checkbox'
                        id='ckbox-ppn'
                        checked={tempDetail?.include_ppn}
                      />
                    </Col>
                  </Row> */}
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_2_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_spec}
                        as='textarea'
                        style={{height: '40px'}}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.notes}
                        as='textarea'
                        style={{height: '40px'}}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}

            {tempDetail?.sector_id == 3 && (
              <Row>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>Sales Org</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.sales_org_code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.incoterm1_id}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control type='text' value={tempDetail.province_id} disabled size='sm' />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_type_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          i18next.language === 'en'
                            ? tempData.request_price.toLocaleString('en', {
                                maximumFractionDigits: 4,
                              }) + ' MT'
                            : tempData.request_price.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }) + ' MT'
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control
                        // placeholder={t("Shipping Tolerance")}
                        size='sm'
                        type='text'
                        id='shipping'
                        value={
                          tempDetail?.shipping_tolerance == 0
                            ? ''
                            : tempDetail?.shipping_tolerance + '%'
                        }
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_1_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('keterangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_note}
                        as='textarea'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('End Customer')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={
                          tempDetail.end_user_multiple
                            ? handleShowValue(tempDetail.end_user)
                            : tempDetail.end_user
                        }
                        as='textarea'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md='6'>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control value={t('Export')} type='text' disabled size='sm' />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.incoterm2_id}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control type='text' value={tempDetail.city_id} disabled size='sm' />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_name}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/MT</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={'USD' + PriceFormater(tempDetail?.request_price)}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>

                  <Row className='mb-2'>
                    <Col sm={4} className='d-flex align-items-center'>
                      <p className=' fs-6'>{t('Formulated Price')}</p>
                    </Col>
                    <Col sm={8} className='d-flex justify-content-start align-items-center'>
                      <Form.Check
                        reverse
                        name='formula_Price'
                        className='mt-5 mb-2'
                        type='checkbox'
                        onClick={() => setIsFormulatedPrice(!isFormulatedPrice)}
                        defaultChecked={tempDetail.is_formulated_price}
                        id='formula_Price'
                      />
                    </Col>
                  </Row>

                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail.product_spec}
                        type='text'
                        as='textarea'
                        style={{height: '40px'}}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.payment_type_2_desc}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        value={tempDetail?.notes}
                        as='textarea'
                        style={{height: '40px'}}
                        type='text'
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </Modal.Body>
        </Modal>

        {/* modal edit product */}
        <Modal
          show={showEditNewProduct}
          onHide={() => setShowEditNewProduct(false)}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t('ubah')} {t('Order')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loading ? (
              <div className='d-flex justify-content-center'>
                <Spinner animation='border' variant='primary' />
              </div>
            ) : (
              <>
                {idSektor == 3 && (
                  <>
                    <Row>
                      <Col md={6}>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('kontrak-produsen')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              id='produsen'
                              size='sm'
                              disabled
                              value={tempData?.sales_org_code}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-incoterm1')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='incoterm1'
                              key={idSektor}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullIncoterm[
                                  fullIncoterm.findIndex(
                                    (item: any) => item.label === tempData?.incoterm1_id
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                              }}
                              options={fullIncoterm}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-provinsi')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='provinsi'
                              key={idSektor + produsen}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullProvince[
                                  fullProvince.findIndex((item: any) => item.label === provinceDesc)
                                ]
                              }
                              onChange={(e: any) => {
                                setFullCity([])
                                cityData(e?.value)
                              }}
                              options={fullProvince}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-jenis')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='jenis'
                              onChange={(e: any) => productTypeChange(e.target.value)}
                            >
                              <option hidden value='~#~'>
                                {t('Pilih-productType')}
                              </option>
                              {fullProductType.map((item: any) => {
                                return (
                                  <>
                                    {item.id != 12 && (
                                      <>
                                        {item.material_group == tempData?.product_type ? (
                                          <option
                                            selected
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        ) : (
                                          <option
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        )}
                                      </>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        {parseInt(pnumber) == 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>
                                Custom Product Name<span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                placeholder=' Custom Product Name'
                                size='sm'
                                defaultValue={pname}
                                aria-label='Default select example'
                                type='text'
                                id='custom'
                                onChange={(e: any) => setPname(e.target.value)}
                              />
                            </Col>
                          </Row>
                        )}
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('Kuantum Pengajuan')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <CurrencyInput
                                className='form-control form-control-sm'
                                id='kuantum'
                                // key={pname}
                                placeholder={t('Kuantum Pengajuan')}
                                defaultValue={quantum}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                onValueChange={(value: any) => {
                                  setQuantum(value?.replace(/,/g, '.'))
                                }}
                                decimalsLimit={3}
                              />
                              <InputGroup.Text id='basic-addon2'>MT</InputGroup.Text>
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col sm={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('Shipping Tolerance')}</p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <Form.Control
                                placeholder={t('Shipping Tolerance')}
                                type='number'
                                id='shipping'
                                defaultValue={shipping}
                                onChange={(e: any) => setShipping(parseFloat(e.target.value))}
                              />
                              <InputGroup.Text id='basic-addon2'>
                                <span className='px-1'>%</span>
                              </InputGroup.Text>
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-payment1')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='payment1'
                              onChange={(e: any) => separateValue(setPay1, e.target.value, setPay1Desc)}
                            >
                              <option hidden value='~#~'>
                                {t('Pilih-payment')}
                              </option>
                              {fullPayment.map((item: any) => {
                                return (
                                  <>
                                    {item.payment_desc == tempData?.payment_type_1_desc ? (
                                      <option selected value={item.code + '~#~' + item.payment_desc}>
                                        {item.payment_desc}
                                      </option>
                                    ) : (
                                      <option value={item.code + '~#~' + item.payment_desc}>
                                        {item.payment_desc}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('keterangan')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              as='textarea'
                              defaultValue={tempData?.payment_note}
                              placeholder={t('keterangan')}
                              id='keterangan'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => setketerangan(e.target.value)}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('End Customer')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              size='sm'
                              as='textarea'
                              id='enduser'
                              placeholder={t('End Customer')}
                              defaultValue={tempData.end_user_multiple ? '' : tempData.end_user}
                              onChange={(e: any) => {
                                setEnduser(e.target.value)
                                setEnduserDesc(e.target.value)
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md={6}>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-sektor')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control type='text' size='sm' disabled value={t('Export')} />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='incoterm2'
                              key={idSektor}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullIncoterm2[
                                  fullIncoterm2.findIndex(
                                    (item: any) => item.label == tempData?.incoterm2_id
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                              }}
                              options={fullIncoterm2}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-kota')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='kota'
                              key={province}
                              isDisabled
                              placeholder={t('pilih')}
                              defaultValue={
                                fullCity[fullCity.findIndex((item: any) => item.label === cityDesc)]
                              }
                              onChange={(e: any) => {
                                separateValue2(setCity, e?.value, setCityDesc)
                                // fieldClearer(4)
                              }}
                              options={fullCity}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-produk')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='produk'
                              key={ptype}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullProductName[
                                  fullProductName.findIndex(
                                    (item: any) =>
                                      item.truevalue == parseInt(tempData?.material_number)
                                  )
                                ]
                              }
                              onChange={(e: any) => productNameChange(e?.value)}
                              options={fullProductName}
                            />
                          </Col>
                        </Row>
                        {pnumber == '0' && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('sub-order-catatan')}
                                defaultValue={tempData?.notes}
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                                onChange={(e: any) => setNote(e.target.value)}
                              />
                            </Col>
                          </Row>
                        )}
                        <Row className='mb-2'>
                          <Col sm={4}>
                            <p className='mt-3 fs-6'>
                              {t('Harga Pengajuan')}/MT<span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <InputGroup.Text>
                                <span className='px-2'>USD</span>
                              </InputGroup.Text>
                              {isFormulatedPrice ? (
                                <CurrencyInput
                                  className='form-control form-control-sm'
                                  id='hargap'
                                  disabled
                                  defaultValue={0}
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  decimalsLimit={2}
                                />
                              ) : (
                                <CurrencyInput
                                  className='form-control form-control-sm'
                                  id='hargap'
                                  // key={pname}
                                  defaultValue={subprice}
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  onValueChange={(value: any) => {
                                    setSubprice(value?.replace(/,/g, '.'))
                                  }}
                                  decimalsLimit={2}
                                  placeholder={t('Harga Pengajuan')}
                                />
                              )}
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col sm={4} className='d-flex align-items-center'>
                            <p className=' fs-6'>{t('Formulated Price')}</p>
                          </Col>
                          <Col sm={8} className='d-flex justify-content-start align-items-center'>
                            <Form.Check
                              reverse
                              name='formula_Price'
                              className='mt-5 mb-2'
                              type='checkbox'
                              onClick={() => setIsFormulatedPrice(!isFormulatedPrice)}
                              defaultChecked={tempData.is_formulated_price}
                              id='formula_Price'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              placeholder={t('sub-order-spek')}
                              as='textarea'
                              defaultValue={tempData?.product_spec}
                              id='spek'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => setPspec(e.target.value)}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='payment2'
                              onChange={(e: any) => separateValue(setPay2, e.target.value, setPay2Desc)}
                            >
                              {/* <option selected hidden disabled>{t(tempData?.payment_type_2)}</option> */}
                              <option value='~#~'>{t('Pilih-payment')}</option>
                              {fullPayment.map((item: any) => {
                                return (
                                  <>
                                    {item.payment_desc == tempData?.payment_type_2_desc ? (
                                      <option selected value={item.code + '~#~' + item.payment_desc}>
                                        {item.payment_desc}
                                      </option>
                                    ) : (
                                      <option value={item.code + '~#~' + item.payment_desc}>
                                        {item.payment_desc}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        {parseInt(pnumber) != 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('sub-order-catatan')}
                                defaultValue={tempData?.notes}
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                                onChange={(e: any) => setNote(e.target.value)}
                              />
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </>
                )}

                {idSektor == 1 && (
                  <>
                    <Row>
                      <Col md={6}>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('kontrak-produsen')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              id='produsen'
                              size='sm'
                              disabled
                              value={tempData?.sales_org_code}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-incoterm1')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='incoterm1'
                              key={idSektor + produsen}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullIncoterm[
                                  fullIncoterm.findIndex(
                                    (item: any) => item.label === incoterm1Desc
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                separateValue2(setIncoterm1, e?.value, setIncoterm1Desc)
                              }}
                              options={fullIncoterm}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-provinsi')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='provinsi'
                              key={idSektor + produsen}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullProvince[
                                  fullProvince.findIndex((item: any) => item.label === provinceDesc)
                                ]
                              }
                              onChange={(e: any) => {
                                setFullCity([])
                                cityData(e?.value)
                              }}
                              options={fullProvince}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-jenis')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='jenis'
                              onChange={(e: any) => productTypeChange(e.target.value)}
                            >
                              <option hidden value='~#~'>
                                {t('Pilih-productType')}
                              </option>
                              {fullProductType.map((item: any) => {
                                return (
                                  <>
                                    {item.id != 12 && (
                                      <>
                                        {item.material_group_desc == tempData?.product_type_desc ? (
                                          <option
                                            selected
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        ) : (
                                          <option
                                            value={
                                              item.material_group_desc + '~#~' + item.material_group
                                            }
                                          >
                                            {t(item.material_group_desc)}
                                          </option>
                                        )}
                                      </>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        {parseInt(pnumber) == 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>
                                Custom Product Name<span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                placeholder=' Custom Product Name'
                                size='sm'
                                defaultValue={pname}
                                aria-label='Default select example'
                                type='text'
                                id='custom'
                                onChange={(e: any) => setPname(e.target.value)}
                              />
                            </Col>
                          </Row>
                        )}
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('Kuantum Pengajuan')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <CurrencyInput
                                className='form-control form-control-sm'
                                id='kuantum'
                                // key={pname}
                                placeholder={t('Kuantum Pengajuan')}
                                defaultValue={quantum}
                                decimalSeparator={language === 'en' ? '.' : ','}
                                groupSeparator={language === 'en' ? ',' : '.'}
                                onValueChange={(value: any) => {
                                  setQuantum(value?.replace(/,/g, '.'))
                                  // console.log(value)
                                }}
                                decimalsLimit={3}
                              />
                              <InputGroup.Text id='basic-addon2'>Ton</InputGroup.Text>
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('Shipping Tolerance')}</p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <Form.Control
                                placeholder={t('Shipping Tolerance')}
                                type='number'
                                id='shipping'
                                defaultValue={shipping}
                                onChange={(e: any) => setShipping(parseFloat(e.target.value))}
                              />
                              <InputGroup.Text id='basic-addon2'>
                                <span className='px-2'>%</span>
                              </InputGroup.Text>
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-payment1')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='payment1'
                              onChange={(e: any) => separateValue(setPay1, e.target.value, setPay1Desc)}
                            >
                              <option hidden value='~#~'>
                                {t('Pilih-payment')}
                              </option>
                              {fullPayment.map((item: any) => {
                                return (
                                  <>
                                    {item.code == tempData?.payment_type_1 ? (
                                      <option
                                        selected
                                        value={item.code + '~#~' + item.payment_desc_id}
                                      >
                                        {item.payment_desc_id}
                                      </option>
                                    ) : (
                                      <option value={item.code + '~#~' + item.payment_desc_id}>
                                        {item.payment_desc_id}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('keterangan')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              as='textarea'
                              defaultValue={tempData?.payment_note}
                              placeholder={t('keterangan')}
                              id='keterangan'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => setketerangan(e.target.value)}
                            />
                          </Col>
                        </Row>
                        {parseInt(pnumber) != 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>
                                {t('segment')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={8}>
                              <Form.Select
                                size='sm'
                                id='segment'
                                onChange={(e: any) =>
                                  separateValue(setSegment, e.target.value, setSegmentDesc)
                                }
                                aria-label='Default select example'
                              >
                                {fullSegment.map((item: any) => {
                                  if (item.code == 'Z2' || item.code == 'Z3') {
                                    if (item.code == segment) {
                                      return (
                                        <option selected value={item.code + '~#~' + item.name}>
                                          {item.name}
                                        </option>
                                      )
                                    } else {
                                      return (
                                        <option value={item.code + '~#~' + item.name}>
                                          {item.name}
                                        </option>
                                      )
                                    }
                                  } else {
                                    return null
                                  }
                                })}
                              </Form.Select>
                            </Col>
                          </Row>
                        )}
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('End Customer')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            {isNoEnduser ? (
                              <Form.Control
                                size='sm'
                                as='textarea'
                                id='enduser'
                                defaultValue={tempData.end_user_multiple ? '' : tempData.end_user}
                                placeholder={t('End Customer')}
                                onChange={(e: any) => {
                                  setEnduser(e.target.value)
                                  setEnduserDesc(e.target.value)
                                }}
                              />
                            ) : (
                              <MultiSelect
                                options={fullEndUser?.map((item: any) => {
                                  return {label: item.name, value: item.name}
                                })}
                                value={arrayEnduser}
                                onChange={(e: any) => setEnduserArray(e)}
                                labelledBy='Select'
                              />
                            )}
                          </Col>
                        </Row>
                        {idSektor == 1 && parseInt(pnumber) != 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}></Col>
                            <Col sm={8} className='d-flex'>
                              <Form.Check
                                onClick={() => setIsNoEnduser(!isNoEnduser)}
                                defaultChecked={isNoEnduser}
                                // disabled={ptype == 'P13'}
                                id='noenduser'
                                className='mb-2'
                                type='checkbox'
                              />
                              {i18next.language == 'en' ? (
                                <p className='ms-2 fs-6'>{t('TidakAdaEndUser')}</p>
                              ) : (
                                <p className='ms-2 fs-6'>{t('TidakAdaEndUser')}</p>
                              )}
                            </Col>
                          </Row>
                        )}
                      </Col>
                      <Col md={6}>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-sektor')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              size='sm'
                              aria-label='Default select example'
                              id='sektor'
                              disabled
                              value={t('Domestik Korperasi')}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='incoterm2'
                              key={idSektor + produsen}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullIncoterm2[
                                  fullIncoterm2.findIndex(
                                    (item: any) => item.label === incoterm2Desc
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                separateValue2(setIncoterm2, e.value, setIncoterm2Desc)
                              }}
                              options={fullIncoterm2}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>
                              {t('sub-order-kota')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='kota'
                              key={province}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullCity[fullCity.findIndex((item: any) => item.label === cityDesc)]
                              }
                              onChange={(e: any) => {
                                separateValue2(setCity, e?.value, setCityDesc)
                                // fieldClearer(4)
                              }}
                              options={fullCity}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='mt-3'>
                              {t('sub-order-produk')}
                              <span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <Select
                              id='produk'
                              key={ptype}
                              placeholder={t('pilih')}
                              defaultValue={
                                fullProductName[
                                  fullProductName.findIndex(
                                    (item: any) => item.truevalue == parseInt(pnumber)
                                  )
                                ]
                              }
                              onChange={(e: any) => {
                                productNameChange(e?.value)
                              }}
                              options={fullProductName}
                            />
                          </Col>
                        </Row>
                        {pnumber == '0' && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('sub-order-catatan')}
                                defaultValue={tempData?.notes}
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                                onChange={(e: any) => setNote(e.target.value)}
                              />
                            </Col>
                          </Row>
                        )}
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='mt-3 fs-6'>
                              {t('Harga Pengajuan')}/Ton<span className='text-danger'>*</span>
                            </p>
                          </Col>
                          <Col sm={8}>
                            <InputGroup size='sm'>
                              <InputGroup.Text>
                                <span className='px-1'>Rp</span>
                              </InputGroup.Text>
                              {isFormulatedPrice ? (
                                <CurrencyInput
                                  className='form-control form-control-sm'
                                  id='hargap'
                                  disabled
                                  defaultValue={0}
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  decimalsLimit={-1}
                                />
                              ) : (
                                <CurrencyInput
                                  className='form-control form-control-sm'
                                  id='hargap'
                                  // key={pname}
                                  defaultValue={subprice}
                                  decimalSeparator={language === 'en' ? '.' : ','}
                                  groupSeparator={language === 'en' ? ',' : '.'}
                                  onValueChange={(value: any) => {
                                    setSubprice(value?.replace(/,/g, '.'))
                                  }}
                                  decimalsLimit={-1}
                                  placeholder={t('Harga Pengajuan')}
                                />
                              )}
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='my-7'>
                          <Col sm={6} className='d-flex '>
                            <Row sm={8} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('termasuk-ppn')}</p>
                            </Row>
                            <Row
                              sm={4}
                              className='d-flex justify-content-start align-items-center ms-4'
                            >
                              <Form.Check
                                reverse
                                name='ppn'
                                type='checkbox'
                                id='ckbox-ppn'
                                defaultChecked={tempData?.include_ppn}
                              />
                            </Row>
                          </Col>
                          <Col sm={6} className='d-flex'>
                            <Row sm={8} className='d-flex align-items-center'>
                              <p className=' fs-6'>{t('Formulated Price')}</p>
                            </Row>
                            <Row
                              sm={4}
                              className='d-flex justify-content-start align-items-center ms-4'
                            >
                              <Form.Check
                                reverse
                                name='formula_Price'
                                type='checkbox'
                                onClick={() => setIsFormulatedPrice(!isFormulatedPrice)}
                                defaultChecked={tempData.is_formulated_price}
                                id='formula_Price'
                              />
                            </Row>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Select
                              size='sm'
                              aria-label='Default select example'
                              id='payment2'
                              onChange={(e: any) => separateValue(setPay2, e.target.value, setPay2Desc)}
                            >
                              <option value='~#~'>{t('Pilih-payment')}</option>
                              {fullPayment.map((item: any) => {
                                return (
                                  <>
                                    {item.code == tempData?.payment_type_2 ? (
                                      <option
                                        selected
                                        value={item.code + '~#~' + item.payment_desc_id}
                                      >
                                        {item.payment_desc_id}
                                      </option>
                                    ) : (
                                      <option value={item.code + '~#~' + item.payment_desc_id}>
                                        {item.payment_desc_id}
                                      </option>
                                    )}
                                  </>
                                )
                              })}
                            </Form.Select>
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col sm={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col sm={8}>
                            <Form.Control
                              placeholder={t('sub-order-spek')}
                              as='textarea'
                              defaultValue={tempData?.product_spec}
                              id='spek'
                              size='sm'
                              style={{height: '40px'}}
                              onChange={(e: any) => setPspec(e.target.value)}
                            />
                          </Col>
                        </Row>
                        {parseInt(pnumber) != 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('sub-order-catatan')}
                                defaultValue={tempData?.notes}
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                                onChange={(e: any) => setNote(e.target.value)}
                              />
                            </Col>
                          </Row>
                        )}
                        {idSektor == 1 && pnumber == '0' && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              {i18next.language == 'en' ? (
                                <p className='fs-6 mt-4'>{t('TidakAdaEndUser')}</p>
                              ) : (
                                <p className='fs-6'>{t('TidakAdaEndUser')}</p>
                              )}
                            </Col>
                            <Col sm={8}>
                              <Form.Check
                                onClick={() => setIsNoEnduser(!isNoEnduser)}
                                defaultChecked={isNoEnduser}
                                // disabled={ptype == 'P13'}
                                name='ppn'
                                className='mt-5 mb-2'
                                id='noenduser'
                                type='checkbox'
                              />
                            </Col>
                          </Row>
                        )}
                        {parseInt(pnumber) == 0 && (
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>
                                {t('segment')}
                                <span className='text-danger'>*</span>
                              </p>
                            </Col>
                            <Col sm={8}>
                              <Form.Select
                                size='sm'
                                id='segment'
                                onChange={(e: any) =>
                                  separateValue(setSegment, e.target.value, setSegmentDesc)
                                }
                                aria-label='Default select example'
                              >
                                {fullSegment.map((item: any) => {
                                  if (item.code == 'Z2' || item.code == 'Z3') {
                                    if (item.code == segment) {
                                      return (
                                        <option selected value={item.code + '~#~' + item.name}>
                                          {item.name}
                                        </option>
                                      )
                                    } else {
                                      return (
                                        <option value={item.code + '~#~' + item.name}>
                                          {item.name}
                                        </option>
                                      )
                                    }
                                  } else {
                                    return null
                                  }
                                })}
                              </Form.Select>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </>
                )}

                <div className='d-flex justify-content-end mt-5'>
                  <Button variant='primary' onClick={() => editNewOrder()} disabled={btnLoading}>
                    {btnLoading ? (
                      <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                      <>
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr075.svg'
                          className='svg-icon-3'
                        />
                        {t('order-kirim')}
                      </>
                    )}
                  </Button>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>

        {/* modal jadwal local */}
        <Modal
          show={show8}
          onHide={() => {
            handleClose8()
            sessionStorage.removeItem('isCustomer')
          }}
          centered
          size='xl'
          backdrop='static'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {sektor != '3' ? provinceDesc + ', ' + cityDesc + ' | ' : ''}
              {pname} | {fixedQuantum2} Ton
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='mt-2'>
              <span style={{fontSize: '15px'}} className='fw-bold d-block'>
                {t('Jadwal')}
              </span>
              <div
                className='table-responsive bdr mt-2'
                hidden={tempJadwal2?.length < 1 || tempJadwal2?.length == undefined ? true : false}
              >
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='border-bottom'>
                    <tr className='fw-bold '>
                      <th className='text-center'>{t('order-pengambilan')}</th>
                      <th className='text-center'>{t('order-minggu')}</th>
                      <th className='text-center'>{t('order-tanggal')}</th>
                      <th className='text-center'>{t('order-bulan')}</th>
                      <th className='text-center'>{t('order-tahun')}</th>
                      <th className='text-center'>{t('order-tonase')}</th>
                    </tr>
                  </thead>
                  {tempJadwal2?.map((data: any, _index: number) => (
                    <tbody key={data?.id ?? _index}>
                      <tr className=''>
                        <td className='text-center'>
                          <label>{_index + 1}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.date}</label>
                        </td>
                        <td className='text-center'>
                          <label>
                            {t('Week')} {Math.ceil(data.date / 7)}
                          </label>
                        </td>
                        <td className='text-center'>
                          <label>{t(bulan[data.month - 1])}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.year}</label>
                        </td>
                        <td className='text-center'>
                          <label>
                            {(i18next.language === 'en'
                              ? data.tonnage.toLocaleString('en')
                              : data.tonnage.toLocaleString('id')) +
                              ' ' +
                              'Ton'}
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* modal jadwal local */}
        <Modal
          show={showJadwal}
          onHide={() => {
            setShowJadwal(false)
            setTempTanggal(0)
            setTempJadwal([])
          }}
          centered
          size='xl'
          backdrop='static'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {sektor != '3' ? provinceDesc + ', ' + cityDesc + ' | ' : ''}
              {pname} | {fixedQuantum2} Ton
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12}>
                <span style={{fontSize: '15px'}} className='fw-bold d-block mt-3'>
                  {t('Jadwal')}
                </span>
                <div className='table-responsive bdr mt-3'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='border-bottom'>
                      <tr className='fw-bold d-flex'>
                        <th className='text-center' style={{width: '165.5px'}}>
                          {t('order-pengambilan')}
                        </th>
                        <th className='text-center' style={{width: '185.5px'}}>
                          {t('order-tanggal')}
                        </th>
                        <th className='text-center' style={{width: '185.5px'}}>
                          {t('order-minggu')}
                        </th>
                        <th className='text-center' style={{width: '185.5px'}}>
                          {t('order-bulan')}
                        </th>
                        <th className='text-center' style={{width: '185.5px'}}>
                          {t('order-tahun')}
                        </th>
                        <th className='text-center' style={{width: '185.5px'}}>
                          {t('order-tonase')}
                        </th>
                      </tr>
                    </thead>
                    {tempJadwal?.map((data: any, index: any) => (
                      <tbody key={data?.date ?? index}>
                        <tr className='d-flex'>
                          <td className='text-center' style={{width: '165.5px'}}>
                            <label className='mt-3'>{index + 1}</label>
                          </td>
                          <td className='text-center' style={{width: '185.5px'}}>
                            <label className='mt-3'>{data.date}</label>
                          </td>
                          <td className='text-center' style={{width: '185.5px'}}>
                            <label className='mt-3'>
                              {t('Week')}
                              {Math.ceil(data.date / 7)}
                            </label>
                          </td>
                          <td className='text-center' style={{width: '185.5px'}}>
                            <label className='mt-3'>{t(bulan[data.month - 1])}</label>
                          </td>
                          <td className='text-center' style={{width: '185.5px'}}>
                            <label className='mt-3'>{data.year}</label>
                          </td>
                          <td className='text-center' style={{width: '185.5px'}}>
                            <label className='mt-3'>
                              {(i18next.language === 'en'
                                ? data.tonnage.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : data.tonnage.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })) +
                                ' ' +
                                'Ton'}
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        {/* modal attachmment header */}
        <Modal
          size='lg'
          show={showHeader}
          onHide={() => {
            setShowHeader(false)
            setIsFileBox({})
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isFileBox?.product_name
                ? (isFileBox.province ? isFileBox.province?.region_name : '') +
                  (isFileBox.city ? ', ' + isFileBox.city?.city_name : '') +
                  (isFileBox.province ? ' | ' : '') +
                  isFileBox.product_name +
                  (isFileBox.request_quantum ? ' | ' + isFileBox.request_quantum + ' Ton' : '')
                : t('File Box')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <>
                <div>
                  <Row>
                    <Col sm={6}>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-fileUnggah')}</h6>
                          </td>
                          <td className='w-75'>
                            <InputFile
                                setFileName={setNamaFile}
                                setFiles={setFiles}
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('order-keterangan')}</h6>
                          </td>
                          <td className='w-75'>
                            <Form.Control
                              type='text'
                              disabled={loadingUpload}
                              id='uploadketerangan'
                              placeholder={t('order-keterangan')}
                              onChange={(e: any) => setDescription(e.target.value)}
                            />
                          </td>
                        </tr>
                      </table>
                      <table
                        className='mb-3'
                        hidden={roleUser == 'null' || roleUser == null ? true : false}
                      >
                        <tr>
                          <td>
                            <h6 className='me-11'>{t('Private')}</h6>
                          </td>
                          <td className='w-75 d-flex justify-content-start'>
                            <Form.Check
                              reverse
                              name='isPrivate'
                              disabled={loadingUpload}
                              type='checkbox'
                              className='mt-5 mb-2'
                              onClick={() => {
                                setIsPrivate(!isPrivate)
                                setTempRole([])
                              }}
                              id='isPrivate'
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3' hidden={isPrivate ? false : true}>
                        <tr>
                          <td style={{width: '120px'}}>
                            <h6>{t('Akses Role')}</h6>
                          </td>
                          <td className='w-75' style={{maxWidth: '274px'}}>
                            <MultiSelect
                              key={files}
                              options={fullRole?.map((item: any) => {
                                return {label: item.label, value: item.value}
                              })}
                              disabled={loadingUpload}
                              value={tempRole}
                              onChange={(e: any) => setTempRole(e)}
                              labelledBy='Select'
                            />
                          </td>
                        </tr>
                      </table>
                      <div className='d-flex justify-content-end'>
                        <Button
                          variant='primary'
                          className='w-100'
                          disabled={loadingUpload}
                          onClick={() => handleUploadHeader()}
                        >
                          {loadingUpload ? '...' : t('order-kirim')}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead className='fw-bold border-bottom'>
                        <tr className=''>
                          <th className='text-center'>{t('order-noo')}</th>
                          <th className='text-center'>{t('order-keterangan')}</th>
                          <th className='text-center'>{t('order-tglUpload')}</th>
                          {/* <th className='text-center'>{t('User Code')}</th> */}
                          <th className='text-center'>{t('order-user')}</th>
                          <th className='text-center'>{t('Akses Role')}</th>
                          <th className='text-center'>{t('order-aksi')}</th>
                        </tr>
                      </thead>
                      {stateFileHeader
                        .slice(0)
                        .reverse()
                        .map((data: any, _index: number) => (
                          <tbody key={data?.datenow ?? _index}>
                            <tr className=''>
                              <td className='text-center'>
                                <label>{_index + 1}</label>
                              </td>
                              <td className='text-center'>
                                <label>{data.description}</label>
                              </td>
                              <td className='text-center'>
                                <label>{dateformat(getCurrentFormattedDate())}</label>
                              </td>
                              {/* <td className='text-center'>
                                <label>
                                  {localStorage.getItem('cust-code') !== 'null'
                                    ? localStorage.getItem('cust-code')
                                    : localStorage.getItem('user_code')}
                                </label>
                              </td> */}
                              <td className='text-center'>
                                <label>{localStorage.getItem('username')}</label>
                              </td>
                              <td className='text-center'>
                                {data.private ? (
                                  data.roles?.length > 0 ? (
                                    <PopoverText
                                      content={handleShowRoleNameFromState(data.roles)}
                                      index={_index}
                                      className='desc-slice'
                                    />
                                  ) : (
                                    'Private'
                                  )
                                ) : (
                                  'Public'
                                )}
                              </td>
                              <td className='text-center'>
                                { !data.is_new && <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('unduh')}
                                  onClick={() => download_file(data.file_r, data.name)}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/arrow-down-square-fill.svg'
                                    className='svg-icon-3'
                                  />
                              </button> }

                                {(data.is_new || hakAkses?.attachment_delete) && (
                                  <button
                                    onClick={() =>
                                      handleDeleteUploadHeader(
                                        stateFileHeader.length - 1 - _index,
                                        stateFileHeader,
                                        setStateFileHeader,
                                        'header'
                                      )
                                    }
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('Hapus')}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/trash-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        ))}
                      {fullHeader.map((data: any, _index: number) => (
                        <tbody key={data?.id ?? _index}>
                          <tr className=''>
                            <td className='text-center'>
                              <label>{stateFileHeader.length + _index + 1}</label>
                            </td>
                            <td className='text-center'>
                              <label>{data.description}</label>
                            </td>
                            <td className='text-center'>
                              <label>{dateformat(data.updated_at)}</label>
                            </td>
                            {/* <td className='text-center'>
                              <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                            </td> */}
                            <td className='text-center'>
                              {data.user?.customer_code == null ? (
                                <label>{data.user?.name}</label>
                              ) : (
                                <label>{data.user?.customer?.name}</label>
                              )}
                            </td>
                            <td className='text-center'>
                              {data.private ? (
                                data.roles?.length > 0 ? (
                                  <PopoverText
                                    content={handleShowRoleName(data.roles)}
                                    index={_index}
                                    className='desc-slice'
                                  />
                                ) : (
                                  'Private'
                                )
                              ) : (
                                'Public'
                              )}
                            </td>
                            <td className='text-center'>
                              <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('unduh')}
                                onClick={() =>
                                  window.open(
                                    data.file_path + `&token=${localStorage.getItem('token')}`
                                  )
                                }
                              >
                                <KTSVG
                                  path='/media/icons/duotune/arrow-down-square-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    </table>
                  </div>
                </div>
              </>
          </Modal.Body>
        </Modal>

        {/* modal revisi note */}
        <Modal
          show={showRevisionNote}
          onHide={() => setShowRevisionNote(false)}
          centered
          backdrop='static'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Revision Reason')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
              <Form.Control
                as='textarea'
                placeholder={t('Tinggal-pesan')}
                style={{height: '100px'}}
                onChange={(e: any) => setRevisionNote(e.target.value)}
              />
            </FloatingLabel>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={() => setShowRevisionNote(false)}>
              {t('cancel')}
            </Button>
            <Button variant='warning' onClick={() => sendReviseAmandemen()} disabled={btnLoading}>
              {btnLoadingRef ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('order-revisi2')
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* modal reject note */}
        <Modal
          show={showRejectNote}
          onHide={() => setShowRejectNote(false)}
          centered
          backdrop='static'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Revision Reason')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
              <Form.Control
                as='textarea'
                placeholder={t('Tinggal-pesan')}
                style={{height: '100px'}}
                onChange={(e: any) => setRejectNote(e.target.value)}
              />
            </FloatingLabel>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={() => setShowRejectNote(false)}>
              {t('cancel')}
            </Button>
            <Button variant='warning' onClick={() => amandementReject()} disabled={btnLoading}>
              {btnLoadingRef ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('order-revisi2')
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* modal comment */}
        <Modal
          show={showComment}
          onHide={() => setShowComment(false)}
          centered
          backdrop='static'
          size='lg'
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Comment')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <FloatingLabel controlId='floatingTextarea2' label={t('Chat')}>
                <Form.Control
                  as='textarea'
                  id='areachat'
                  placeholder={t('Tinggal-pesan')}
                  style={{height: '100px'}}
                  onChange={(e: any) => setTempChat(e.target.value)}
              />
              </FloatingLabel>
              <div className='d-flex justify-content-end'>
                <Button variant='primary' className='mt-3 mb-3' onClick={() => handlePostChat()}>
                  {t('Tambah')}
                </Button>
              </div>
            </div>

            {fullComment?.length < 1 ? (
              <div>{t('No Comment')}</div>
            ) : (
              <div className='table-responsive mt-10 bdr'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold w-100 align-items-center'>
                      <th className='td-3 text-center'>{t('no')}</th>
                      <th className='td-3 text-center'>{t('order-tanggal')}</th>
                      <th className='td-3 text-center'>{t('order-user')}</th>
                      {/* <th className='td-3 text-center'>Status</th> */}
                      <th className='td-3 text-center'>{t('Comment')}</th>
                    </tr>
                  </thead>
                  {fullComment?.map((item: any, _index: number) => (
                    <tbody key={item?.type ?? _index}>
                      <tr className='w-100 align-items-center'>
                        <td className='td-150 text-center'>{_index + 1}</td>
                        <td className='td-150 text-center'>{item.created_at?.slice(0, 10)}</td>
                        <td className='td-150 text-center'>{item.user?.name}</td>
                        {/* <td className='td-150 text-center'>
                          {item.type == 1
                            ? t('order-revisi')
                            : item.type == 2
                            ? t('order-tolak')
                            : item.type == 10
                            ? t('revisi amandemen')
                            : item.type == 11
                            ? t('reject amandemen')
                            : ''}
                        </td> */}
                        <td className='td-60 text-center text-truncate'>
                          <PopoverText
                            content={item.comment}
                            index={_index}
                            className='desc-slicee'
                          />
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
                {/* End Table Head */}
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* modal customer profile */}
        <Modal
          size='xl'
          show={showCustPro}
          onHide={() => {
            setShowCustPro(false)
            setTotalInvoices([0, 0, 0, 0])
            setInvoices([
              {
                B000: 0,
                C000: 0,
                D000: 0,
                E000: 0,
                F000: 0,
              },
              {
                B000: 0,
                C000: 0,
                D000: 0,
                E000: 0,
                F000: 0,
              },
              {
                B000: 0,
                C000: 0,
                D000: 0,
                E000: 0,
                F000: 0,
              },
              {
                B000: 0,
                C000: 0,
                D000: 0,
                E000: 0,
                F000: 0,
              },
            ])
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Customer Support Data')}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{backgroundColor: '#e9e9f4'}}>
            <Row className='mb-5'>
              <Col sm={6}>
                <div className='card pe-1'>
                  <div className='card-body'>
                    <div className='d-flex align-items-center'>
                      <img alt='money' src={toAbsoluteUrl(`/media/money 1.png`)} />
                      <h6 className='ms-3' style={{color: '#274070'}}>
                        Outstanding Invoice
                      </h6>
                    </div>
                    <hr />
                    <div className='d-flex justify-content-between'>
                      <p>{'<'}31 Days</p>
                      <p>{totalInvoices[0]}</p>
                    </div>
                    <div className='d-flex justify-content-between bg-secondary'>
                      <p>31-90 Days</p>
                      <p>{totalInvoices[1]}</p>
                    </div>
                    <div className='d-flex justify-content-between'>
                      <p>91-365 Days</p>
                      <p>{totalInvoices[2]}</p>
                    </div>
                    <div className='d-flex justify-content-between bg-secondary'>
                      <p>{'>'}365 Days</p>
                      <p>{totalInvoices[3]}</p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col sm={6}>
                <div className='card ps-1 '>
                  <div className='card-body'>
                    <div className='d-flex align-items-center'>
                      <img alt='search' src={toAbsoluteUrl(`/media/search 1.png`)} />
                      <h6 className='ms-3' style={{color: '#274070'}}>
                        Status
                      </h6>
                    </div>
                    <hr />
                    <div className='d-flex justify-content-center align-items-center'>
                      <div
                        className='rounded-circle'
                        style={{
                          width: '80px',
                          height: '80px',
                          backgroundColor: colorList[custStatus.status],
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className='card'>
              <div className='card-body'>
                <Row>
                  <Col sm={6}>
                    <div className='d-flex align-items-center mb-3'>
                      <img alt='search' src={toAbsoluteUrl(`/media/search 1.png`)} />
                      <h6 className='ms-3' style={{color: '#274070'}}>
                        Data Detail
                      </h6>
                    </div>
                    <div className='card' style={{backgroundColor: '#F4FAFA'}}>
                      <div className='card-body'>
                        <h6 className='mb-4' style={{color: '#274070'}}>
                          Customer Name:{' '}
                          <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>
                            {custStatus.customer_address}
                          </span>
                        </h6>
                        <h6 style={{color: '#274070'}}>
                          Alamat:{' '}
                          <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>
                            {customerAddress}
                          </span>
                        </h6>
                        <h6 style={{color: '#274070'}}>
                          Provinsi: <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>-</span>
                        </h6>
                        <h6 className='mb-10' style={{color: '#274070'}}>
                          Kota/Kab: <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>-</span>
                        </h6>
                        <h6 style={{color: '#274070'}}>Customer Number</h6>
                        <div className='w-50' style={{backgroundColor: 'white'}}>
                          <div className='d-flex justify-content-between align-items-center px-2 border-top border-bottom'>
                            <p>{customerCode}</p>
                            <div
                              className='rounded-circle'
                              style={{
                                width: '12px',
                                height: '12px',
                                backgroundColor:
                                  colorList[custStatus.status ? custStatus.status : 'Yellow'],
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm={6}>
                    <Row className='mb-5'>
                      <Col sm={6} className='pe-2'>
                        <h4 className='mb-2'>Invoices {'>'} 365 Days</h4>
                        <h5 className='mb-2' style={{color: '#274070'}}>
                          Company Code
                        </h5>
                        <hr style={{margin: '0'}} />
                        <div className='d-flex justify-content-between'>
                          <p>B000</p>
                          <p>{invoices[3].B000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>C000</p>
                          <p>{invoices[3].C000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>D000</p>
                          <p>{invoices[3].D000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>E000</p>
                          <p>{invoices[3].E000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>F000</p>
                          <p>{invoices[3].F000}</p>
                        </div>
                        <hr style={{margin: '0'}} />
                      </Col>
                      <Col sm={6} className='ps-2'>
                        <h4 className='mb-2' style={{color: '#F0C94A'}}>
                          Invoices 31-90 Days
                        </h4>
                        <h5 className='mb-2' style={{color: '#274070'}}>
                          Company Code
                        </h5>
                        <hr style={{margin: '0'}} />
                        <div className='d-flex justify-content-between'>
                          <p>B000</p>
                          <p>{invoices[1].B000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>C000</p>
                          <p>{invoices[1].C000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>D000</p>
                          <p>{invoices[1].D000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>E000</p>
                          <p>{invoices[1].E000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>F000</p>
                          <p>{invoices[1].F000}</p>
                        </div>
                        <hr style={{margin: '0'}} />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6} className='pe-2'>
                        <h4 className='mb-2 text-danger'>Invoices 91-365 Days</h4>
                        <h5 className='mb-2' style={{color: '#274070'}}>
                          Company Code
                        </h5>
                        <hr style={{margin: '0'}} />
                        <div className='d-flex justify-content-between'>
                          <p>B000</p>
                          <p>{invoices[2].B000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>C000</p>
                          <p>{invoices[2].C000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>D000</p>
                          <p>{invoices[2].D000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>E000</p>
                          <p>{invoices[2].E000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>F000</p>
                          <p>{invoices[2].F000}</p>
                        </div>
                        <hr style={{margin: '0'}} />
                      </Col>
                      <Col sm={6} className='ps-2'>
                        <h4 className='mb-2' style={{color: '#48CE86'}}>
                          Invoices {'<'}30 Days
                        </h4>
                        <h5 className='mb-2' style={{color: '#274070'}}>
                          Company Code
                        </h5>
                        <hr style={{margin: '0'}} />
                        <div className='d-flex justify-content-between'>
                          <p>B000</p>
                          <p>{invoices[0].B000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>C000</p>
                          <p>{invoices[0].C000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>D000</p>
                          <p>{invoices[0].D000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>E000</p>
                          <p>{invoices[0].E000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>F000</p>
                          <p>{invoices[0].F000}</p>
                        </div>
                        <hr style={{margin: '0'}} />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  )
}

export {OrderAmandemen}
